/* eslint-disable */
export const region1Barangays = [
    {
        CITY: 'ADAMS',
        BARANGAY: 'ADAMS (POB.)',
    },
    {
        CITY: 'BACARRA',
        BARANGAY: 'BANI',
    },
    {
        CITY: 'BACARRA',
        BARANGAY: 'BUYON',
    },
    {
        CITY: 'BACARRA',
        BARANGAY: 'CABARUAN',
    },
    {
        CITY: 'BACARRA',
        BARANGAY: 'CABULALAAN',
    },
    {
        CITY: 'BACARRA',
        BARANGAY: 'CABUSLIGAN',
    },
    {
        CITY: 'BACARRA',
        BARANGAY: 'CADARATAN',
    },
    {
        CITY: 'BACARRA',
        BARANGAY: 'CALIOET-LIBONG',
    },
    {
        CITY: 'BACARRA',
        BARANGAY: 'CASILIAN',
    },
    {
        CITY: 'BACARRA',
        BARANGAY: 'COROCOR',
    },
    {
        CITY: 'BACARRA',
        BARANGAY: 'DURIPES',
    },
    {
        CITY: 'BACARRA',
        BARANGAY: 'GANAGAN',
    },
    {
        CITY: 'BACARRA',
        BARANGAY: 'LIBTONG',
    },
    {
        CITY: 'BACARRA',
        BARANGAY: 'MACUPIT',
    },
    {
        CITY: 'BACARRA',
        BARANGAY: 'NAMBARAN',
    },
    {
        CITY: 'BACARRA',
        BARANGAY: 'NATBA',
    },
    {
        CITY: 'BACARRA',
        BARANGAY: 'PANINAAN',
    },
    {
        CITY: 'BACARRA',
        BARANGAY: 'PASIOCAN',
    },
    {
        CITY: 'BACARRA',
        BARANGAY: 'PASNGAL',
    },
    {
        CITY: 'BACARRA',
        BARANGAY: 'PIPIAS',
    },
    {
        CITY: 'BACARRA',
        BARANGAY: 'PULANGI',
    },
    {
        CITY: 'BACARRA',
        BARANGAY: 'PUNGTO',
    },
    {
        CITY: 'BACARRA',
        BARANGAY: 'SAN AGUSTIN I (POB.)',
    },
    {
        CITY: 'BACARRA',
        BARANGAY: 'SAN AGUSTIN II (POB.)',
    },
    {
        CITY: 'BACARRA',
        BARANGAY: 'SAN ANDRES I (POB.)',
    },
    {
        CITY: 'BACARRA',
        BARANGAY: 'SAN ANDRES II (POB.)',
    },
    {
        CITY: 'BACARRA',
        BARANGAY: 'SAN GABRIEL I (POB.)',
    },
    {
        CITY: 'BACARRA',
        BARANGAY: 'SAN GABRIEL II (POB.)',
    },
    {
        CITY: 'BACARRA',
        BARANGAY: 'SAN PEDRO I (POB.)',
    },
    {
        CITY: 'BACARRA',
        BARANGAY: 'SAN PEDRO II (POB.)',
    },
    {
        CITY: 'BACARRA',
        BARANGAY: 'SAN ROQUE I (POB.)',
    },
    {
        CITY: 'BACARRA',
        BARANGAY: 'SAN ROQUE II (POB.)',
    },
    {
        CITY: 'BACARRA',
        BARANGAY: 'SAN SIMON I (POB.)',
    },
    {
        CITY: 'BACARRA',
        BARANGAY: 'SAN SIMON II (POB.)',
    },
    {
        CITY: 'BACARRA',
        BARANGAY: 'SAN VICENTE (POB.)',
    },
    {
        CITY: 'BACARRA',
        BARANGAY: 'SANGIL',
    },
    {
        CITY: 'BACARRA',
        BARANGAY: 'SANTA FILOMENA I (POB.)',
    },
    {
        CITY: 'BACARRA',
        BARANGAY: 'SANTA FILOMENA II (POB.)',
    },
    {
        CITY: 'BACARRA',
        BARANGAY: 'SANTA RITA (POB.)',
    },
    {
        CITY: 'BACARRA',
        BARANGAY: 'SANTO CRISTO I (POB.)',
    },
    {
        CITY: 'BACARRA',
        BARANGAY: 'SANTO CRISTO II (POB.)',
    },
    {
        CITY: 'BACARRA',
        BARANGAY: 'TAMBIDAO',
    },
    {
        CITY: 'BACARRA',
        BARANGAY: 'TEPPANG',
    },
    {
        CITY: 'BACARRA',
        BARANGAY: 'TUBBURAN',
    },
    {
        CITY: 'BADOC',
        BARANGAY: 'ALAY-NANGBABAAN (ALAY 15-B)',
    },
    {
        CITY: 'BADOC',
        BARANGAY: 'ALOGOOG',
    },
    {
        CITY: 'BADOC',
        BARANGAY: 'AR-ARUSIP',
    },
    {
        CITY: 'BADOC',
        BARANGAY: 'ARING',
    },
    {
        CITY: 'BADOC',
        BARANGAY: 'BALBALDEZ',
    },
    {
        CITY: 'BADOC',
        BARANGAY: 'BATO',
    },
    {
        CITY: 'BADOC',
        BARANGAY: 'CAMANGA',
    },
    {
        CITY: 'BADOC',
        BARANGAY: 'CANAAN (POB.)',
    },
    {
        CITY: 'BADOC',
        BARANGAY: 'CARAITAN',
    },
    {
        CITY: 'BADOC',
        BARANGAY: 'GABUT NORTE',
    },
    {
        CITY: 'BADOC',
        BARANGAY: 'GABUT SUR',
    },
    {
        CITY: 'BADOC',
        BARANGAY: 'GARRETA (POB.)',
    },
    {
        CITY: 'BADOC',
        BARANGAY: 'LA VIRGEN MILAGROSA (PAGUETPET)',
    },
    {
        CITY: 'BADOC',
        BARANGAY: 'LABUT',
    },
    {
        CITY: 'BADOC',
        BARANGAY: 'LACUBEN',
    },
    {
        CITY: 'BADOC',
        BARANGAY: 'LUBIGAN',
    },
    {
        CITY: 'BADOC',
        BARANGAY: 'MABUSAG NORTE',
    },
    {
        CITY: 'BADOC',
        BARANGAY: 'MABUSAG SUR',
    },
    {
        CITY: 'BADOC',
        BARANGAY: 'MADUPAYAS',
    },
    {
        CITY: 'BADOC',
        BARANGAY: 'MORONG',
    },
    {
        CITY: 'BADOC',
        BARANGAY: 'NAGREBCAN',
    },
    {
        CITY: 'BADOC',
        BARANGAY: 'NAPU',
    },
    {
        CITY: 'BADOC',
        BARANGAY: 'PAGSANAHAN NORTE',
    },
    {
        CITY: 'BADOC',
        BARANGAY: 'PAGSANAHAN SUR',
    },
    {
        CITY: 'BADOC',
        BARANGAY: 'PALTIT',
    },
    {
        CITY: 'BADOC',
        BARANGAY: 'PARANG',
    },
    {
        CITY: 'BADOC',
        BARANGAY: 'PASUC',
    },
    {
        CITY: 'BADOC',
        BARANGAY: 'SANTA CRUZ NORTE',
    },
    {
        CITY: 'BADOC',
        BARANGAY: 'SANTA CRUZ SUR',
    },
    {
        CITY: 'BADOC',
        BARANGAY: 'SAUD',
    },
    {
        CITY: 'BADOC',
        BARANGAY: 'TUROD',
    },
    {
        CITY: 'BANGUI',
        BARANGAY: 'ABACA',
    },
    {
        CITY: 'BANGUI',
        BARANGAY: 'BACSIL',
    },
    {
        CITY: 'BANGUI',
        BARANGAY: 'BANBAN',
    },
    {
        CITY: 'BANGUI',
        BARANGAY: 'BARUYEN',
    },
    {
        CITY: 'BANGUI',
        BARANGAY: 'DADAOR',
    },
    {
        CITY: 'BANGUI',
        BARANGAY: 'LANAO',
    },
    {
        CITY: 'BANGUI',
        BARANGAY: 'MALASIN',
    },
    {
        CITY: 'BANGUI',
        BARANGAY: 'MANAYON',
    },
    {
        CITY: 'BANGUI',
        BARANGAY: 'MASIKIL',
    },
    {
        CITY: 'BANGUI',
        BARANGAY: 'NAGBALAGAN',
    },
    {
        CITY: 'BANGUI',
        BARANGAY: 'PAYAC',
    },
    {
        CITY: 'BANGUI',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'BANGUI',
        BARANGAY: 'SAN LORENZO (POB.)',
    },
    {
        CITY: 'BANGUI',
        BARANGAY: 'TAGUIPORO',
    },
    {
        CITY: 'BANGUI',
        BARANGAY: 'UTOL',
    },
    {
        CITY: 'BANNA',
        BARANGAY: 'BALIOEG',
    },
    {
        CITY: 'BANNA',
        BARANGAY: 'BANGSAR',
    },
    {
        CITY: 'BANNA',
        BARANGAY: 'BARBARANGAY',
    },
    {
        CITY: 'BANNA',
        BARANGAY: 'BINACAG',
    },
    {
        CITY: 'BANNA',
        BARANGAY: 'BOMITOG',
    },
    {
        CITY: 'BANNA',
        BARANGAY: 'BUGASI',
    },
    {
        CITY: 'BANNA',
        BARANGAY: 'CAESTEBANAN',
    },
    {
        CITY: 'BANNA',
        BARANGAY: 'CARIBQUIB',
    },
    {
        CITY: 'BANNA',
        BARANGAY: 'CATAGTAGUEN',
    },
    {
        CITY: 'BANNA',
        BARANGAY: 'CRISPINA',
    },
    {
        CITY: 'BANNA',
        BARANGAY: 'HILARIO (POB.)',
    },
    {
        CITY: 'BANNA',
        BARANGAY: 'IMELDA',
    },
    {
        CITY: 'BANNA',
        BARANGAY: 'LORENZO (POB.)',
    },
    {
        CITY: 'BANNA',
        BARANGAY: 'MACAYEPYEP',
    },
    {
        CITY: 'BANNA',
        BARANGAY: 'MARCOS (POB.)',
    },
    {
        CITY: 'BANNA',
        BARANGAY: 'NAGPATAYAN',
    },
    {
        CITY: 'BANNA',
        BARANGAY: 'SINAMAR',
    },
    {
        CITY: 'BANNA',
        BARANGAY: 'TABTABAGAN',
    },
    {
        CITY: 'BANNA',
        BARANGAY: 'VALDEZ',
    },
    {
        CITY: 'BANNA',
        BARANGAY: 'VALENCIANO (POB.)',
    },
    {
        CITY: 'BATAC',
        BARANGAY: 'ABLAN POB. (LABUCAO)',
    },
    {
        CITY: 'BATAC',
        BARANGAY: 'ACOSTA POB. (ILOILO)',
    },
    {
        CITY: 'BATAC',
        BARANGAY: 'AGLIPAY (POB.)',
    },
    {
        CITY: 'BATAC',
        BARANGAY: 'BAAY',
    },
    {
        CITY: 'BATAC',
        BARANGAY: 'BALIGAT',
    },
    {
        CITY: 'BATAC',
        BARANGAY: 'BAOA EAST',
    },
    {
        CITY: 'BATAC',
        BARANGAY: 'BAOA WEST',
    },
    {
        CITY: 'BATAC',
        BARANGAY: 'BARANI (POB.)',
    },
    {
        CITY: 'BATAC',
        BARANGAY: 'BEN-AGAN (POB.)',
    },
    {
        CITY: 'BATAC',
        BARANGAY: 'BIL-LOCA',
    },
    {
        CITY: 'BATAC',
        BARANGAY: 'BININGAN',
    },
    {
        CITY: 'BATAC',
        BARANGAY: 'BUNGON',
    },
    {
        CITY: 'BATAC',
        BARANGAY: 'CALLAGUIP (POB.)',
    },
    {
        CITY: 'BATAC',
        BARANGAY: 'CAMANDINGAN',
    },
    {
        CITY: 'BATAC',
        BARANGAY: 'CAMGUIDAN',
    },
    {
        CITY: 'BATAC',
        BARANGAY: 'CANGRUNAAN (POB.)',
    },
    {
        CITY: 'BATAC',
        BARANGAY: 'CAPACUAN',
    },
    {
        CITY: 'BATAC',
        BARANGAY: 'CAUNAYAN (POB.)',
    },
    {
        CITY: 'BATAC',
        BARANGAY: 'COLO',
    },
    {
        CITY: 'BATAC',
        BARANGAY: 'DARIWDIW',
    },
    {
        CITY: 'BATAC',
        BARANGAY: 'LACUB (POB.)',
    },
    {
        CITY: 'BATAC',
        BARANGAY: 'MABALENG',
    },
    {
        CITY: 'BATAC',
        BARANGAY: 'MAGNUANG',
    },
    {
        CITY: 'BATAC',
        BARANGAY: 'MAIPALIG',
    },
    {
        CITY: 'BATAC',
        BARANGAY: 'NAGBACALAN',
    },
    {
        CITY: 'BATAC',
        BARANGAY: 'NAGUIRANGAN',
    },
    {
        CITY: 'BATAC',
        BARANGAY: 'PALONGPONG',
    },
    {
        CITY: 'BATAC',
        BARANGAY: 'PALPALICONG (POB.)',
    },
    {
        CITY: 'BATAC',
        BARANGAY: 'PARANGOPONG',
    },
    {
        CITY: 'BATAC',
        BARANGAY: 'PAYAO',
    },
    {
        CITY: 'BATAC',
        BARANGAY: 'PIMENTEL (CUBOL)',
    },
    {
        CITY: 'BATAC',
        BARANGAY: 'QUILING NORTE',
    },
    {
        CITY: 'BATAC',
        BARANGAY: 'QUILING SUR',
    },
    {
        CITY: 'BATAC',
        BARANGAY: 'QUIOM',
    },
    {
        CITY: 'BATAC',
        BARANGAY: 'RAYURAY',
    },
    {
        CITY: 'BATAC',
        BARANGAY: 'RICARTE POB. (NALASIN)',
    },
    {
        CITY: 'BATAC',
        BARANGAY: 'SAN JULIAN (POB.)',
    },
    {
        CITY: 'BATAC',
        BARANGAY: 'SAN MATEO',
    },
    {
        CITY: 'BATAC',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'BATAC',
        BARANGAY: 'SUABIT (POB.)',
    },
    {
        CITY: 'BATAC',
        BARANGAY: 'SUMADER',
    },
    {
        CITY: 'BATAC',
        BARANGAY: 'TABUG',
    },
    {
        CITY: 'BATAC',
        BARANGAY: 'VALDEZ POB. (CAOAYAN)',
    },
    {
        CITY: 'CARASI',
        BARANGAY: 'ANGSET',
    },
    {
        CITY: 'CARASI',
        BARANGAY: 'BARBAQUESO (POB.)',
    },
    {
        CITY: 'CARASI',
        BARANGAY: 'VIRBIRA',
    },
    {
        CITY: 'CURRIMAO',
        BARANGAY: 'ANGGAPANG NORTE',
    },
    {
        CITY: 'CURRIMAO',
        BARANGAY: 'ANGGAPANG SUR',
    },
    {
        CITY: 'CURRIMAO',
        BARANGAY: 'BIMMANGA',
    },
    {
        CITY: 'CURRIMAO',
        BARANGAY: 'CABUUSAN',
    },
    {
        CITY: 'CURRIMAO',
        BARANGAY: 'COMCOMLOONG',
    },
    {
        CITY: 'CURRIMAO',
        BARANGAY: 'GAANG',
    },
    {
        CITY: 'CURRIMAO',
        BARANGAY: 'LANG-AYAN-BARAMBAN',
    },
    {
        CITY: 'CURRIMAO',
        BARANGAY: 'LIOES',
    },
    {
        CITY: 'CURRIMAO',
        BARANGAY: 'MAGLAOI CENTRO',
    },
    {
        CITY: 'CURRIMAO',
        BARANGAY: 'MAGLAOI NORTE',
    },
    {
        CITY: 'CURRIMAO',
        BARANGAY: 'MAGLAOI SUR',
    },
    {
        CITY: 'CURRIMAO',
        BARANGAY: 'PAGULUDAN-SALINDEG',
    },
    {
        CITY: 'CURRIMAO',
        BARANGAY: 'PANGIL',
    },
    {
        CITY: 'CURRIMAO',
        BARANGAY: 'PIAS NORTE',
    },
    {
        CITY: 'CURRIMAO',
        BARANGAY: 'PIAS SUR',
    },
    {
        CITY: 'CURRIMAO',
        BARANGAY: 'POBLACION I',
    },
    {
        CITY: 'CURRIMAO',
        BARANGAY: 'POBLACION II',
    },
    {
        CITY: 'CURRIMAO',
        BARANGAY: 'SALUGAN',
    },
    {
        CITY: 'CURRIMAO',
        BARANGAY: 'SAN SIMEON',
    },
    {
        CITY: 'CURRIMAO',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'CURRIMAO',
        BARANGAY: 'TAPAO-TIGUE',
    },
    {
        CITY: 'CURRIMAO',
        BARANGAY: 'TORRE',
    },
    {
        CITY: 'CURRIMAO',
        BARANGAY: 'VICTORIA',
    },
    {
        CITY: 'DINGRAS',
        BARANGAY: 'ALBANO (POB.)',
    },
    {
        CITY: 'DINGRAS',
        BARANGAY: 'BACSIL',
    },
    {
        CITY: 'DINGRAS',
        BARANGAY: 'BAGUT',
    },
    {
        CITY: 'DINGRAS',
        BARANGAY: 'BARESBES',
    },
    {
        CITY: 'DINGRAS',
        BARANGAY: 'BARONG',
    },
    {
        CITY: 'DINGRAS',
        BARANGAY: 'BUNGCAG',
    },
    {
        CITY: 'DINGRAS',
        BARANGAY: 'CALI',
    },
    {
        CITY: 'DINGRAS',
        BARANGAY: 'CAPASAN',
    },
    {
        CITY: 'DINGRAS',
        BARANGAY: 'DANCEL (POB.)',
    },
    {
        CITY: 'DINGRAS',
        BARANGAY: 'ELIZABETH',
    },
    {
        CITY: 'DINGRAS',
        BARANGAY: 'ESPIRITU',
    },
    {
        CITY: 'DINGRAS',
        BARANGAY: 'FOZ',
    },
    {
        CITY: 'DINGRAS',
        BARANGAY: 'GUERRERO (POB.)',
    },
    {
        CITY: 'DINGRAS',
        BARANGAY: 'LANAS',
    },
    {
        CITY: 'DINGRAS',
        BARANGAY: 'LUMBAD',
    },
    {
        CITY: 'DINGRAS',
        BARANGAY: 'MADAMBA (POB.)',
    },
    {
        CITY: 'DINGRAS',
        BARANGAY: 'MANDALOQUE',
    },
    {
        CITY: 'DINGRAS',
        BARANGAY: 'MEDINA',
    },
    {
        CITY: 'DINGRAS',
        BARANGAY: 'PARADO (BANGAY)',
    },
    {
        CITY: 'DINGRAS',
        BARANGAY: 'PERALTA (POB.)',
    },
    {
        CITY: 'DINGRAS',
        BARANGAY: 'PURUGANAN (POB.)',
    },
    {
        CITY: 'DINGRAS',
        BARANGAY: 'ROOT (BALDIAS)',
    },
    {
        CITY: 'DINGRAS',
        BARANGAY: 'SAGPATAN',
    },
    {
        CITY: 'DINGRAS',
        BARANGAY: 'SALUDARES',
    },
    {
        CITY: 'DINGRAS',
        BARANGAY: 'SAN ESTEBAN',
    },
    {
        CITY: 'DINGRAS',
        BARANGAY: 'SAN FRANCISCO (SURRATE)',
    },
    {
        CITY: 'DINGRAS',
        BARANGAY: 'SAN MARCELINO (PADONG)',
    },
    {
        CITY: 'DINGRAS',
        BARANGAY: 'SAN MARCOS',
    },
    {
        CITY: 'DINGRAS',
        BARANGAY: 'SULQUIANO (SIDIRAN)',
    },
    {
        CITY: 'DINGRAS',
        BARANGAY: 'SUYO',
    },
    {
        CITY: 'DINGRAS',
        BARANGAY: 'VER (NAGLAYAAN)',
    },
    {
        CITY: 'DUMALNEG',
        BARANGAY: 'CABARITAN (DUMALNEG)',
    },
    {
        CITY: 'DUMALNEG',
        BARANGAY: 'DUMALNEG',
    },
    {
        CITY: 'DUMALNEG',
        BARANGAY: 'KALAW (DUMALNEG)',
    },
    {
        CITY: 'DUMALNEG',
        BARANGAY: 'QUIBEL (DUMALNEG)',
    },
    {
        CITY: 'DUMALNEG',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'BURGOS',
        BARANGAY: 'ABLAN SARAT',
    },
    {
        CITY: 'BURGOS',
        BARANGAY: 'AGAGA',
    },
    {
        CITY: 'BURGOS',
        BARANGAY: 'BAYOG',
    },
    {
        CITY: 'BURGOS',
        BARANGAY: 'BOBON',
    },
    {
        CITY: 'BURGOS',
        BARANGAY: 'BUDUAN (MALITUEK)',
    },
    {
        CITY: 'BURGOS',
        BARANGAY: 'NAGSUROT',
    },
    {
        CITY: 'BURGOS',
        BARANGAY: 'PAAYAS',
    },
    {
        CITY: 'BURGOS',
        BARANGAY: 'PAGALI',
    },
    {
        CITY: 'BURGOS',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BURGOS',
        BARANGAY: 'SAOIT',
    },
    {
        CITY: 'BURGOS',
        BARANGAY: 'TANAP',
    },
    {
        CITY: 'ILOCOS-NORTE-SAN-NICOLAS',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'ILOCOS-NORTE-SAN-NICOLAS',
        BARANGAY: 'SAN BALTAZAR (POB.)',
    },
    {
        CITY: 'ILOCOS-NORTE-SAN-NICOLAS',
        BARANGAY: 'SAN BARTOLOME (POB.)',
    },
    {
        CITY: 'ILOCOS-NORTE-SAN-NICOLAS',
        BARANGAY: 'SAN CAYETANO (POB.)',
    },
    {
        CITY: 'ILOCOS-NORTE-SAN-NICOLAS',
        BARANGAY: 'SAN EUGENIO (POB.)',
    },
    {
        CITY: 'ILOCOS-NORTE-SAN-NICOLAS',
        BARANGAY: 'SAN FERNANDO (POB.)',
    },
    {
        CITY: 'ILOCOS-NORTE-SAN-NICOLAS',
        BARANGAY: 'SAN FRANCISCO (POB.)',
    },
    {
        CITY: 'ILOCOS-NORTE-SAN-NICOLAS',
        BARANGAY: 'SAN GREGORIO (POB.)',
    },
    {
        CITY: 'ILOCOS-NORTE-SAN-NICOLAS',
        BARANGAY: 'SAN GUILLERMO',
    },
    {
        CITY: 'ILOCOS-NORTE-SAN-NICOLAS',
        BARANGAY: 'SAN ILDEFONSO (POB.)',
    },
    {
        CITY: 'ILOCOS-NORTE-SAN-NICOLAS',
        BARANGAY: 'SAN JOSE (POB.)',
    },
    {
        CITY: 'ILOCOS-NORTE-SAN-NICOLAS',
        BARANGAY: 'SAN JUAN BAUTISTA (POB.)',
    },
    {
        CITY: 'ILOCOS-NORTE-SAN-NICOLAS',
        BARANGAY: 'SAN LORENZO',
    },
    {
        CITY: 'ILOCOS-NORTE-SAN-NICOLAS',
        BARANGAY: 'SAN LUCAS (POB.)',
    },
    {
        CITY: 'ILOCOS-NORTE-SAN-NICOLAS',
        BARANGAY: 'SAN MARCOS (PAYAS)',
    },
    {
        CITY: 'ILOCOS-NORTE-SAN-NICOLAS',
        BARANGAY: 'SAN MIGUEL (POB.)',
    },
    {
        CITY: 'ILOCOS-NORTE-SAN-NICOLAS',
        BARANGAY: 'SAN PABLO',
    },
    {
        CITY: 'ILOCOS-NORTE-SAN-NICOLAS',
        BARANGAY: 'SAN PAULO (POB.)',
    },
    {
        CITY: 'ILOCOS-NORTE-SAN-NICOLAS',
        BARANGAY: 'SAN PEDRO (BINGAO)',
    },
    {
        CITY: 'ILOCOS-NORTE-SAN-NICOLAS',
        BARANGAY: 'SAN RUFINO (POB.)',
    },
    {
        CITY: 'ILOCOS-NORTE-SAN-NICOLAS',
        BARANGAY: 'SAN SILVESTRE (POB.)',
    },
    {
        CITY: 'ILOCOS-NORTE-SAN-NICOLAS',
        BARANGAY: 'SANTA ASUNCION (SAMAC)',
    },
    {
        CITY: 'ILOCOS-NORTE-SAN-NICOLAS',
        BARANGAY: 'SANTA CECILIA (BARABAR)',
    },
    {
        CITY: 'ILOCOS-NORTE-SAN-NICOLAS',
        BARANGAY: 'SANTA MONICA (NAGREBCAN)',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 1',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 1 SAN LORENZO (POB.)',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 10',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 10 SAN JOSE (POB.)',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 11',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 11 SANTA BALBINA (POB.)',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 12',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 12 SAN ISIDRO (POB.)',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 13',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 13 NSTRA. SRA. DE VISITACION (POB.)',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 14',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 14 SANTO TOMAS (POB.)',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 15',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 15 SAN GUILLERMO (POB.)',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 16',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 16 SAN JACINTO (POB.)',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 17',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 17 SAN FRANCISCO (POB.)',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 19',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 19 SANTA MARCELA (POB.)',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 2',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 2 SANTA JOAQUINA (POB.)',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 20',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 20 SAN MIGUEL (POB.)',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 21',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 21 SAN PEDRO (POB.)',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 22',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 22 SAN ANDRES (POB.)',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 23',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 23 SAN MATIAS (POB.)',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 24',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 24 NSTRA. SRA. DE CONSOLACION (POB.)',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 25',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 25 SANTA CAYETANA (POB.)',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 26',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 26 SAN MARCELINO (POB.)',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 27',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 27 NSTRA. SRA. DE SOLEDAD (POB.)',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 28',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 28 SAN BERNARDO (POB.)',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 29',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 29 SANTO TOMAS (POB.)',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 3',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 3 NSTRA. SRA. DEL ROSARIO (POB.)',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 30-A',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 30-A SUYO',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 30-B',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 30-B SANTA MARIA',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 31',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 31 TALINGAAN',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 32-A',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 32-A LA PAZ EAST',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 32-B',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 32-B LA PAZ WEST',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 32-C LA PAZ EAST',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 33-A',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 33-A LA PAZ PROPER',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 33-B',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 33-B LA PAZ PROPER',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 34-A',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 34-A GABU NORTE WEST',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 34-B',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 34-B GABU NORTE EAST',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 35',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 35 GABU SUR',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 36',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 36 ARANIW',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 37',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 37 CALAYAB',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 38-A',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 38-A MANGATO EAST',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 38-B',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 38-B MANGATO WEST',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 39',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 39 SANTA ROSA',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 4',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 4 SAN GUILLERMO (POB.)',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 40',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 40 BALATONG',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 41',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 41 BALACAD',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 42',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 42 APAYA',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 43',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 43 CAVIT',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 44',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 44 ZAMBOANGA',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 45',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 45 TANGID',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 46',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 46 NALBO',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 47',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 47 BENGCAG',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 48-B',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 48-B CABUNGAAN SOUTH',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 49-A',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 49-A DARAYDAY',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 49-B',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 49-B RARABURAN',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 5',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 5 SAN PEDRO (POB.)',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 50',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 50 BUTTONG',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 51-A',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 51-A NANGALISAN EAST',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 51-B',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 51-B NANGALISAN WEST',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 52-A',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 52-A SAN MATEO',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 52-B',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 52-B LATAAG',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 53',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 53 RIOENG',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 54-A',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 54-A LAGUI-SAIL',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 54-B',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 54-B CAMANGAAN',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 55-A',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 55-A BARIT-PANDAN',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 55-B',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 55-B SALET-BULANGON',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 55-C',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 55-C VIRA',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 56-A',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 56-A BACSIL NORTH',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 56-B',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 56-B BACSIL SOUTH',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 57',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 57 PILA',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 58',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 58 CASILI',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 59-A',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 59-A DIBUA SOUTH',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 59-B',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 59-B DIBUA NORTH',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 6',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 6 SAN AGUSTIN (POB.)',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 60-A',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 60-A CAAOACAN',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 60-B',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 60-B MADILADIG',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 61',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 61 CATABAN',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 62-A',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 62-A NAVOTAS NORTH',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 62-B',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 62-B NAVOTAS SOUTH',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 7-A',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 7-A NSTRA. SRA. DE NATIVIDAD (POB.)',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 7-B',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 7-B NSTRA. SRA. DE NATIVIDAD (POB.)',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 8',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 8 SAN VICENTE (POB.)',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 9',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BGY. NO. 9 SANTA ANGELA (POB.)',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BRY. NO. 18',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BRY. NO. 18 SAN QUIRINO (POB.)',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BRY. NO. 48-A',
    },
    {
        CITY: 'LAOAG',
        BARANGAY: 'BRY. NO. 48-A CABUNGAAN NORTH',
    },
    {
        CITY: 'MARCOS',
        BARANGAY: 'CACAFEAN',
    },
    {
        CITY: 'MARCOS',
        BARANGAY: 'DAQUIOAG',
    },
    {
        CITY: 'MARCOS',
        BARANGAY: 'ELIZABETH (CULAO)',
    },
    {
        CITY: 'MARCOS',
        BARANGAY: 'ESCODA',
    },
    {
        CITY: 'MARCOS',
        BARANGAY: 'FERDINAND',
    },
    {
        CITY: 'MARCOS',
        BARANGAY: 'FORTUNA',
    },
    {
        CITY: 'MARCOS',
        BARANGAY: 'IMELDA (CAPARIAAN)',
    },
    {
        CITY: 'MARCOS',
        BARANGAY: 'LYDIA (POB.)',
    },
    {
        CITY: 'MARCOS',
        BARANGAY: 'MABUTI',
    },
    {
        CITY: 'MARCOS',
        BARANGAY: 'PACIFICO (AGUNIT)',
    },
    {
        CITY: 'MARCOS',
        BARANGAY: 'SANTIAGO',
    },
    {
        CITY: 'MARCOS',
        BARANGAY: 'TABUCBUC (RAGAS)',
    },
    {
        CITY: 'MARCOS',
        BARANGAY: 'VALDEZ (BIDING)',
    },
    {
        CITY: 'NUEVA-ERA',
        BARANGAY: 'ACNAM',
    },
    {
        CITY: 'NUEVA-ERA',
        BARANGAY: 'BARANGOBONG',
    },
    {
        CITY: 'NUEVA-ERA',
        BARANGAY: 'BARIKIR',
    },
    {
        CITY: 'NUEVA-ERA',
        BARANGAY: 'BUGAYONG',
    },
    {
        CITY: 'NUEVA-ERA',
        BARANGAY: 'CABITTAURAN',
    },
    {
        CITY: 'NUEVA-ERA',
        BARANGAY: 'CARAY',
    },
    {
        CITY: 'NUEVA-ERA',
        BARANGAY: 'GARNADEN',
    },
    {
        CITY: 'NUEVA-ERA',
        BARANGAY: 'NAGUILLAN (PAGPAG-ONG)',
    },
    {
        CITY: 'NUEVA-ERA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'NUEVA-ERA',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'NUEVA-ERA',
        BARANGAY: 'UGUIS',
    },
    {
        CITY: 'PAGUDPUD',
        BARANGAY: 'AGGASI',
    },
    {
        CITY: 'PAGUDPUD',
        BARANGAY: 'BADUANG',
    },
    {
        CITY: 'PAGUDPUD',
        BARANGAY: 'BALAOI',
    },
    {
        CITY: 'PAGUDPUD',
        BARANGAY: 'BURAYOC',
    },
    {
        CITY: 'PAGUDPUD',
        BARANGAY: 'CAPARISPISAN',
    },
    {
        CITY: 'PAGUDPUD',
        BARANGAY: 'CAUNAYAN',
    },
    {
        CITY: 'PAGUDPUD',
        BARANGAY: 'DAMPIG',
    },
    {
        CITY: 'PAGUDPUD',
        BARANGAY: 'LIGAYA',
    },
    {
        CITY: 'PAGUDPUD',
        BARANGAY: 'PANCIAN',
    },
    {
        CITY: 'PAGUDPUD',
        BARANGAY: 'PASALENG',
    },
    {
        CITY: 'PAGUDPUD',
        BARANGAY: 'POBLACION 1',
    },
    {
        CITY: 'PAGUDPUD',
        BARANGAY: 'POBLACION 2',
    },
    {
        CITY: 'PAGUDPUD',
        BARANGAY: 'SAGUIGUI',
    },
    {
        CITY: 'PAGUDPUD',
        BARANGAY: 'SAUD',
    },
    {
        CITY: 'PAGUDPUD',
        BARANGAY: 'SUBEC',
    },
    {
        CITY: 'PAGUDPUD',
        BARANGAY: 'TARRAG',
    },
    {
        CITY: 'PAOAY',
        BARANGAY: 'BACSIL',
    },
    {
        CITY: 'PAOAY',
        BARANGAY: 'CABAGOAN',
    },
    {
        CITY: 'PAOAY',
        BARANGAY: 'CABANGARAN',
    },
    {
        CITY: 'PAOAY',
        BARANGAY: 'CALLAGUIP',
    },
    {
        CITY: 'PAOAY',
        BARANGAY: 'CAYUBOG',
    },
    {
        CITY: 'PAOAY',
        BARANGAY: 'DOLORES',
    },
    {
        CITY: 'PAOAY',
        BARANGAY: 'LAOA',
    },
    {
        CITY: 'PAOAY',
        BARANGAY: 'MASINTOC',
    },
    {
        CITY: 'PAOAY',
        BARANGAY: 'MONTE',
    },
    {
        CITY: 'PAOAY',
        BARANGAY: 'MUMULAAN',
    },
    {
        CITY: 'PAOAY',
        BARANGAY: 'NAGBACALAN',
    },
    {
        CITY: 'PAOAY',
        BARANGAY: 'NALASIN',
    },
    {
        CITY: 'PAOAY',
        BARANGAY: 'NANGUYUDAN',
    },
    {
        CITY: 'PAOAY',
        BARANGAY: 'OAIG-UPAY-ABULAO',
    },
    {
        CITY: 'PAOAY',
        BARANGAY: 'PAMBARAN',
    },
    {
        CITY: 'PAOAY',
        BARANGAY: 'PANNARATAN (POB.)',
    },
    {
        CITY: 'PAOAY',
        BARANGAY: 'PARATONG',
    },
    {
        CITY: 'PAOAY',
        BARANGAY: 'PASIL',
    },
    {
        CITY: 'PAOAY',
        BARANGAY: 'SALBANG (POB.)',
    },
    {
        CITY: 'PAOAY',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'PAOAY',
        BARANGAY: 'SAN BLAS (POB.)',
    },
    {
        CITY: 'PAOAY',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'PAOAY',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'PAOAY',
        BARANGAY: 'SAN ROQUE (POB.)',
    },
    {
        CITY: 'PAOAY',
        BARANGAY: 'SANGLADAN POB. (NALBUAN)',
    },
    {
        CITY: 'PAOAY',
        BARANGAY: 'SANTA RITA (POB.)',
    },
    {
        CITY: 'PAOAY',
        BARANGAY: 'SIDEG',
    },
    {
        CITY: 'PAOAY',
        BARANGAY: 'SUBA',
    },
    {
        CITY: 'PAOAY',
        BARANGAY: 'SUNGADAN',
    },
    {
        CITY: 'PAOAY',
        BARANGAY: 'SURGUI',
    },
    {
        CITY: 'PAOAY',
        BARANGAY: 'VERONICA',
    },
    {
        CITY: 'PASUQUIN',
        BARANGAY: 'BATULI',
    },
    {
        CITY: 'PASUQUIN',
        BARANGAY: 'BINSANG',
    },
    {
        CITY: 'PASUQUIN',
        BARANGAY: 'CARUAN',
    },
    {
        CITY: 'PASUQUIN',
        BARANGAY: 'CARUSIKIS',
    },
    {
        CITY: 'PASUQUIN',
        BARANGAY: 'CARUSIPAN',
    },
    {
        CITY: 'PASUQUIN',
        BARANGAY: 'DADAEMAN',
    },
    {
        CITY: 'PASUQUIN',
        BARANGAY: 'DARUPIDIP',
    },
    {
        CITY: 'PASUQUIN',
        BARANGAY: 'DAVILA',
    },
    {
        CITY: 'PASUQUIN',
        BARANGAY: 'DILANIS',
    },
    {
        CITY: 'PASUQUIN',
        BARANGAY: 'DILAVO',
    },
    {
        CITY: 'PASUQUIN',
        BARANGAY: 'ESTANCIA',
    },
    {
        CITY: 'PASUQUIN',
        BARANGAY: 'NAGLICUAN',
    },
    {
        CITY: 'PASUQUIN',
        BARANGAY: 'NAGSANGA',
    },
    {
        CITY: 'PASUQUIN',
        BARANGAY: 'NALVO (CABABAAN-NALVO)',
    },
    {
        CITY: 'PASUQUIN',
        BARANGAY: 'NGABANGAB',
    },
    {
        CITY: 'PASUQUIN',
        BARANGAY: 'PANGIL',
    },
    {
        CITY: 'PASUQUIN',
        BARANGAY: 'POBLACION 1',
    },
    {
        CITY: 'PASUQUIN',
        BARANGAY: 'POBLACION 2',
    },
    {
        CITY: 'PASUQUIN',
        BARANGAY: 'POBLACION 3',
    },
    {
        CITY: 'PASUQUIN',
        BARANGAY: 'POBLACION 4',
    },
    {
        CITY: 'PASUQUIN',
        BARANGAY: 'PRAGATA (PRAGATA-BUNGRO)',
    },
    {
        CITY: 'PASUQUIN',
        BARANGAY: 'PUYUPUYAN',
    },
    {
        CITY: 'PASUQUIN',
        BARANGAY: 'SALPAD',
    },
    {
        CITY: 'PASUQUIN',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'PASUQUIN',
        BARANGAY: 'SANTA CATALINA',
    },
    {
        CITY: 'PASUQUIN',
        BARANGAY: 'SANTA MATILDE',
    },
    {
        CITY: 'PASUQUIN',
        BARANGAY: 'SAPAT',
    },
    {
        CITY: 'PASUQUIN',
        BARANGAY: 'SULBEC',
    },
    {
        CITY: 'PASUQUIN',
        BARANGAY: 'SULONGAN',
    },
    {
        CITY: 'PASUQUIN',
        BARANGAY: 'SURONG',
    },
    {
        CITY: 'PASUQUIN',
        BARANGAY: 'SUSUGAEN',
    },
    {
        CITY: 'PASUQUIN',
        BARANGAY: 'TABUNGAO',
    },
    {
        CITY: 'PASUQUIN',
        BARANGAY: 'TADAO',
    },
    {
        CITY: 'PIDDIG',
        BARANGAY: 'AB-ABUT',
    },
    {
        CITY: 'PIDDIG',
        BARANGAY: 'ABUCAY',
    },
    {
        CITY: 'PIDDIG',
        BARANGAY: 'ANAO (POB.)',
    },
    {
        CITY: 'PIDDIG',
        BARANGAY: 'ARUA-AY',
    },
    {
        CITY: 'PIDDIG',
        BARANGAY: 'BIMMANGA',
    },
    {
        CITY: 'PIDDIG',
        BARANGAY: 'BOYBOY',
    },
    {
        CITY: 'PIDDIG',
        BARANGAY: 'CABAROAN (POB.)',
    },
    {
        CITY: 'PIDDIG',
        BARANGAY: 'CALAMBEG',
    },
    {
        CITY: 'PIDDIG',
        BARANGAY: 'CALLUSA',
    },
    {
        CITY: 'PIDDIG',
        BARANGAY: 'DUPITAC',
    },
    {
        CITY: 'PIDDIG',
        BARANGAY: 'ESTANCIA',
    },
    {
        CITY: 'PIDDIG',
        BARANGAY: 'GAYAMAT',
    },
    {
        CITY: 'PIDDIG',
        BARANGAY: 'LAGANDIT',
    },
    {
        CITY: 'PIDDIG',
        BARANGAY: 'LIBNAOAN',
    },
    {
        CITY: 'PIDDIG',
        BARANGAY: 'LOING (POB.)',
    },
    {
        CITY: 'PIDDIG',
        BARANGAY: 'MAAB-ABACA',
    },
    {
        CITY: 'PIDDIG',
        BARANGAY: 'MANGITAYAG',
    },
    {
        CITY: 'PIDDIG',
        BARANGAY: 'MARUAYA',
    },
    {
        CITY: 'PIDDIG',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'PIDDIG',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'PIDDIG',
        BARANGAY: 'SUCSUQUEN',
    },
    {
        CITY: 'PIDDIG',
        BARANGAY: 'TANGAOAN',
    },
    {
        CITY: 'PIDDIG',
        BARANGAY: 'TONOTON',
    },
    {
        CITY: 'PINILI',
        BARANGAY: 'AGLIPAY',
    },
    {
        CITY: 'PINILI',
        BARANGAY: 'APATUT-LUBONG',
    },
    {
        CITY: 'PINILI',
        BARANGAY: 'BADIO',
    },
    {
        CITY: 'PINILI',
        BARANGAY: 'BARBAR',
    },
    {
        CITY: 'PINILI',
        BARANGAY: 'BUANGA',
    },
    {
        CITY: 'PINILI',
        BARANGAY: 'BULBULALA',
    },
    {
        CITY: 'PINILI',
        BARANGAY: 'BUNGRO',
    },
    {
        CITY: 'PINILI',
        BARANGAY: 'CABAROAN',
    },
    {
        CITY: 'PINILI',
        BARANGAY: 'CAPANGDANAN',
    },
    {
        CITY: 'PINILI',
        BARANGAY: 'DALAYAP',
    },
    {
        CITY: 'PINILI',
        BARANGAY: 'DARAT',
    },
    {
        CITY: 'PINILI',
        BARANGAY: 'GULPENG',
    },
    {
        CITY: 'PINILI',
        BARANGAY: 'LILIPUTEN',
    },
    {
        CITY: 'PINILI',
        BARANGAY: 'LUMBAAN-BICBICA',
    },
    {
        CITY: 'PINILI',
        BARANGAY: 'NAGTRIGOAN',
    },
    {
        CITY: 'PINILI',
        BARANGAY: 'PAGDILAO (POB.)',
    },
    {
        CITY: 'PINILI',
        BARANGAY: 'PUGAOAN',
    },
    {
        CITY: 'PINILI',
        BARANGAY: 'PURITAC',
    },
    {
        CITY: 'PINILI',
        BARANGAY: 'PUZOL',
    },
    {
        CITY: 'PINILI',
        BARANGAY: 'SACRITAN',
    },
    {
        CITY: 'PINILI',
        BARANGAY: 'SALANAP',
    },
    {
        CITY: 'PINILI',
        BARANGAY: 'SANTO TOMAS',
    },
    {
        CITY: 'PINILI',
        BARANGAY: 'TARTARABANG',
    },
    {
        CITY: 'PINILI',
        BARANGAY: 'UPON',
    },
    {
        CITY: 'PINILI',
        BARANGAY: 'VALBUENA (POB.)',
    },
    {
        CITY: 'SARRAT',
        BARANGAY: 'SAN AGUSTIN (POB.)',
    },
    {
        CITY: 'SARRAT',
        BARANGAY: 'SAN ANDRES',
    },
    {
        CITY: 'SARRAT',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'SARRAT',
        BARANGAY: 'SAN BERNABE',
    },
    {
        CITY: 'SARRAT',
        BARANGAY: 'SAN CRISTOBAL',
    },
    {
        CITY: 'SARRAT',
        BARANGAY: 'SAN FELIPE',
    },
    {
        CITY: 'SARRAT',
        BARANGAY: 'SAN FRANCISCO (POB.)',
    },
    {
        CITY: 'SARRAT',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'SARRAT',
        BARANGAY: 'SAN JOAQUIN (POB.)',
    },
    {
        CITY: 'SARRAT',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'SARRAT',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'SARRAT',
        BARANGAY: 'SAN LEANDRO (POB.)',
    },
    {
        CITY: 'SARRAT',
        BARANGAY: 'SAN LORENZO',
    },
    {
        CITY: 'SARRAT',
        BARANGAY: 'SAN MANUEL',
    },
    {
        CITY: 'SARRAT',
        BARANGAY: 'SAN MARCOS',
    },
    {
        CITY: 'SARRAT',
        BARANGAY: 'SAN NICOLAS',
    },
    {
        CITY: 'SARRAT',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'SARRAT',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'SARRAT',
        BARANGAY: 'SAN VICENTE (POB.)',
    },
    {
        CITY: 'SARRAT',
        BARANGAY: 'SANTA BARBARA (POB.)',
    },
    {
        CITY: 'SARRAT',
        BARANGAY: 'SANTA MAGDALENA',
    },
    {
        CITY: 'SARRAT',
        BARANGAY: 'SANTA ROSA',
    },
    {
        CITY: 'SARRAT',
        BARANGAY: 'SANTO SANTIAGO',
    },
    {
        CITY: 'SARRAT',
        BARANGAY: 'SANTO TOMAS',
    },
    {
        CITY: 'SOLSONA',
        BARANGAY: 'AGUITAP',
    },
    {
        CITY: 'SOLSONA',
        BARANGAY: 'BAGBAG',
    },
    {
        CITY: 'SOLSONA',
        BARANGAY: 'BAGBAGO',
    },
    {
        CITY: 'SOLSONA',
        BARANGAY: 'BARCELONA',
    },
    {
        CITY: 'SOLSONA',
        BARANGAY: 'BUBUOS',
    },
    {
        CITY: 'SOLSONA',
        BARANGAY: 'CAPURICTAN',
    },
    {
        CITY: 'SOLSONA',
        BARANGAY: 'CATANGRARAN',
    },
    {
        CITY: 'SOLSONA',
        BARANGAY: 'DARASDAS',
    },
    {
        CITY: 'SOLSONA',
        BARANGAY: 'JUAN (POB.)',
    },
    {
        CITY: 'SOLSONA',
        BARANGAY: 'LAURETA (POB.)',
    },
    {
        CITY: 'SOLSONA',
        BARANGAY: 'LIPAY',
    },
    {
        CITY: 'SOLSONA',
        BARANGAY: 'MAANANTENG',
    },
    {
        CITY: 'SOLSONA',
        BARANGAY: 'MANALPAC',
    },
    {
        CITY: 'SOLSONA',
        BARANGAY: 'MARIQUET',
    },
    {
        CITY: 'SOLSONA',
        BARANGAY: 'NAGPATPATAN',
    },
    {
        CITY: 'SOLSONA',
        BARANGAY: 'NALASIN',
    },
    {
        CITY: 'SOLSONA',
        BARANGAY: 'PUTTAO',
    },
    {
        CITY: 'SOLSONA',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'SOLSONA',
        BARANGAY: 'SAN JULIAN',
    },
    {
        CITY: 'SOLSONA',
        BARANGAY: 'SANTA ANA',
    },
    {
        CITY: 'SOLSONA',
        BARANGAY: 'SANTIAGO',
    },
    {
        CITY: 'SOLSONA',
        BARANGAY: 'TALUGTOG',
    },
    {
        CITY: 'VINTAR',
        BARANGAY: 'ABKIR',
    },
    {
        CITY: 'VINTAR',
        BARANGAY: 'ALEJO MALASIG',
    },
    {
        CITY: 'VINTAR',
        BARANGAY: 'ALSEM',
    },
    {
        CITY: 'VINTAR',
        BARANGAY: 'BAGO',
    },
    {
        CITY: 'VINTAR',
        BARANGAY: 'BULBULALA',
    },
    {
        CITY: 'VINTAR',
        BARANGAY: 'CABANGARAN',
    },
    {
        CITY: 'VINTAR',
        BARANGAY: 'CABAYO',
    },
    {
        CITY: 'VINTAR',
        BARANGAY: 'CABISOCOLAN',
    },
    {
        CITY: 'VINTAR',
        BARANGAY: 'CANAAM',
    },
    {
        CITY: 'VINTAR',
        BARANGAY: 'COLUMBIA',
    },
    {
        CITY: 'VINTAR',
        BARANGAY: 'DAGUPAN',
    },
    {
        CITY: 'VINTAR',
        BARANGAY: 'DIPILAT',
    },
    {
        CITY: 'VINTAR',
        BARANGAY: 'ESPERANZA',
    },
    {
        CITY: 'VINTAR',
        BARANGAY: 'ESTER',
    },
    {
        CITY: 'VINTAR',
        BARANGAY: 'ISIC ISIC',
    },
    {
        CITY: 'VINTAR',
        BARANGAY: 'LUBNAC',
    },
    {
        CITY: 'VINTAR',
        BARANGAY: 'MABANBANAG',
    },
    {
        CITY: 'VINTAR',
        BARANGAY: 'MALAMPA (PENINAAN-MALAMPA)',
    },
    {
        CITY: 'VINTAR',
        BARANGAY: 'MANARANG',
    },
    {
        CITY: 'VINTAR',
        BARANGAY: 'MARGAAY',
    },
    {
        CITY: 'VINTAR',
        BARANGAY: 'NAMOROC',
    },
    {
        CITY: 'VINTAR',
        BARANGAY: 'PARPAROROC',
    },
    {
        CITY: 'VINTAR',
        BARANGAY: 'PARUT',
    },
    {
        CITY: 'VINTAR',
        BARANGAY: 'PEDRO F. ALVIAR (DIATON)',
    },
    {
        CITY: 'VINTAR',
        BARANGAY: 'SALSALAMAGUI',
    },
    {
        CITY: 'VINTAR',
        BARANGAY: 'SAN JOSE (LIPAY)',
    },
    {
        CITY: 'VINTAR',
        BARANGAY: 'SAN NICOLAS (POB.)',
    },
    {
        CITY: 'VINTAR',
        BARANGAY: 'SAN PEDRO (POB.)',
    },
    {
        CITY: 'VINTAR',
        BARANGAY: 'SAN RAMON (POB.)',
    },
    {
        CITY: 'VINTAR',
        BARANGAY: 'SAN ROQUE (POB.)',
    },
    {
        CITY: 'VINTAR',
        BARANGAY: 'SANTA MARIA (POB.)',
    },
    {
        CITY: 'VINTAR',
        BARANGAY: 'TAMDAGAN',
    },
    {
        CITY: 'VINTAR',
        BARANGAY: 'VISAYA',
    },
    {
        CITY: 'AGNO',
        BARANGAY: 'ALLABON',
    },
    {
        CITY: 'AGNO',
        BARANGAY: 'ALOLENG',
    },
    {
        CITY: 'AGNO',
        BARANGAY: 'BANGAN-ODA',
    },
    {
        CITY: 'AGNO',
        BARANGAY: 'BARUAN',
    },
    {
        CITY: 'AGNO',
        BARANGAY: 'BOBOY',
    },
    {
        CITY: 'AGNO',
        BARANGAY: 'CAYUNGNAN',
    },
    {
        CITY: 'AGNO',
        BARANGAY: 'DANGLEY',
    },
    {
        CITY: 'AGNO',
        BARANGAY: 'GAYUSAN',
    },
    {
        CITY: 'AGNO',
        BARANGAY: 'MACABOBONI',
    },
    {
        CITY: 'AGNO',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'AGNO',
        BARANGAY: 'NAMATUCAN',
    },
    {
        CITY: 'AGNO',
        BARANGAY: 'PATAR',
    },
    {
        CITY: 'AGNO',
        BARANGAY: 'POBLACION EAST',
    },
    {
        CITY: 'AGNO',
        BARANGAY: 'POBLACION WEST',
    },
    {
        CITY: 'AGNO',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'AGNO',
        BARANGAY: 'TUPA',
    },
    {
        CITY: 'AGNO',
        BARANGAY: 'VIGA',
    },
    {
        CITY: 'AGUILAR',
        BARANGAY: 'BAYAOAS',
    },
    {
        CITY: 'AGUILAR',
        BARANGAY: 'BAYBAY',
    },
    {
        CITY: 'AGUILAR',
        BARANGAY: 'BOCACLIW',
    },
    {
        CITY: 'AGUILAR',
        BARANGAY: 'BOCBOC EAST',
    },
    {
        CITY: 'AGUILAR',
        BARANGAY: 'BOCBOC WEST',
    },
    {
        CITY: 'AGUILAR',
        BARANGAY: 'BUER',
    },
    {
        CITY: 'AGUILAR',
        BARANGAY: 'CALSIB',
    },
    {
        CITY: 'AGUILAR',
        BARANGAY: 'LAOAG',
    },
    {
        CITY: 'AGUILAR',
        BARANGAY: 'MANLOCBOC',
    },
    {
        CITY: 'AGUILAR',
        BARANGAY: 'NINOY',
    },
    {
        CITY: 'AGUILAR',
        BARANGAY: 'PANACOL',
    },
    {
        CITY: 'AGUILAR',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'AGUILAR',
        BARANGAY: 'POGOMBOA',
    },
    {
        CITY: 'AGUILAR',
        BARANGAY: 'POGONSILI',
    },
    {
        CITY: 'AGUILAR',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'AGUILAR',
        BARANGAY: 'TAMPAC',
    },
    {
        CITY: 'ALAMINOS',
        BARANGAY: 'ALOS',
    },
    {
        CITY: 'ALAMINOS',
        BARANGAY: 'AMANDIEGO',
    },
    {
        CITY: 'ALAMINOS',
        BARANGAY: 'AMANGBANGAN',
    },
    {
        CITY: 'ALAMINOS',
        BARANGAY: 'BALANGOBONG',
    },
    {
        CITY: 'ALAMINOS',
        BARANGAY: 'BALAYANG',
    },
    {
        CITY: 'ALAMINOS',
        BARANGAY: 'BALEYADAAN',
    },
    {
        CITY: 'ALAMINOS',
        BARANGAY: 'BISOCOL',
    },
    {
        CITY: 'ALAMINOS',
        BARANGAY: 'BOLANEY',
    },
    {
        CITY: 'ALAMINOS',
        BARANGAY: 'BUED',
    },
    {
        CITY: 'ALAMINOS',
        BARANGAY: 'CABATUAN',
    },
    {
        CITY: 'ALAMINOS',
        BARANGAY: 'CAYUCAY',
    },
    {
        CITY: 'ALAMINOS',
        BARANGAY: 'DULACAC',
    },
    {
        CITY: 'ALAMINOS',
        BARANGAY: 'INERANGAN',
    },
    {
        CITY: 'ALAMINOS',
        BARANGAY: 'LANDOC',
    },
    {
        CITY: 'ALAMINOS',
        BARANGAY: 'LINMANSANGAN',
    },
    {
        CITY: 'ALAMINOS',
        BARANGAY: 'LUCAP',
    },
    {
        CITY: 'ALAMINOS',
        BARANGAY: 'MAAWI',
    },
    {
        CITY: 'ALAMINOS',
        BARANGAY: 'MACATIW',
    },
    {
        CITY: 'ALAMINOS',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'ALAMINOS',
        BARANGAY: 'MONA',
    },
    {
        CITY: 'ALAMINOS',
        BARANGAY: 'PALAMIS',
    },
    {
        CITY: 'ALAMINOS',
        BARANGAY: 'PANDAN',
    },
    {
        CITY: 'ALAMINOS',
        BARANGAY: 'PANGAPISAN',
    },
    {
        CITY: 'ALAMINOS',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'ALAMINOS',
        BARANGAY: 'POCALPOCAL',
    },
    {
        CITY: 'ALAMINOS',
        BARANGAY: 'POGO',
    },
    {
        CITY: 'ALAMINOS',
        BARANGAY: 'POLO',
    },
    {
        CITY: 'ALAMINOS',
        BARANGAY: 'QUIBUAR',
    },
    {
        CITY: 'ALAMINOS',
        BARANGAY: 'SABANGAN',
    },
    {
        CITY: 'ALAMINOS',
        BARANGAY: 'SAN ANTONIO (R. MAGSAYSAY)',
    },
    {
        CITY: 'ALAMINOS',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'ALAMINOS',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'ALAMINOS',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'ALAMINOS',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'ALAMINOS',
        BARANGAY: 'TANAYTAY',
    },
    {
        CITY: 'ALAMINOS',
        BARANGAY: 'TANGCARANG',
    },
    {
        CITY: 'ALAMINOS',
        BARANGAY: 'TAWINTAWIN',
    },
    {
        CITY: 'ALAMINOS',
        BARANGAY: 'TELBANG',
    },
    {
        CITY: 'ALAMINOS',
        BARANGAY: 'VICTORIA',
    },
    {
        CITY: 'ASINGAN',
        BARANGAY: 'ARISTON ESTE',
    },
    {
        CITY: 'ASINGAN',
        BARANGAY: 'ARISTON WESTE',
    },
    {
        CITY: 'ASINGAN',
        BARANGAY: 'BANTOG',
    },
    {
        CITY: 'ASINGAN',
        BARANGAY: 'BARO',
    },
    {
        CITY: 'ASINGAN',
        BARANGAY: 'BOBONAN',
    },
    {
        CITY: 'ASINGAN',
        BARANGAY: 'CABALITIAN',
    },
    {
        CITY: 'ASINGAN',
        BARANGAY: 'CALEPAAN',
    },
    {
        CITY: 'ASINGAN',
        BARANGAY: 'CAROSUCAN NORTE',
    },
    {
        CITY: 'ASINGAN',
        BARANGAY: 'CAROSUCAN SUR',
    },
    {
        CITY: 'ASINGAN',
        BARANGAY: 'COLDIT',
    },
    {
        CITY: 'ASINGAN',
        BARANGAY: 'DOMANPOT',
    },
    {
        CITY: 'ASINGAN',
        BARANGAY: 'DUPAC',
    },
    {
        CITY: 'ASINGAN',
        BARANGAY: 'MACALONG',
    },
    {
        CITY: 'ASINGAN',
        BARANGAY: 'PALARIS',
    },
    {
        CITY: 'ASINGAN',
        BARANGAY: 'POBLACION EAST',
    },
    {
        CITY: 'ASINGAN',
        BARANGAY: 'POBLACION WEST',
    },
    {
        CITY: 'ASINGAN',
        BARANGAY: 'SAN VICENTE ESTE',
    },
    {
        CITY: 'ASINGAN',
        BARANGAY: 'SAN VICENTE WESTE',
    },
    {
        CITY: 'ASINGAN',
        BARANGAY: 'SANCHEZ',
    },
    {
        CITY: 'ASINGAN',
        BARANGAY: 'SOBOL',
    },
    {
        CITY: 'ASINGAN',
        BARANGAY: 'TOBOY',
    },
    {
        CITY: 'BALUNGAO',
        BARANGAY: 'ANGAYAN NORTE',
    },
    {
        CITY: 'BALUNGAO',
        BARANGAY: 'ANGAYAN SUR',
    },
    {
        CITY: 'BALUNGAO',
        BARANGAY: 'CAPULAAN',
    },
    {
        CITY: 'BALUNGAO',
        BARANGAY: 'ESMERALDA',
    },
    {
        CITY: 'BALUNGAO',
        BARANGAY: 'KITA-KITA',
    },
    {
        CITY: 'BALUNGAO',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'BALUNGAO',
        BARANGAY: 'MAUBAN',
    },
    {
        CITY: 'BALUNGAO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BALUNGAO',
        BARANGAY: 'PUGARO',
    },
    {
        CITY: 'BALUNGAO',
        BARANGAY: 'RAJAL',
    },
    {
        CITY: 'BALUNGAO',
        BARANGAY: 'SAN ANDRES',
    },
    {
        CITY: 'BALUNGAO',
        BARANGAY: 'SAN AURELIO 1ST',
    },
    {
        CITY: 'BALUNGAO',
        BARANGAY: 'SAN AURELIO 2ND',
    },
    {
        CITY: 'BALUNGAO',
        BARANGAY: 'SAN AURELIO 3RD',
    },
    {
        CITY: 'BALUNGAO',
        BARANGAY: 'SAN JOAQUIN',
    },
    {
        CITY: 'BALUNGAO',
        BARANGAY: 'SAN JULIAN',
    },
    {
        CITY: 'BALUNGAO',
        BARANGAY: 'SAN LEON',
    },
    {
        CITY: 'BALUNGAO',
        BARANGAY: 'SAN MARCELINO',
    },
    {
        CITY: 'BALUNGAO',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'BALUNGAO',
        BARANGAY: 'SAN RAYMUNDO',
    },
    {
        CITY: 'BANI',
        BARANGAY: 'AMBABAAY',
    },
    {
        CITY: 'BANI',
        BARANGAY: 'APORAO',
    },
    {
        CITY: 'BANI',
        BARANGAY: 'ARWAS',
    },
    {
        CITY: 'BANI',
        BARANGAY: 'BALLAG',
    },
    {
        CITY: 'BANI',
        BARANGAY: 'BANOG NORTE',
    },
    {
        CITY: 'BANI',
        BARANGAY: 'BANOG SUR',
    },
    {
        CITY: 'BANI',
        BARANGAY: 'CALABENG',
    },
    {
        CITY: 'BANI',
        BARANGAY: 'CENTRO TOMA',
    },
    {
        CITY: 'BANI',
        BARANGAY: 'COLAYO',
    },
    {
        CITY: 'BANI',
        BARANGAY: 'DACAP NORTE',
    },
    {
        CITY: 'BANI',
        BARANGAY: 'DACAP SUR',
    },
    {
        CITY: 'BANI',
        BARANGAY: 'GARRITA',
    },
    {
        CITY: 'BANI',
        BARANGAY: 'LUAC',
    },
    {
        CITY: 'BANI',
        BARANGAY: 'MACABIT',
    },
    {
        CITY: 'BANI',
        BARANGAY: 'MASIDEM',
    },
    {
        CITY: 'BANI',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BANI',
        BARANGAY: 'QUINAOAYANAN',
    },
    {
        CITY: 'BANI',
        BARANGAY: 'RANAO',
    },
    {
        CITY: 'BANI',
        BARANGAY: 'RANOM ILOCO',
    },
    {
        CITY: 'BANI',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'BANI',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'BANI',
        BARANGAY: 'SAN SIMON',
    },
    {
        CITY: 'BANI',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'BANI',
        BARANGAY: 'TIEP',
    },
    {
        CITY: 'BANI',
        BARANGAY: 'TIPOR',
    },
    {
        CITY: 'BANI',
        BARANGAY: 'TUGUI GRANDE',
    },
    {
        CITY: 'BANI',
        BARANGAY: 'TUGUI NORTE',
    },
    {
        CITY: 'BASISTA',
        BARANGAY: 'ANAMBONGAN',
    },
    {
        CITY: 'BASISTA',
        BARANGAY: 'BAYOYONG',
    },
    {
        CITY: 'BASISTA',
        BARANGAY: 'CABELDATAN',
    },
    {
        CITY: 'BASISTA',
        BARANGAY: 'DUMPAY',
    },
    {
        CITY: 'BASISTA',
        BARANGAY: 'MALIMPEC EAST',
    },
    {
        CITY: 'BASISTA',
        BARANGAY: 'MAPOLOPOLO',
    },
    {
        CITY: 'BASISTA',
        BARANGAY: 'NALNERAN',
    },
    {
        CITY: 'BASISTA',
        BARANGAY: 'NAVATAT',
    },
    {
        CITY: 'BASISTA',
        BARANGAY: 'OBONG',
    },
    {
        CITY: 'BASISTA',
        BARANGAY: 'OSMENA SR.',
    },
    {
        CITY: 'BASISTA',
        BARANGAY: 'PALMA',
    },
    {
        CITY: 'BASISTA',
        BARANGAY: 'PATACBO',
    },
    {
        CITY: 'BASISTA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BAUTISTA',
        BARANGAY: 'ARTACHO',
    },
    {
        CITY: 'BAUTISTA',
        BARANGAY: 'BALUYOT',
    },
    {
        CITY: 'BAUTISTA',
        BARANGAY: 'CABUAAN',
    },
    {
        CITY: 'BAUTISTA',
        BARANGAY: 'CACANDONGAN',
    },
    {
        CITY: 'BAUTISTA',
        BARANGAY: 'DIAZ',
    },
    {
        CITY: 'BAUTISTA',
        BARANGAY: 'KETEGAN',
    },
    {
        CITY: 'BAUTISTA',
        BARANGAY: 'NANDACAN',
    },
    {
        CITY: 'BAUTISTA',
        BARANGAY: 'NIBALIW NORTE',
    },
    {
        CITY: 'BAUTISTA',
        BARANGAY: 'NIBALIW SUR',
    },
    {
        CITY: 'BAUTISTA',
        BARANGAY: 'PALISOC',
    },
    {
        CITY: 'BAUTISTA',
        BARANGAY: 'POBLACION EAST',
    },
    {
        CITY: 'BAUTISTA',
        BARANGAY: 'POBLACION WEST',
    },
    {
        CITY: 'BAUTISTA',
        BARANGAY: 'POGO',
    },
    {
        CITY: 'BAUTISTA',
        BARANGAY: 'POPONTO',
    },
    {
        CITY: 'BAUTISTA',
        BARANGAY: 'PRIMICIAS',
    },
    {
        CITY: 'BAUTISTA',
        BARANGAY: 'SINABAAN',
    },
    {
        CITY: 'BAUTISTA',
        BARANGAY: 'VACANTE',
    },
    {
        CITY: 'BAUTISTA',
        BARANGAY: 'VILLANUEVA',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'ALINGGAN',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'AMAMPEREZ',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'AMANCOSILING NORTE',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'AMANCOSILING SUR',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'AMBAYAT I',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'AMBAYAT II',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'APALEN',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'ASIN',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'ATAYNAN',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'BACNONO',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'BALAYBUAYA',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'BANABAN',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'BANI',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'BATANGCAWA',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'BELENG',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'BICAL NORTE',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'BICAL SUR',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'BONGATO EAST',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'BONGATO WEST',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'BUAYAEN',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'BUENLAG 1ST',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'BUENLAG 2ND',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'CADRE SITE',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'CARUNGAY',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'CATURAY',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'DARAWEY (TANGAL)',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'DUERA',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'DUSOC',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'HERMOZA',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'IDONG',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'INANLORENZANA',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'INIRANGAN',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'ITON',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'LANGIRAN',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'LIGUE',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'M. H. DEL PILAR',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'MACAYOCAYO',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'MAIGPA',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'MALIMPEC',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'MALIOER',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'MANAGOS',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'MANAMBONG NORTE',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'MANAMBONG PARTE',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'MANAMBONG SUR',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'MANGAYAO',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'NALSIAN NORTE',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'NALSIAN SUR',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'PANGDEL',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'PANTOL',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'PARAGOS',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'POBLACION SUR',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'PUGO',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'REYNADO',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'SAN GABRIEL 1ST',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'SAN GABRIEL 2ND',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'SANGCAGULIS',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'SANLIBO',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'SAPANG',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'TAMARO',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'TAMBAC',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'TAMPOG',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'TANOLONG',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'TATARAO',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'TELBANG',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'TOCOC EAST',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'TOCOC WEST',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'WARDING',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'WAWA',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'ZONE I (POB.)',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'ZONE II (POB.)',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'ZONE III (POB.)',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'ZONE IV (POB.)',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'ZONE V (POB.)',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'ZONE VI (POB.)',
    },
    {
        CITY: 'BAYAMBANG',
        BARANGAY: 'ZONE VII (POB.)',
    },
    {
        CITY: 'BINALONAN',
        BARANGAY: 'BALANGOBONG',
    },
    {
        CITY: 'BINALONAN',
        BARANGAY: 'BUED',
    },
    {
        CITY: 'BINALONAN',
        BARANGAY: 'BUGAYONG',
    },
    {
        CITY: 'BINALONAN',
        BARANGAY: 'CAMANGAAN',
    },
    {
        CITY: 'BINALONAN',
        BARANGAY: 'CANARVACANAN',
    },
    {
        CITY: 'BINALONAN',
        BARANGAY: 'CAPAS',
    },
    {
        CITY: 'BINALONAN',
        BARANGAY: 'CILI',
    },
    {
        CITY: 'BINALONAN',
        BARANGAY: 'DUMAYAT',
    },
    {
        CITY: 'BINALONAN',
        BARANGAY: 'LINMANSANGAN',
    },
    {
        CITY: 'BINALONAN',
        BARANGAY: 'MANGCASUY',
    },
    {
        CITY: 'BINALONAN',
        BARANGAY: 'MORENO',
    },
    {
        CITY: 'BINALONAN',
        BARANGAY: 'PASILENG NORTE',
    },
    {
        CITY: 'BINALONAN',
        BARANGAY: 'PASILENG SUR',
    },
    {
        CITY: 'BINALONAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BINALONAN',
        BARANGAY: 'SAN FELIPE CENTRAL',
    },
    {
        CITY: 'BINALONAN',
        BARANGAY: 'SAN FELIPE SUR',
    },
    {
        CITY: 'BINALONAN',
        BARANGAY: 'SAN PABLO',
    },
    {
        CITY: 'BINALONAN',
        BARANGAY: 'SANTA CATALINA',
    },
    {
        CITY: 'BINALONAN',
        BARANGAY: 'SANTA MARIA NORTE',
    },
    {
        CITY: 'BINALONAN',
        BARANGAY: 'SANTIAGO',
    },
    {
        CITY: 'BINALONAN',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'BINALONAN',
        BARANGAY: 'SUMABNIT',
    },
    {
        CITY: 'BINALONAN',
        BARANGAY: 'TABUYOC',
    },
    {
        CITY: 'BINALONAN',
        BARANGAY: 'VACANTE',
    },
    {
        CITY: 'BINMALEY',
        BARANGAY: 'AMANCORO',
    },
    {
        CITY: 'BINMALEY',
        BARANGAY: 'BALAGAN',
    },
    {
        CITY: 'BINMALEY',
        BARANGAY: 'BALOGO',
    },
    {
        CITY: 'BINMALEY',
        BARANGAY: 'BASING',
    },
    {
        CITY: 'BINMALEY',
        BARANGAY: 'BAYBAY LOPEZ',
    },
    {
        CITY: 'BINMALEY',
        BARANGAY: 'BAYBAY POLONG',
    },
    {
        CITY: 'BINMALEY',
        BARANGAY: 'BIEC',
    },
    {
        CITY: 'BINMALEY',
        BARANGAY: 'BUENLAG',
    },
    {
        CITY: 'BINMALEY',
        BARANGAY: 'CALIT',
    },
    {
        CITY: 'BINMALEY',
        BARANGAY: 'CALOOCAN DUPO',
    },
    {
        CITY: 'BINMALEY',
        BARANGAY: 'CALOOCAN NORTE',
    },
    {
        CITY: 'BINMALEY',
        BARANGAY: 'CALOOCAN SUR',
    },
    {
        CITY: 'BINMALEY',
        BARANGAY: 'CAMALEY',
    },
    {
        CITY: 'BINMALEY',
        BARANGAY: 'CANAOALAN',
    },
    {
        CITY: 'BINMALEY',
        BARANGAY: 'DULAG',
    },
    {
        CITY: 'BINMALEY',
        BARANGAY: 'GAYAMAN',
    },
    {
        CITY: 'BINMALEY',
        BARANGAY: 'LINOC',
    },
    {
        CITY: 'BINMALEY',
        BARANGAY: 'LOMBOY',
    },
    {
        CITY: 'BINMALEY',
        BARANGAY: 'MALINDONG',
    },
    {
        CITY: 'BINMALEY',
        BARANGAY: 'MANAT',
    },
    {
        CITY: 'BINMALEY',
        BARANGAY: 'NAGPALANGAN',
    },
    {
        CITY: 'BINMALEY',
        BARANGAY: 'NAGUILAYAN',
    },
    {
        CITY: 'BINMALEY',
        BARANGAY: 'PALLAS',
    },
    {
        CITY: 'BINMALEY',
        BARANGAY: 'PAPAGUEYAN',
    },
    {
        CITY: 'BINMALEY',
        BARANGAY: 'PARAYAO',
    },
    {
        CITY: 'BINMALEY',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BINMALEY',
        BARANGAY: 'POTOTAN',
    },
    {
        CITY: 'BINMALEY',
        BARANGAY: 'SABANGAN',
    },
    {
        CITY: 'BINMALEY',
        BARANGAY: 'SALAPINGAO',
    },
    {
        CITY: 'BINMALEY',
        BARANGAY: 'SAN ISIDRO NORTE',
    },
    {
        CITY: 'BINMALEY',
        BARANGAY: 'SAN ISIDRO SUR',
    },
    {
        CITY: 'BINMALEY',
        BARANGAY: 'SANTA ROSA',
    },
    {
        CITY: 'BINMALEY',
        BARANGAY: 'TOMBOR',
    },
    {
        CITY: 'BOLINAO',
        BARANGAY: 'ARNEDO',
    },
    {
        CITY: 'BOLINAO',
        BARANGAY: 'BALINGASAY',
    },
    {
        CITY: 'BOLINAO',
        BARANGAY: 'BINABALIAN',
    },
    {
        CITY: 'BOLINAO',
        BARANGAY: 'CABUYAO',
    },
    {
        CITY: 'BOLINAO',
        BARANGAY: 'CABUYAO',
    },
    {
        CITY: 'BOLINAO',
        BARANGAY: 'CATUDAY',
    },
    {
        CITY: 'BOLINAO',
        BARANGAY: 'CATUNGI',
    },
    {
        CITY: 'BOLINAO',
        BARANGAY: 'CONCORDIA (POB.)',
    },
    {
        CITY: 'BOLINAO',
        BARANGAY: 'CULANG',
    },
    {
        CITY: 'BOLINAO',
        BARANGAY: 'DEWEY',
    },
    {
        CITY: 'BOLINAO',
        BARANGAY: 'ESTANZA',
    },
    {
        CITY: 'BOLINAO',
        BARANGAY: 'GERMINAL (POB.)',
    },
    {
        CITY: 'BOLINAO',
        BARANGAY: 'GOYODEN',
    },
    {
        CITY: 'BOLINAO',
        BARANGAY: 'ILOGMALINO',
    },
    {
        CITY: 'BOLINAO',
        BARANGAY: 'LAMBES (LAMES)',
    },
    {
        CITY: 'BOLINAO',
        BARANGAY: 'LIWA-LIWA',
    },
    {
        CITY: 'BOLINAO',
        BARANGAY: 'LUCERO',
    },
    {
        CITY: 'BOLINAO',
        BARANGAY: 'LUCIENTE 1.0',
    },
    {
        CITY: 'BOLINAO',
        BARANGAY: 'LUCIENTE 2.0',
    },
    {
        CITY: 'BOLINAO',
        BARANGAY: 'LUNA',
    },
    {
        CITY: 'BOLINAO',
        BARANGAY: 'PATAR',
    },
    {
        CITY: 'BOLINAO',
        BARANGAY: 'PILAR',
    },
    {
        CITY: 'BOLINAO',
        BARANGAY: 'SALUD',
    },
    {
        CITY: 'BOLINAO',
        BARANGAY: 'SAMANG NORTE',
    },
    {
        CITY: 'BOLINAO',
        BARANGAY: 'SAMANG SUR',
    },
    {
        CITY: 'BOLINAO',
        BARANGAY: 'SAMPALOC',
    },
    {
        CITY: 'BOLINAO',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'BOLINAO',
        BARANGAY: 'TARA',
    },
    {
        CITY: 'BOLINAO',
        BARANGAY: 'TUPA',
    },
    {
        CITY: 'BOLINAO',
        BARANGAY: 'VICTORY',
    },
    {
        CITY: 'BOLINAO',
        BARANGAY: 'ZARAGOZA',
    },
    {
        CITY: 'BUGALLON',
        BARANGAY: 'ANGARIAN',
    },
    {
        CITY: 'BUGALLON',
        BARANGAY: 'ASINAN',
    },
    {
        CITY: 'BUGALLON',
        BARANGAY: 'BACABAC',
    },
    {
        CITY: 'BUGALLON',
        BARANGAY: 'BANAGA',
    },
    {
        CITY: 'BUGALLON',
        BARANGAY: 'BOLAOEN',
    },
    {
        CITY: 'BUGALLON',
        BARANGAY: 'BUENLAG',
    },
    {
        CITY: 'BUGALLON',
        BARANGAY: 'CABAYAOASAN',
    },
    {
        CITY: 'BUGALLON',
        BARANGAY: 'CAYANGA',
    },
    {
        CITY: 'BUGALLON',
        BARANGAY: 'GUESET',
    },
    {
        CITY: 'BUGALLON',
        BARANGAY: 'HACIENDA',
    },
    {
        CITY: 'BUGALLON',
        BARANGAY: 'LAGUIT CENTRO',
    },
    {
        CITY: 'BUGALLON',
        BARANGAY: 'LAGUIT PADILLA',
    },
    {
        CITY: 'BUGALLON',
        BARANGAY: 'MAGTAKING',
    },
    {
        CITY: 'BUGALLON',
        BARANGAY: 'PANGASCASAN',
    },
    {
        CITY: 'BUGALLON',
        BARANGAY: 'PANTAL',
    },
    {
        CITY: 'BUGALLON',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BUGALLON',
        BARANGAY: 'POLONG',
    },
    {
        CITY: 'BUGALLON',
        BARANGAY: 'PORTIC',
    },
    {
        CITY: 'BUGALLON',
        BARANGAY: 'SALASA',
    },
    {
        CITY: 'BUGALLON',
        BARANGAY: 'SALOMAGUE NORTE',
    },
    {
        CITY: 'BUGALLON',
        BARANGAY: 'SALOMAGUE SUR',
    },
    {
        CITY: 'BUGALLON',
        BARANGAY: 'SAMAT',
    },
    {
        CITY: 'BUGALLON',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'BUGALLON',
        BARANGAY: 'UMANDAY',
    },
    {
        CITY: 'CALASIAO',
        BARANGAY: 'AMBONAO',
    },
    {
        CITY: 'CALASIAO',
        BARANGAY: 'AMBUETEL',
    },
    {
        CITY: 'CALASIAO',
        BARANGAY: 'BANAOANG',
    },
    {
        CITY: 'CALASIAO',
        BARANGAY: 'BUED',
    },
    {
        CITY: 'CALASIAO',
        BARANGAY: 'BUENLAG',
    },
    {
        CITY: 'CALASIAO',
        BARANGAY: 'CABILOCAAN',
    },
    {
        CITY: 'CALASIAO',
        BARANGAY: 'DINALAOAN',
    },
    {
        CITY: 'CALASIAO',
        BARANGAY: 'DOYONG',
    },
    {
        CITY: 'CALASIAO',
        BARANGAY: 'GABON',
    },
    {
        CITY: 'CALASIAO',
        BARANGAY: 'LASIP',
    },
    {
        CITY: 'CALASIAO',
        BARANGAY: 'LONGOS',
    },
    {
        CITY: 'CALASIAO',
        BARANGAY: 'LUMBANG',
    },
    {
        CITY: 'CALASIAO',
        BARANGAY: 'MACABITO',
    },
    {
        CITY: 'CALASIAO',
        BARANGAY: 'MALABAGO',
    },
    {
        CITY: 'CALASIAO',
        BARANGAY: 'MANCUP',
    },
    {
        CITY: 'CALASIAO',
        BARANGAY: 'NAGSAING',
    },
    {
        CITY: 'CALASIAO',
        BARANGAY: 'NALSIAN',
    },
    {
        CITY: 'CALASIAO',
        BARANGAY: 'POBLACION EAST',
    },
    {
        CITY: 'CALASIAO',
        BARANGAY: 'POBLACION WEST',
    },
    {
        CITY: 'CALASIAO',
        BARANGAY: 'QUESBAN',
    },
    {
        CITY: 'CALASIAO',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'CALASIAO',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'CALASIAO',
        BARANGAY: 'SONGKOY',
    },
    {
        CITY: 'CALASIAO',
        BARANGAY: 'TALIBAEW',
    },
    {
        CITY: 'DAGUPAN',
        BARANGAY: 'BACAYAO NORTE',
    },
    {
        CITY: 'DAGUPAN',
        BARANGAY: 'BACAYAO SUR',
    },
    {
        CITY: 'DAGUPAN',
        BARANGAY: 'BARANGAY I (T. BUGALLON)',
    },
    {
        CITY: 'DAGUPAN',
        BARANGAY: 'BARANGAY II (NUEVA)',
    },
    {
        CITY: 'DAGUPAN',
        BARANGAY: 'BARANGAY IV (ZAMORA)',
    },
    {
        CITY: 'DAGUPAN',
        BARANGAY: 'BOLOSAN',
    },
    {
        CITY: 'DAGUPAN',
        BARANGAY: 'BONUAN BINLOC',
    },
    {
        CITY: 'DAGUPAN',
        BARANGAY: 'BONUAN BOQUIG',
    },
    {
        CITY: 'DAGUPAN',
        BARANGAY: 'BONUAN GUESET',
    },
    {
        CITY: 'DAGUPAN',
        BARANGAY: 'CALMAY',
    },
    {
        CITY: 'DAGUPAN',
        BARANGAY: 'CARAEL',
    },
    {
        CITY: 'DAGUPAN',
        BARANGAY: 'CARANGLAAN',
    },
    {
        CITY: 'DAGUPAN',
        BARANGAY: 'HERRERO',
    },
    {
        CITY: 'DAGUPAN',
        BARANGAY: 'LASIP CHICO',
    },
    {
        CITY: 'DAGUPAN',
        BARANGAY: 'LASIP GRANDE',
    },
    {
        CITY: 'DAGUPAN',
        BARANGAY: 'LOMBOY',
    },
    {
        CITY: 'DAGUPAN',
        BARANGAY: 'LUCAO',
    },
    {
        CITY: 'DAGUPAN',
        BARANGAY: 'MALUED',
    },
    {
        CITY: 'DAGUPAN',
        BARANGAY: 'MAMALINGLING',
    },
    {
        CITY: 'DAGUPAN',
        BARANGAY: 'MANGIN',
    },
    {
        CITY: 'DAGUPAN',
        BARANGAY: 'MAYOMBO',
    },
    {
        CITY: 'DAGUPAN',
        BARANGAY: 'PANTAL',
    },
    {
        CITY: 'DAGUPAN',
        BARANGAY: 'POBLACION OESTE',
    },
    {
        CITY: 'DAGUPAN',
        BARANGAY: 'POGO CHICO',
    },
    {
        CITY: 'DAGUPAN',
        BARANGAY: 'POGO GRANDE',
    },
    {
        CITY: 'DAGUPAN',
        BARANGAY: 'PUGARO SUIT',
    },
    {
        CITY: 'DAGUPAN',
        BARANGAY: 'SALAPINGAO',
    },
    {
        CITY: 'DAGUPAN',
        BARANGAY: 'SALISAY',
    },
    {
        CITY: 'DAGUPAN',
        BARANGAY: 'TAMBAC',
    },
    {
        CITY: 'DAGUPAN',
        BARANGAY: 'TAPUAC',
    },
    {
        CITY: 'DAGUPAN',
        BARANGAY: 'TEBENG',
    },
    {
        CITY: 'DASOL',
        BARANGAY: 'ALILAO',
    },
    {
        CITY: 'DASOL',
        BARANGAY: 'AMALBALAN',
    },
    {
        CITY: 'DASOL',
        BARANGAY: 'BOBONOT',
    },
    {
        CITY: 'DASOL',
        BARANGAY: 'EGUIA',
    },
    {
        CITY: 'DASOL',
        BARANGAY: 'GAIS-GUIPE',
    },
    {
        CITY: 'DASOL',
        BARANGAY: 'HERMOSA',
    },
    {
        CITY: 'DASOL',
        BARANGAY: 'MACALANG',
    },
    {
        CITY: 'DASOL',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'DASOL',
        BARANGAY: 'MALACAPAS',
    },
    {
        CITY: 'DASOL',
        BARANGAY: 'MALIMPIN',
    },
    {
        CITY: 'DASOL',
        BARANGAY: 'OSMENA',
    },
    {
        CITY: 'DASOL',
        BARANGAY: 'PETAL',
    },
    {
        CITY: 'DASOL',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'DASOL',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'DASOL',
        BARANGAY: 'TAMBAC',
    },
    {
        CITY: 'DASOL',
        BARANGAY: 'TAMBOBONG',
    },
    {
        CITY: 'DASOL',
        BARANGAY: 'ULI',
    },
    {
        CITY: 'DASOL',
        BARANGAY: 'VIGA',
    },
    {
        CITY: 'LABRADOR',
        BARANGAY: 'BOLO',
    },
    {
        CITY: 'LABRADOR',
        BARANGAY: 'BONGALON',
    },
    {
        CITY: 'LABRADOR',
        BARANGAY: 'DULIG',
    },
    {
        CITY: 'LABRADOR',
        BARANGAY: 'LAOIS',
    },
    {
        CITY: 'LABRADOR',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'LABRADOR',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'LABRADOR',
        BARANGAY: 'SAN GONZALO',
    },
    {
        CITY: 'LABRADOR',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'LABRADOR',
        BARANGAY: 'TOBUAN',
    },
    {
        CITY: 'LABRADOR',
        BARANGAY: 'UYONG',
    },
    {
        CITY: 'LAOAC',
        BARANGAY: 'ANIS',
    },
    {
        CITY: 'LAOAC',
        BARANGAY: 'BALLIGI',
    },
    {
        CITY: 'LAOAC',
        BARANGAY: 'BANUAR',
    },
    {
        CITY: 'LAOAC',
        BARANGAY: 'BOTIQUE',
    },
    {
        CITY: 'LAOAC',
        BARANGAY: 'CAARINGAYAN',
    },
    {
        CITY: 'LAOAC',
        BARANGAY: 'CABILAOAN WEST',
    },
    {
        CITY: 'LAOAC',
        BARANGAY: 'CABULALAAN',
    },
    {
        CITY: 'LAOAC',
        BARANGAY: 'CALAOAGAN',
    },
    {
        CITY: 'LAOAC',
        BARANGAY: 'CALMAY',
    },
    {
        CITY: 'LAOAC',
        BARANGAY: 'CASAMPAGAAN',
    },
    {
        CITY: 'LAOAC',
        BARANGAY: 'CASANESTEBANAN',
    },
    {
        CITY: 'LAOAC',
        BARANGAY: 'CASANTIAGOAN',
    },
    {
        CITY: 'LAOAC',
        BARANGAY: 'DOMINGO ALARCIO (CABILAOAN EAST)',
    },
    {
        CITY: 'LAOAC',
        BARANGAY: 'INMANDUYAN',
    },
    {
        CITY: 'LAOAC',
        BARANGAY: 'LEBUEG',
    },
    {
        CITY: 'LAOAC',
        BARANGAY: 'MARABOC',
    },
    {
        CITY: 'LAOAC',
        BARANGAY: 'NANBAGATAN',
    },
    {
        CITY: 'LAOAC',
        BARANGAY: 'PANAGA',
    },
    {
        CITY: 'LAOAC',
        BARANGAY: 'POBLACION (LAOAC)',
    },
    {
        CITY: 'LAOAC',
        BARANGAY: 'TALOGTOG',
    },
    {
        CITY: 'LAOAC',
        BARANGAY: 'TURKO',
    },
    {
        CITY: 'LAOAC',
        BARANGAY: 'YATYAT',
    },
    {
        CITY: 'LINGAYEN',
        BARANGAY: 'ALIWEKWEK',
    },
    {
        CITY: 'LINGAYEN',
        BARANGAY: 'BAAY',
    },
    {
        CITY: 'LINGAYEN',
        BARANGAY: 'BALANGOBONG',
    },
    {
        CITY: 'LINGAYEN',
        BARANGAY: 'BALOCOC',
    },
    {
        CITY: 'LINGAYEN',
        BARANGAY: 'BANTAYAN',
    },
    {
        CITY: 'LINGAYEN',
        BARANGAY: 'BASING',
    },
    {
        CITY: 'LINGAYEN',
        BARANGAY: 'CAPANDANAN',
    },
    {
        CITY: 'LINGAYEN',
        BARANGAY: 'DOMALANDAN CENTER',
    },
    {
        CITY: 'LINGAYEN',
        BARANGAY: 'DOMALANDAN EAST',
    },
    {
        CITY: 'LINGAYEN',
        BARANGAY: 'DOMALANDAN WEST',
    },
    {
        CITY: 'LINGAYEN',
        BARANGAY: 'DORONGAN',
    },
    {
        CITY: 'LINGAYEN',
        BARANGAY: 'DULAG',
    },
    {
        CITY: 'LINGAYEN',
        BARANGAY: 'ESTANZA',
    },
    {
        CITY: 'LINGAYEN',
        BARANGAY: 'LASIP',
    },
    {
        CITY: 'LINGAYEN',
        BARANGAY: 'LIBSONG EAST',
    },
    {
        CITY: 'LINGAYEN',
        BARANGAY: 'LIBSONG WEST',
    },
    {
        CITY: 'LINGAYEN',
        BARANGAY: 'MALAWA',
    },
    {
        CITY: 'LINGAYEN',
        BARANGAY: 'MALIMPUEC',
    },
    {
        CITY: 'LINGAYEN',
        BARANGAY: 'MANIBOC',
    },
    {
        CITY: 'LINGAYEN',
        BARANGAY: 'MATALAVA',
    },
    {
        CITY: 'LINGAYEN',
        BARANGAY: 'NAGUELGUEL',
    },
    {
        CITY: 'LINGAYEN',
        BARANGAY: 'NAMOLAN',
    },
    {
        CITY: 'LINGAYEN',
        BARANGAY: 'PANGAPISAN NORTH',
    },
    {
        CITY: 'LINGAYEN',
        BARANGAY: 'PANGAPISAN SUR',
    },
    {
        CITY: 'LINGAYEN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'LINGAYEN',
        BARANGAY: 'QUIBAOL',
    },
    {
        CITY: 'LINGAYEN',
        BARANGAY: 'ROSARIO',
    },
    {
        CITY: 'LINGAYEN',
        BARANGAY: 'SABANGAN',
    },
    {
        CITY: 'LINGAYEN',
        BARANGAY: 'TALOGTOG',
    },
    {
        CITY: 'LINGAYEN',
        BARANGAY: 'TONTON',
    },
    {
        CITY: 'LINGAYEN',
        BARANGAY: 'TUMBAR',
    },
    {
        CITY: 'LINGAYEN',
        BARANGAY: 'WAWA',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'ABONAGAN',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'AGDAO',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'ALACAN',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'ALIAGA',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'AMACALAN',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'ANOLID',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'APAYA',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'ASIN ESTE',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'ASIN WESTE',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'BACUNDAO ESTE',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'BACUNDAO WESTE',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'BAKITIW',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'BALITE',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'BANAWANG',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'BARANG',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'BAWER',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'BINALAY',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'BOBON',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'BOLAOIT',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'BONGAR',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'BUTAO',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'CABATLING',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'CABATLING',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'CABUELDATAN',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'CALBUEG',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'CANAN NORTE',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'CANAN SUR',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'CAWAYAN BOGTONG',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'DON PEDRO',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'GATANG',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'GOLIMAN',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'GOMEZ',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'GUILIG',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'ICAN',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'INGALAGALA',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'LAREG-LAREG',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'LASIP',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'LEPA',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'LOQUEB ESTE',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'LOQUEB NORTE',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'LOQUEB SUR',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'LUNEC',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'MABULITEC',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'MALIMPEC',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'MANGGAN-DAMPAY',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'NALSIAN NORTE',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'NALSIAN SUR',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'NANCAPIAN',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'NANSANGAAN',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'OLEA',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'PACUAN',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'PALAPAR NORTE',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'PALAPAR SUR',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'PALONG',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'PAMARANUM',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'PASIMA',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'PAYAR',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'POLONG NORTE',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'POLONG SUR',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'POTIOCAN',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'SAN JULIAN',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'TABO-SILI',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'TALOSPATANG',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'TALOY',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'TALOYAN',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'TAMBAC',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'TOBOR',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'TOLONGUAT',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'TOMLING',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'UMANDO',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'VIADO',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'WAIG',
    },
    {
        CITY: 'MALASIQUI',
        BARANGAY: 'WAREY',
    },
    {
        CITY: 'MANAOAG',
        BARANGAY: 'BABASIT',
    },
    {
        CITY: 'MANAOAG',
        BARANGAY: 'BAGUINAY',
    },
    {
        CITY: 'MANAOAG',
        BARANGAY: 'BARITAO',
    },
    {
        CITY: 'MANAOAG',
        BARANGAY: 'BISAL',
    },
    {
        CITY: 'MANAOAG',
        BARANGAY: 'BUCAO',
    },
    {
        CITY: 'MANAOAG',
        BARANGAY: 'CABANBANAN',
    },
    {
        CITY: 'MANAOAG',
        BARANGAY: 'CALAOCAN',
    },
    {
        CITY: 'MANAOAG',
        BARANGAY: 'INAMOTAN',
    },
    {
        CITY: 'MANAOAG',
        BARANGAY: 'LELEMAAN',
    },
    {
        CITY: 'MANAOAG',
        BARANGAY: 'LICSI',
    },
    {
        CITY: 'MANAOAG',
        BARANGAY: 'LIPIT NORTE',
    },
    {
        CITY: 'MANAOAG',
        BARANGAY: 'LIPIT SUR',
    },
    {
        CITY: 'MANAOAG',
        BARANGAY: 'MATOLONG',
    },
    {
        CITY: 'MANAOAG',
        BARANGAY: 'MERMER',
    },
    {
        CITY: 'MANAOAG',
        BARANGAY: 'NALSIAN',
    },
    {
        CITY: 'MANAOAG',
        BARANGAY: 'ORAAN EAST',
    },
    {
        CITY: 'MANAOAG',
        BARANGAY: 'ORAAN WEST',
    },
    {
        CITY: 'MANAOAG',
        BARANGAY: 'PANTAL',
    },
    {
        CITY: 'MANAOAG',
        BARANGAY: 'PAO',
    },
    {
        CITY: 'MANAOAG',
        BARANGAY: 'PARIAN',
    },
    {
        CITY: 'MANAOAG',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'MANAOAG',
        BARANGAY: 'PUGARO',
    },
    {
        CITY: 'MANAOAG',
        BARANGAY: 'SAN RAMON',
    },
    {
        CITY: 'MANAOAG',
        BARANGAY: 'SANTA INES',
    },
    {
        CITY: 'MANAOAG',
        BARANGAY: 'SAPANG',
    },
    {
        CITY: 'MANAOAG',
        BARANGAY: 'TEBUEL',
    },
    {
        CITY: 'MANGALDAN',
        BARANGAY: 'ALITAYA',
    },
    {
        CITY: 'MANGALDAN',
        BARANGAY: 'AMANSABINA',
    },
    {
        CITY: 'MANGALDAN',
        BARANGAY: 'ANOLID',
    },
    {
        CITY: 'MANGALDAN',
        BARANGAY: 'BANAOANG',
    },
    {
        CITY: 'MANGALDAN',
        BARANGAY: 'BANTAYAN',
    },
    {
        CITY: 'MANGALDAN',
        BARANGAY: 'BARI',
    },
    {
        CITY: 'MANGALDAN',
        BARANGAY: 'BATENG',
    },
    {
        CITY: 'MANGALDAN',
        BARANGAY: 'BUENLAG',
    },
    {
        CITY: 'MANGALDAN',
        BARANGAY: 'DAVID',
    },
    {
        CITY: 'MANGALDAN',
        BARANGAY: 'EMBARCADERO',
    },
    {
        CITY: 'MANGALDAN',
        BARANGAY: 'GUEGUESANGEN',
    },
    {
        CITY: 'MANGALDAN',
        BARANGAY: 'GUESANG',
    },
    {
        CITY: 'MANGALDAN',
        BARANGAY: 'GUIGUILONEN',
    },
    {
        CITY: 'MANGALDAN',
        BARANGAY: 'GUILIG',
    },
    {
        CITY: 'MANGALDAN',
        BARANGAY: 'INLAMBO',
    },
    {
        CITY: 'MANGALDAN',
        BARANGAY: 'LANAS',
    },
    {
        CITY: 'MANGALDAN',
        BARANGAY: 'LANDAS',
    },
    {
        CITY: 'MANGALDAN',
        BARANGAY: 'MAASIN',
    },
    {
        CITY: 'MANGALDAN',
        BARANGAY: 'MACAYUG',
    },
    {
        CITY: 'MANGALDAN',
        BARANGAY: 'MALABAGO',
    },
    {
        CITY: 'MANGALDAN',
        BARANGAY: 'NAVALUAN',
    },
    {
        CITY: 'MANGALDAN',
        BARANGAY: 'NIBALIW',
    },
    {
        CITY: 'MANGALDAN',
        BARANGAY: 'OSIEM',
    },
    {
        CITY: 'MANGALDAN',
        BARANGAY: 'PALUA',
    },
    {
        CITY: 'MANGALDAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'MANGALDAN',
        BARANGAY: 'POGO',
    },
    {
        CITY: 'MANGALDAN',
        BARANGAY: 'SALAAN',
    },
    {
        CITY: 'MANGALDAN',
        BARANGAY: 'SALAY',
    },
    {
        CITY: 'MANGALDAN',
        BARANGAY: 'TALOGTOG',
    },
    {
        CITY: 'MANGALDAN',
        BARANGAY: 'TEBAG',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'ANDANGIN',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'ARELLANO STREET (POB.)',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'BANTAY',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'BANTOCALING',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'BARACBAC',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'BOGTONG BOLO',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'BOGTONG BUNAO',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'BOGTONG CENTRO',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'BOGTONG NIOG',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'BOGTONG SILAG',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'BUAYA',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'BUENLAG',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'BUENO',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'BUNAGAN',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'BUNLALACAO',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'BURGOS STREET (POB.)',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'CABALUYAN 1ST',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'CABALUYAN 2ND',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'CABARABUAN',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'CABARUAN',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'CABAYAOASAN',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'CABAYUGAN',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'CACAOITEN',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'CALUMBOYAN NORTE',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'CALUMBOYAN SUR',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'CALVO (POB.)',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'CASILAGAN',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'CATARATARAAN',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'CATURAY NORTE',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'CATURAY SUR',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'CAVIERNESAN',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'DORONGAN KETAKET',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'DORONGAN LINMANSANGAN',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'DORONGAN PUNTA',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'DORONGAN SAWAT',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'DORONGAN VALERIO',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'GENERAL LUNA (POB.)',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'HISTORIA',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'LAWAK LANGKA',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'LINMANSANGAN',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'LOPEZ (POB.)',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'MABINI (POB.)',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'MACARANG',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'MALABOBO',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'MALIBONG',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'MALUNEC',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'MARAVILLA (POB.)',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'MARAVILLA-ARELLANO EXT. (POB.)',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'MUELANG',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'NAGUILAYAN EAST',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'NAGUILAYAN WEST',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'NANCASALAN',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'NIOG-CABISON-BULANEY',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'OLEGARIO-CAOILE (POB.)',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'OLO CACAMPOSAN',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'OLO CAFABROSAN',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'OLO CAGARLITAN',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'OSMENA (POB.)',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'PACALAT',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'PAMPANO',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'PARIAN',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'PAUL',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'PEANIA PEDANIA (BEDANIA)',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'POGON-ANIAT',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'POGON-LOMBOY (POB.)',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'PONGLO-BALEG',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'PONGLO-MUELAG',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'QUETEGAN (POGON-BALEG)',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'QUEZON (POB.)',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'SALAVANTE',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'SAPANG',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'SONSON ONGKIT',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'SUACO',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'TAGAC',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'TAKIPAN',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'TALOGTOG',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'TOCOC BARIKIR',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'TORRE 1ST',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'TORRE 2ND',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'TORRES BUGALLON (POB.)',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'UMANGAN',
    },
    {
        CITY: 'MANGATAREM',
        BARANGAY: 'ZAMORA (POB.)',
    },
    {
        CITY: 'MAPANDAN',
        BARANGAY: 'AMANOAOAC',
    },
    {
        CITY: 'MAPANDAN',
        BARANGAY: 'APAYA',
    },
    {
        CITY: 'MAPANDAN',
        BARANGAY: 'ASERDA',
    },
    {
        CITY: 'MAPANDAN',
        BARANGAY: 'BALOLING',
    },
    {
        CITY: 'MAPANDAN',
        BARANGAY: 'CORAL',
    },
    {
        CITY: 'MAPANDAN',
        BARANGAY: 'GOLDEN',
    },
    {
        CITY: 'MAPANDAN',
        BARANGAY: 'JIMENEZ',
    },
    {
        CITY: 'MAPANDAN',
        BARANGAY: 'LAMBAYAN',
    },
    {
        CITY: 'MAPANDAN',
        BARANGAY: 'LUYAN (LUYAN SOUTH)',
    },
    {
        CITY: 'MAPANDAN',
        BARANGAY: 'NILOMBOT',
    },
    {
        CITY: 'MAPANDAN',
        BARANGAY: 'PIAS',
    },
    {
        CITY: 'MAPANDAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'MAPANDAN',
        BARANGAY: 'PRIMICIAS',
    },
    {
        CITY: 'MAPANDAN',
        BARANGAY: 'SANTA MARIA (LUYAN NORTH)',
    },
    {
        CITY: 'MAPANDAN',
        BARANGAY: 'TORRES',
    },
    {
        CITY: 'NATIVIDAD',
        BARANGAY: 'BARANGOBONG',
    },
    {
        CITY: 'NATIVIDAD',
        BARANGAY: 'BATCHELOR EAST',
    },
    {
        CITY: 'NATIVIDAD',
        BARANGAY: 'BATCHELOR WEST',
    },
    {
        CITY: 'NATIVIDAD',
        BARANGAY: 'BURGOS (SAN NARCISO)',
    },
    {
        CITY: 'NATIVIDAD',
        BARANGAY: 'CACANDUNGAN',
    },
    {
        CITY: 'NATIVIDAD',
        BARANGAY: 'CALAPUGAN',
    },
    {
        CITY: 'NATIVIDAD',
        BARANGAY: 'CANAREM',
    },
    {
        CITY: 'NATIVIDAD',
        BARANGAY: 'LUNA',
    },
    {
        CITY: 'NATIVIDAD',
        BARANGAY: 'POBLACION EAST',
    },
    {
        CITY: 'NATIVIDAD',
        BARANGAY: 'POBLACION WEST',
    },
    {
        CITY: 'NATIVIDAD',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'NATIVIDAD',
        BARANGAY: 'SALUD',
    },
    {
        CITY: 'NATIVIDAD',
        BARANGAY: 'SAN EUGENIO',
    },
    {
        CITY: 'NATIVIDAD',
        BARANGAY: 'SAN MACARIO NORTE',
    },
    {
        CITY: 'NATIVIDAD',
        BARANGAY: 'SAN MACARIO SUR',
    },
    {
        CITY: 'NATIVIDAD',
        BARANGAY: 'SAN MAXIMO',
    },
    {
        CITY: 'NATIVIDAD',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'NATIVIDAD',
        BARANGAY: 'SILAG',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'ANULID',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'ATAINAN',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'BERSAMIN',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'CANARVACANAN',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'CARANGLAAN',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'CURARENG',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'GUALSIC',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'KASIKIS',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'LAOAC',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'MACAYO',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'PINDANGAN CENTRO',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'PINDANGAN EAST',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'PINDANGAN WEST',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'POBLACION EAST',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'POBLACION WEST',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'SAN NICOLAS',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'SAN PEDRO APARTADO',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'SAN PEDRO ILI',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'ALCALA',
        BARANGAY: 'VACANTE',
    },
    {
        CITY: 'ANDA',
        BARANGAY: 'AWAG',
    },
    {
        CITY: 'ANDA',
        BARANGAY: 'AWILE',
    },
    {
        CITY: 'ANDA',
        BARANGAY: 'BATIARAO',
    },
    {
        CITY: 'ANDA',
        BARANGAY: 'CABUNGAN',
    },
    {
        CITY: 'ANDA',
        BARANGAY: 'CAROT',
    },
    {
        CITY: 'ANDA',
        BARANGAY: 'DOLAOAN',
    },
    {
        CITY: 'ANDA',
        BARANGAY: 'IMBO',
    },
    {
        CITY: 'ANDA',
        BARANGAY: 'MACALEENG',
    },
    {
        CITY: 'ANDA',
        BARANGAY: 'MACANDOCANDONG',
    },
    {
        CITY: 'ANDA',
        BARANGAY: 'MAL-ONG',
    },
    {
        CITY: 'ANDA',
        BARANGAY: 'NAMAGBAGAN',
    },
    {
        CITY: 'ANDA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'ANDA',
        BARANGAY: 'ROXAS',
    },
    {
        CITY: 'ANDA',
        BARANGAY: 'SABLIG',
    },
    {
        CITY: 'ANDA',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'ANDA',
        BARANGAY: 'SIAPAR',
    },
    {
        CITY: 'ANDA',
        BARANGAY: 'TONDOL',
    },
    {
        CITY: 'ANDA',
        BARANGAY: 'TORITORI',
    },
    {
        CITY: 'PANGASINAN-BURGOS',
        BARANGAY: 'ANAPAO (BUR ANAPAC)',
    },
    {
        CITY: 'PANGASINAN-BURGOS',
        BARANGAY: 'CACAYASEN',
    },
    {
        CITY: 'PANGASINAN-BURGOS',
        BARANGAY: 'CONCORDIA',
    },
    {
        CITY: 'PANGASINAN-BURGOS',
        BARANGAY: 'DON MATIAS',
    },
    {
        CITY: 'PANGASINAN-BURGOS',
        BARANGAY: 'ILIO-ILIO (ILIW-ILIW)',
    },
    {
        CITY: 'PANGASINAN-BURGOS',
        BARANGAY: 'PAPALLASEN',
    },
    {
        CITY: 'PANGASINAN-BURGOS',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'PANGASINAN-BURGOS',
        BARANGAY: 'POGORUAC',
    },
    {
        CITY: 'PANGASINAN-BURGOS',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'PANGASINAN-BURGOS',
        BARANGAY: 'SAN PASCUAL',
    },
    {
        CITY: 'PANGASINAN-BURGOS',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'PANGASINAN-BURGOS',
        BARANGAY: 'SAPA GRANDE',
    },
    {
        CITY: 'PANGASINAN-BURGOS',
        BARANGAY: 'SAPA PEQUENA',
    },
    {
        CITY: 'PANGASINAN-BURGOS',
        BARANGAY: 'TAMBACAN',
    },
    {
        CITY: 'INFANTA',
        BARANGAY: 'BABUYAN',
    },
    {
        CITY: 'INFANTA',
        BARANGAY: 'BAMBAN',
    },
    {
        CITY: 'INFANTA',
        BARANGAY: 'BATANG',
    },
    {
        CITY: 'INFANTA',
        BARANGAY: 'BAYAMBANG',
    },
    {
        CITY: 'INFANTA',
        BARANGAY: 'CATO',
    },
    {
        CITY: 'INFANTA',
        BARANGAY: 'DOLIMAN',
    },
    {
        CITY: 'INFANTA',
        BARANGAY: 'FATIMA',
    },
    {
        CITY: 'INFANTA',
        BARANGAY: 'MAYA',
    },
    {
        CITY: 'INFANTA',
        BARANGAY: 'NANGALISAN',
    },
    {
        CITY: 'INFANTA',
        BARANGAY: 'NAYOM',
    },
    {
        CITY: 'INFANTA',
        BARANGAY: 'PITA',
    },
    {
        CITY: 'INFANTA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'INFANTA',
        BARANGAY: 'POTOL',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'BACNIT',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'BARLO',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'CAABIANGAAN',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'CABANAETAN',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'CABINUANGAN',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'CALZADA',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'CARANGLAAN',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'DE GUZMAN',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'LUNA',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'MAGALONG',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'NIBALIW',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'PATAR',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'TAGUDIN',
    },
    {
        CITY: 'MABINI',
        BARANGAY: 'VILLACORTA',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'ABANON',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'AGDAO',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'ANANDO',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'ANO',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'ANTIPANGOL',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'APONIT',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'BACNAR',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'BALAYA',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'BALAYONG',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'BALDOG',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'BALITE SUR',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'BALOCOC',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'BANI',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'BEGA',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'BOCBOC',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'BOGAOAN',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'BOLINGIT',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'BOLOSAN',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'BONIFACIO (POB.)',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'BUENGLAT',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'BUGALLON-POSADAS STREET (POB.)',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'BURGOS PADLAN (POB.)',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'CACARITAN',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'CAINGAL',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'CALOBAOAN',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'CALOMBOYAN',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'CAOAYAN-KILING',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'CAPATAAN',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'COBOL',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'COLILING',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'CRUZ',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'DOYONG',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'GAMATA',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'GUELEW',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'ILANG',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'INERANGAN',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'ISLA',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'LIBAS',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'LILIMASAN',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'LONGOS',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'LUCBAN (POB.)',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'M. SORIANO',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'MABALBALINO',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'MABINI (POB.)',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'MAGTAKING',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'MALACANANG',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'MALIWARA',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'MAMARLAO',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'MANZON',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'MATAGDEM',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'MESTIZO NORTE',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'NAGUILAYAN',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'NILENTAP',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'PADILLA-GOMEZ',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'PAGAL',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'PAITAN-PANOYPOY',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'PALAMING',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'PALARIS (POB.)',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'PALOSPOS',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'PANGALANGAN',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'PANGOLOAN',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'PANGPANG',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'PARAYAO',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'PAYAPA',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'PAYAR',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'PEREZ BOULEVARD (POB.)',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'PNR STATION SITE',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'POLO',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'QUEZON BOULEVARD (POB.)',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'QUINTONG',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'RIZAL (POB.)',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'ROXAS BOULEVARD (POB.)',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'SALINAP',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'SAN PEDRO-TALOY',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'SAPINIT',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'SUPO',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'TALANG',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'TAMAYO',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'TANDANG SORA',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'TANDOC',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'TARECE',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'TARECTEC',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'TAYAMBANI',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'TEBAG',
    },
    {
        CITY: 'SAN-CARLOS',
        BARANGAY: 'TURAC',
    },
    {
        CITY: 'SAN-JACINTO',
        BARANGAY: 'AWAI',
    },
    {
        CITY: 'SAN-JACINTO',
        BARANGAY: 'BAGONG PAG-ASA (POBLACION EAST)',
    },
    {
        CITY: 'SAN-JACINTO',
        BARANGAY: 'BOLO',
    },
    {
        CITY: 'SAN-JACINTO',
        BARANGAY: 'CAPAOAY (POB.)',
    },
    {
        CITY: 'SAN-JACINTO',
        BARANGAY: 'CASIBONG',
    },
    {
        CITY: 'SAN-JACINTO',
        BARANGAY: 'GUIBEL',
    },
    {
        CITY: 'SAN-JACINTO',
        BARANGAY: 'IMELDA (DECRITO)',
    },
    {
        CITY: 'SAN-JACINTO',
        BARANGAY: 'LABNEY',
    },
    {
        CITY: 'SAN-JACINTO',
        BARANGAY: 'LOBONG',
    },
    {
        CITY: 'SAN-JACINTO',
        BARANGAY: 'MACAYUG',
    },
    {
        CITY: 'SAN-JACINTO',
        BARANGAY: 'MAGSAYSAY (CAPAY)',
    },
    {
        CITY: 'SAN-JACINTO',
        BARANGAY: 'SAN GUILLERMO (POBLACION WEST)',
    },
    {
        CITY: 'SAN-JACINTO',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'SAN-JACINTO',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'SAN-JACINTO',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'SAN-JACINTO',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'SAN-JACINTO',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'SAN-JACINTO',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'SAN-JACINTO',
        BARANGAY: 'SANTO TOMAS',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'CABACARAAN',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'CABARITAN',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'FLORES',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'GUISET NORTE (POB.)',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'GUISET SUR (POB.)',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'LAPALO',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'NAGSAAG',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'NARRA',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'SAN ANTONIO-ARZADON',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'SAN BONIFACIO',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'SAN-MANUEL',
        BARANGAY: 'SANTO DOMINGO',
    },
    {
        CITY: 'SAN-NICOLAS',
        BARANGAY: 'BENSICAN',
    },
    {
        CITY: 'SAN-NICOLAS',
        BARANGAY: 'CABITNONGAN',
    },
    {
        CITY: 'SAN-NICOLAS',
        BARANGAY: 'CABOLOAN',
    },
    {
        CITY: 'SAN-NICOLAS',
        BARANGAY: 'CACABUGAOAN',
    },
    {
        CITY: 'SAN-NICOLAS',
        BARANGAY: 'CALANUTIAN',
    },
    {
        CITY: 'SAN-NICOLAS',
        BARANGAY: 'CALAOCAN',
    },
    {
        CITY: 'SAN-NICOLAS',
        BARANGAY: 'CAMANGGAAN',
    },
    {
        CITY: 'SAN-NICOLAS',
        BARANGAY: 'CAMINDOROAN',
    },
    {
        CITY: 'SAN-NICOLAS',
        BARANGAY: 'CASARATAN',
    },
    {
        CITY: 'SAN-NICOLAS',
        BARANGAY: 'DALUMPINAS',
    },
    {
        CITY: 'SAN-NICOLAS',
        BARANGAY: 'FIANZA',
    },
    {
        CITY: 'SAN-NICOLAS',
        BARANGAY: 'LUNGAO',
    },
    {
        CITY: 'SAN-NICOLAS',
        BARANGAY: 'MALICO',
    },
    {
        CITY: 'SAN-NICOLAS',
        BARANGAY: 'MALILION',
    },
    {
        CITY: 'SAN-NICOLAS',
        BARANGAY: 'NAGKAYSA',
    },
    {
        CITY: 'SAN-NICOLAS',
        BARANGAY: 'NINING',
    },
    {
        CITY: 'SAN-NICOLAS',
        BARANGAY: 'POBLACION EAST',
    },
    {
        CITY: 'SAN-NICOLAS',
        BARANGAY: 'POBLACION WEST',
    },
    {
        CITY: 'SAN-NICOLAS',
        BARANGAY: 'SALINGCOB',
    },
    {
        CITY: 'SAN-NICOLAS',
        BARANGAY: 'SALPAD',
    },
    {
        CITY: 'SAN-NICOLAS',
        BARANGAY: 'SAN FELIPE EAST',
    },
    {
        CITY: 'SAN-NICOLAS',
        BARANGAY: 'SAN FELIPE WEST',
    },
    {
        CITY: 'SAN-NICOLAS',
        BARANGAY: 'SAN ISIDRO (STA. CRUZAN)',
    },
    {
        CITY: 'SAN-NICOLAS',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'SAN-NICOLAS',
        BARANGAY: 'SAN RAFAEL CENTRO',
    },
    {
        CITY: 'SAN-NICOLAS',
        BARANGAY: 'SAN RAFAEL EAST',
    },
    {
        CITY: 'SAN-NICOLAS',
        BARANGAY: 'SAN RAFAEL WEST',
    },
    {
        CITY: 'SAN-NICOLAS',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'SAN-NICOLAS',
        BARANGAY: 'SANTA MARIA EAST',
    },
    {
        CITY: 'SAN-NICOLAS',
        BARANGAY: 'SANTA MARIA WEST',
    },
    {
        CITY: 'SAN-NICOLAS',
        BARANGAY: 'SANTO TOMAS',
    },
    {
        CITY: 'SAN-NICOLAS',
        BARANGAY: 'SIBLOT',
    },
    {
        CITY: 'SAN-NICOLAS',
        BARANGAY: 'SOBOL',
    },
    {
        CITY: 'SAN-QUINTIN',
        BARANGAY: 'ALAC',
    },
    {
        CITY: 'SAN-QUINTIN',
        BARANGAY: 'BALIGAYAN',
    },
    {
        CITY: 'SAN-QUINTIN',
        BARANGAY: 'BANTOG',
    },
    {
        CITY: 'SAN-QUINTIN',
        BARANGAY: 'BOLINTAGUEN',
    },
    {
        CITY: 'SAN-QUINTIN',
        BARANGAY: 'CABALAOANGAN',
    },
    {
        CITY: 'SAN-QUINTIN',
        BARANGAY: 'CABANGARAN',
    },
    {
        CITY: 'SAN-QUINTIN',
        BARANGAY: 'CALOMBOYAN',
    },
    {
        CITY: 'SAN-QUINTIN',
        BARANGAY: 'CARAYACAN',
    },
    {
        CITY: 'SAN-QUINTIN',
        BARANGAY: 'CASANTAMARIAN',
    },
    {
        CITY: 'SAN-QUINTIN',
        BARANGAY: 'GONZALO',
    },
    {
        CITY: 'SAN-QUINTIN',
        BARANGAY: 'LABUAN',
    },
    {
        CITY: 'SAN-QUINTIN',
        BARANGAY: 'LAGASIT',
    },
    {
        CITY: 'SAN-QUINTIN',
        BARANGAY: 'LUMAYAO',
    },
    {
        CITY: 'SAN-QUINTIN',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'SAN-QUINTIN',
        BARANGAY: 'MANTACDANG',
    },
    {
        CITY: 'SAN-QUINTIN',
        BARANGAY: 'NANGAPUGAN',
    },
    {
        CITY: 'SAN-QUINTIN',
        BARANGAY: 'POBLACION ZONE I',
    },
    {
        CITY: 'SAN-QUINTIN',
        BARANGAY: 'POBLACION ZONE II',
    },
    {
        CITY: 'SAN-QUINTIN',
        BARANGAY: 'POBLACION ZONE III',
    },
    {
        CITY: 'SAN-QUINTIN',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'SAN-QUINTIN',
        BARANGAY: 'UNGIB',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'ALIBAGO',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'BALINGUEO',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'BANAOANG',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'BANZAL',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'BOTAO',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'CABLONG',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'CARUSOCAN',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'DALONGUE',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'ERFE',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'GUEGUESANGEN',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'LEET',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'MALANAY',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'MANINGDING',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'MARONONG',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'MATICMATIC',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'MINIEN EAST',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'MINIEN WEST',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'NILOMBOT',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'PATAYAC',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'PAYAS',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'POBLACION NORTE',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'POBLACION SUR',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'PRIMICIAS (VENTINILLA WEST)',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'SAPANG',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'SONQUIL',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'TEBAG EAST',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'TEBAG WEST',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'TULIAO',
    },
    {
        CITY: 'SANTA-BARBARA',
        BARANGAY: 'VENTINILLA (VENTINILLA EAST)',
    },
    {
        CITY: 'PANGASINAN-SANTA-MARIA',
        BARANGAY: 'BAL-LOY',
    },
    {
        CITY: 'PANGASINAN-SANTA-MARIA',
        BARANGAY: 'BANTOG',
    },
    {
        CITY: 'PANGASINAN-SANTA-MARIA',
        BARANGAY: 'CABOLUAN',
    },
    {
        CITY: 'PANGASINAN-SANTA-MARIA',
        BARANGAY: 'CAL-LITANG',
    },
    {
        CITY: 'PANGASINAN-SANTA-MARIA',
        BARANGAY: 'CAPANDANAN',
    },
    {
        CITY: 'PANGASINAN-SANTA-MARIA',
        BARANGAY: 'CAUPLASAN',
    },
    {
        CITY: 'PANGASINAN-SANTA-MARIA',
        BARANGAY: 'DALAYAP',
    },
    {
        CITY: 'PANGASINAN-SANTA-MARIA',
        BARANGAY: 'LIBSONG',
    },
    {
        CITY: 'PANGASINAN-SANTA-MARIA',
        BARANGAY: 'NAMAGBAGAN',
    },
    {
        CITY: 'PANGASINAN-SANTA-MARIA',
        BARANGAY: 'PAITAN',
    },
    {
        CITY: 'PANGASINAN-SANTA-MARIA',
        BARANGAY: 'PATAQUID',
    },
    {
        CITY: 'PANGASINAN-SANTA-MARIA',
        BARANGAY: 'PILAR',
    },
    {
        CITY: 'PANGASINAN-SANTA-MARIA',
        BARANGAY: 'POBLACION EAST',
    },
    {
        CITY: 'PANGASINAN-SANTA-MARIA',
        BARANGAY: 'POBLACION WEST',
    },
    {
        CITY: 'PANGASINAN-SANTA-MARIA',
        BARANGAY: 'PUGOT',
    },
    {
        CITY: 'PANGASINAN-SANTA-MARIA',
        BARANGAY: 'SAMON',
    },
    {
        CITY: 'PANGASINAN-SANTA-MARIA',
        BARANGAY: 'SAN ALEJANDRO',
    },
    {
        CITY: 'PANGASINAN-SANTA-MARIA',
        BARANGAY: 'SAN MARIANO',
    },
    {
        CITY: 'PANGASINAN-SANTA-MARIA',
        BARANGAY: 'SAN PABLO',
    },
    {
        CITY: 'PANGASINAN-SANTA-MARIA',
        BARANGAY: 'SAN PATRICIO',
    },
    {
        CITY: 'PANGASINAN-SANTA-MARIA',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'PANGASINAN-SANTA-MARIA',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'PANGASINAN-SANTA-MARIA',
        BARANGAY: 'SANTA ROSA',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'LA LUNA',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'POBLACION EAST',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'POBLACION WEST',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'SAN MARCOS',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'SANTO DOMINGO',
    },
    {
        CITY: 'SANTO-TOMAS',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'SISON',
        BARANGAY: 'AGAT',
    },
    {
        CITY: 'SISON',
        BARANGAY: 'ALIBENG',
    },
    {
        CITY: 'SISON',
        BARANGAY: 'AMAGBAGAN',
    },
    {
        CITY: 'SISON',
        BARANGAY: 'ARTACHO',
    },
    {
        CITY: 'SISON',
        BARANGAY: 'ASAN NORTE',
    },
    {
        CITY: 'SISON',
        BARANGAY: 'ASAN SUR',
    },
    {
        CITY: 'SISON',
        BARANGAY: 'BANTAY INSIK',
    },
    {
        CITY: 'SISON',
        BARANGAY: 'BILA',
    },
    {
        CITY: 'SISON',
        BARANGAY: 'BINMECKEG',
    },
    {
        CITY: 'SISON',
        BARANGAY: 'BULAOEN EAST',
    },
    {
        CITY: 'SISON',
        BARANGAY: 'BULAOEN WEST',
    },
    {
        CITY: 'SISON',
        BARANGAY: 'CABARITAN',
    },
    {
        CITY: 'SISON',
        BARANGAY: 'CALUNETAN',
    },
    {
        CITY: 'SISON',
        BARANGAY: 'CAMANGAAN',
    },
    {
        CITY: 'SISON',
        BARANGAY: 'CAURINGAN',
    },
    {
        CITY: 'SISON',
        BARANGAY: 'DUNGON',
    },
    {
        CITY: 'SISON',
        BARANGAY: 'ESPERANZA',
    },
    {
        CITY: 'SISON',
        BARANGAY: 'INMALOG',
    },
    {
        CITY: 'SISON',
        BARANGAY: 'KILLO',
    },
    {
        CITY: 'SISON',
        BARANGAY: 'LABAYUG',
    },
    {
        CITY: 'SISON',
        BARANGAY: 'PALDIT',
    },
    {
        CITY: 'SISON',
        BARANGAY: 'PINDANGAN',
    },
    {
        CITY: 'SISON',
        BARANGAY: 'PINMILAPIL',
    },
    {
        CITY: 'SISON',
        BARANGAY: 'POBLACION CENTRAL',
    },
    {
        CITY: 'SISON',
        BARANGAY: 'POBLACION NORTE',
    },
    {
        CITY: 'SISON',
        BARANGAY: 'POBLACION SUR',
    },
    {
        CITY: 'SISON',
        BARANGAY: 'SAGUNTO',
    },
    {
        CITY: 'SISON',
        BARANGAY: 'TARA-TARA',
    },
    {
        CITY: 'POZORRUBIO',
        BARANGAY: 'ALIPANGPANG',
    },
    {
        CITY: 'POZORRUBIO',
        BARANGAY: 'AMAGBAGAN',
    },
    {
        CITY: 'POZORRUBIO',
        BARANGAY: 'BALACAG',
    },
    {
        CITY: 'POZORRUBIO',
        BARANGAY: 'BANDING',
    },
    {
        CITY: 'POZORRUBIO',
        BARANGAY: 'BANTUGAN',
    },
    {
        CITY: 'POZORRUBIO',
        BARANGAY: 'BATAKIL',
    },
    {
        CITY: 'POZORRUBIO',
        BARANGAY: 'BOBONAN',
    },
    {
        CITY: 'POZORRUBIO',
        BARANGAY: 'BUNEG',
    },
    {
        CITY: 'POZORRUBIO',
        BARANGAY: 'CABLONG',
    },
    {
        CITY: 'POZORRUBIO',
        BARANGAY: 'CASANFERNANDOAN',
    },
    {
        CITY: 'POZORRUBIO',
        BARANGAY: 'CASTANO',
    },
    {
        CITY: 'POZORRUBIO',
        BARANGAY: 'DILAN',
    },
    {
        CITY: 'POZORRUBIO',
        BARANGAY: 'DON BENITO',
    },
    {
        CITY: 'POZORRUBIO',
        BARANGAY: 'HAWAY',
    },
    {
        CITY: 'POZORRUBIO',
        BARANGAY: 'IMBALBALATONG',
    },
    {
        CITY: 'POZORRUBIO',
        BARANGAY: 'INOMAN',
    },
    {
        CITY: 'POZORRUBIO',
        BARANGAY: 'LAOAC',
    },
    {
        CITY: 'POZORRUBIO',
        BARANGAY: 'MAAMBAL',
    },
    {
        CITY: 'POZORRUBIO',
        BARANGAY: 'MALASIN',
    },
    {
        CITY: 'POZORRUBIO',
        BARANGAY: 'MALOKIAT',
    },
    {
        CITY: 'POZORRUBIO',
        BARANGAY: 'MANAOL',
    },
    {
        CITY: 'POZORRUBIO',
        BARANGAY: 'NAMA',
    },
    {
        CITY: 'POZORRUBIO',
        BARANGAY: 'NANTANGALAN',
    },
    {
        CITY: 'POZORRUBIO',
        BARANGAY: 'PALACPALAC',
    },
    {
        CITY: 'POZORRUBIO',
        BARANGAY: 'PALGUYOD',
    },
    {
        CITY: 'POZORRUBIO',
        BARANGAY: 'POBLACION I',
    },
    {
        CITY: 'POZORRUBIO',
        BARANGAY: 'POBLACION II',
    },
    {
        CITY: 'POZORRUBIO',
        BARANGAY: 'POBLACION III',
    },
    {
        CITY: 'POZORRUBIO',
        BARANGAY: 'POBLACION IV',
    },
    {
        CITY: 'POZORRUBIO',
        BARANGAY: 'ROSARIO',
    },
    {
        CITY: 'POZORRUBIO',
        BARANGAY: 'SUGCONG',
    },
    {
        CITY: 'POZORRUBIO',
        BARANGAY: 'TALOGTOG',
    },
    {
        CITY: 'POZORRUBIO',
        BARANGAY: 'TULNAC',
    },
    {
        CITY: 'POZORRUBIO',
        BARANGAY: 'VILLEGAS',
    },
    {
        CITY: 'ROSALES',
        BARANGAY: 'ACOP',
    },
    {
        CITY: 'ROSALES',
        BARANGAY: 'BAKITBAKIT',
    },
    {
        CITY: 'ROSALES',
        BARANGAY: 'BALINGCANAWAY',
    },
    {
        CITY: 'ROSALES',
        BARANGAY: 'CABALAOANGAN NORTE',
    },
    {
        CITY: 'ROSALES',
        BARANGAY: 'CABALAOANGAN SUR',
    },
    {
        CITY: 'ROSALES',
        BARANGAY: 'CALANUTAN (DON FELIX COLOMA)',
    },
    {
        CITY: 'ROSALES',
        BARANGAY: 'CAMANGAAN',
    },
    {
        CITY: 'ROSALES',
        BARANGAY: 'CAPITAN TOMAS',
    },
    {
        CITY: 'ROSALES',
        BARANGAY: 'CARMAY EAST',
    },
    {
        CITY: 'ROSALES',
        BARANGAY: 'CARMAY WEST',
    },
    {
        CITY: 'ROSALES',
        BARANGAY: 'CARMEN EAST',
    },
    {
        CITY: 'ROSALES',
        BARANGAY: 'CARMEN WEST',
    },
    {
        CITY: 'ROSALES',
        BARANGAY: 'CASANICOLASAN',
    },
    {
        CITY: 'ROSALES',
        BARANGAY: 'COLILING',
    },
    {
        CITY: 'ROSALES',
        BARANGAY: 'DON ANTONIO VILLAGE',
    },
    {
        CITY: 'ROSALES',
        BARANGAY: 'GUILING',
    },
    {
        CITY: 'ROSALES',
        BARANGAY: 'PALAKIPAK',
    },
    {
        CITY: 'ROSALES',
        BARANGAY: 'PANGAOAN',
    },
    {
        CITY: 'ROSALES',
        BARANGAY: 'RABAGO',
    },
    {
        CITY: 'ROSALES',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'ROSALES',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'ROSALES',
        BARANGAY: 'SAN ANGEL',
    },
    {
        CITY: 'ROSALES',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'ROSALES',
        BARANGAY: 'SAN BARTOLOME',
    },
    {
        CITY: 'ROSALES',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'ROSALES',
        BARANGAY: 'SAN LUIS',
    },
    {
        CITY: 'ROSALES',
        BARANGAY: 'SAN PEDRO EAST',
    },
    {
        CITY: 'ROSALES',
        BARANGAY: 'SAN PEDRO WEST',
    },
    {
        CITY: 'ROSALES',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'ROSALES',
        BARANGAY: 'STATION DISTRICT',
    },
    {
        CITY: 'ROSALES',
        BARANGAY: 'TOMANA EAST',
    },
    {
        CITY: 'ROSALES',
        BARANGAY: 'TOMANA WEST',
    },
    {
        CITY: 'ROSALES',
        BARANGAY: 'ZONE I (POB.)',
    },
    {
        CITY: 'ROSALES',
        BARANGAY: 'ZONE II (POB.)',
    },
    {
        CITY: 'ROSALES',
        BARANGAY: 'ZONE III (POB.)',
    },
    {
        CITY: 'ROSALES',
        BARANGAY: 'ZONE IV (POB.)',
    },
    {
        CITY: 'ROSALES',
        BARANGAY: 'ZONE V (POB.)',
    },
    {
        CITY: 'SAN-FABIAN',
        BARANGAY: 'ALACAN',
    },
    {
        CITY: 'SAN-FABIAN',
        BARANGAY: 'AMBALANGAN-DALIN',
    },
    {
        CITY: 'SAN-FABIAN',
        BARANGAY: 'ANGIO',
    },
    {
        CITY: 'SAN-FABIAN',
        BARANGAY: 'ANONANG',
    },
    {
        CITY: 'SAN-FABIAN',
        BARANGAY: 'ARAMAL',
    },
    {
        CITY: 'SAN-FABIAN',
        BARANGAY: 'BIGBIGA',
    },
    {
        CITY: 'SAN-FABIAN',
        BARANGAY: 'BINDAY',
    },
    {
        CITY: 'SAN-FABIAN',
        BARANGAY: 'BOLAOEN',
    },
    {
        CITY: 'SAN-FABIAN',
        BARANGAY: 'BOLASI',
    },
    {
        CITY: 'SAN-FABIAN',
        BARANGAY: 'CABARUAN',
    },
    {
        CITY: 'SAN-FABIAN',
        BARANGAY: 'CAYANGA',
    },
    {
        CITY: 'SAN-FABIAN',
        BARANGAY: 'COLISAO',
    },
    {
        CITY: 'SAN-FABIAN',
        BARANGAY: 'GOMOT',
    },
    {
        CITY: 'SAN-FABIAN',
        BARANGAY: 'INMALOG',
    },
    {
        CITY: 'SAN-FABIAN',
        BARANGAY: 'INMALOG NORTE',
    },
    {
        CITY: 'SAN-FABIAN',
        BARANGAY: 'LEKEP-BUTAO',
    },
    {
        CITY: 'SAN-FABIAN',
        BARANGAY: 'LIPIT-TOMEENG',
    },
    {
        CITY: 'SAN-FABIAN',
        BARANGAY: 'LONGOS',
    },
    {
        CITY: 'SAN-FABIAN',
        BARANGAY: 'LONGOS PROPER',
    },
    {
        CITY: 'SAN-FABIAN',
        BARANGAY: 'LONGOS-AMANGONAN-PARAC-PARAC FABRICA',
    },
    {
        CITY: 'SAN-FABIAN',
        BARANGAY: 'MABILAO',
    },
    {
        CITY: 'SAN-FABIAN',
        BARANGAY: 'NIBALIW CENTRAL',
    },
    {
        CITY: 'SAN-FABIAN',
        BARANGAY: 'NIBALIW EAST',
    },
    {
        CITY: 'SAN-FABIAN',
        BARANGAY: 'NIBALIW MAGLIBA',
    },
    {
        CITY: 'SAN-FABIAN',
        BARANGAY: 'NIBALIW NARVARTE (NIBALIW WEST COMPOUND)',
    },
    {
        CITY: 'SAN-FABIAN',
        BARANGAY: 'NIBALIW VIDAL (NIBALIW WEST PROPER)',
    },
    {
        CITY: 'SAN-FABIAN',
        BARANGAY: 'PALAPAD',
    },
    {
        CITY: 'SAN-FABIAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SAN-FABIAN',
        BARANGAY: 'RABON',
    },
    {
        CITY: 'SAN-FABIAN',
        BARANGAY: 'SAGUD-BAHLEY',
    },
    {
        CITY: 'SAN-FABIAN',
        BARANGAY: 'SOBOL',
    },
    {
        CITY: 'SAN-FABIAN',
        BARANGAY: 'TEMPRA-GUILIG',
    },
    {
        CITY: 'SAN-FABIAN',
        BARANGAY: 'TIBLONG',
    },
    {
        CITY: 'SAN-FABIAN',
        BARANGAY: 'TOCOK',
    },
    {
        CITY: 'SUAL',
        BARANGAY: 'BAQUIOEN',
    },
    {
        CITY: 'SUAL',
        BARANGAY: 'BAYBAY NORTE',
    },
    {
        CITY: 'SUAL',
        BARANGAY: 'BAYBAY SUR',
    },
    {
        CITY: 'SUAL',
        BARANGAY: 'BOLAOEN',
    },
    {
        CITY: 'SUAL',
        BARANGAY: 'CABALITIAN',
    },
    {
        CITY: 'SUAL',
        BARANGAY: 'CALUMBUYAN',
    },
    {
        CITY: 'SUAL',
        BARANGAY: 'CAMAGSINGALAN',
    },
    {
        CITY: 'SUAL',
        BARANGAY: 'CAOAYAN',
    },
    {
        CITY: 'SUAL',
        BARANGAY: 'CAPANTOLAN',
    },
    {
        CITY: 'SUAL',
        BARANGAY: 'MACAYCAYAWAN',
    },
    {
        CITY: 'SUAL',
        BARANGAY: 'PAITAN EAST',
    },
    {
        CITY: 'SUAL',
        BARANGAY: 'PAITAN WEST',
    },
    {
        CITY: 'SUAL',
        BARANGAY: 'PANGASCASAN',
    },
    {
        CITY: 'SUAL',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SUAL',
        BARANGAY: 'SANTO DOMINGO',
    },
    {
        CITY: 'SUAL',
        BARANGAY: 'SESELANGEN',
    },
    {
        CITY: 'SUAL',
        BARANGAY: 'SIOASIO EAST',
    },
    {
        CITY: 'SUAL',
        BARANGAY: 'SIOASIO WEST',
    },
    {
        CITY: 'SUAL',
        BARANGAY: 'VICTORIA',
    },
    {
        CITY: 'TAYUG',
        BARANGAY: 'AGNO',
    },
    {
        CITY: 'TAYUG',
        BARANGAY: 'AMISTAD',
    },
    {
        CITY: 'TAYUG',
        BARANGAY: 'BARANGAY A (POB.)',
    },
    {
        CITY: 'TAYUG',
        BARANGAY: 'BARANGAY B (POB.)',
    },
    {
        CITY: 'TAYUG',
        BARANGAY: 'BARANGAY C (POB.)',
    },
    {
        CITY: 'TAYUG',
        BARANGAY: 'BARANGAY D (POB.)',
    },
    {
        CITY: 'TAYUG',
        BARANGAY: 'BARANGOBONG',
    },
    {
        CITY: 'TAYUG',
        BARANGAY: 'C. LICHAUCO',
    },
    {
        CITY: 'TAYUG',
        BARANGAY: 'CARRIEDO',
    },
    {
        CITY: 'TAYUG',
        BARANGAY: 'EVANGELISTA',
    },
    {
        CITY: 'TAYUG',
        BARANGAY: 'GUZON',
    },
    {
        CITY: 'TAYUG',
        BARANGAY: 'LAWAK',
    },
    {
        CITY: 'TAYUG',
        BARANGAY: 'LEGASPI',
    },
    {
        CITY: 'TAYUG',
        BARANGAY: 'LIBERTAD',
    },
    {
        CITY: 'TAYUG',
        BARANGAY: 'MAGALLANES',
    },
    {
        CITY: 'TAYUG',
        BARANGAY: 'PANGANIBAN',
    },
    {
        CITY: 'TAYUG',
        BARANGAY: 'SALENG',
    },
    {
        CITY: 'TAYUG',
        BARANGAY: 'SANTO DOMINGO',
    },
    {
        CITY: 'TAYUG',
        BARANGAY: 'TOKETEC',
    },
    {
        CITY: 'TAYUG',
        BARANGAY: 'TRENCHERA',
    },
    {
        CITY: 'TAYUG',
        BARANGAY: 'ZAMORA',
    },
    {
        CITY: 'UMINGAN',
        BARANGAY: 'ABOT MOLINA',
    },
    {
        CITY: 'UMINGAN',
        BARANGAY: 'ALO-O',
    },
    {
        CITY: 'UMINGAN',
        BARANGAY: 'AMARONAN',
    },
    {
        CITY: 'UMINGAN',
        BARANGAY: 'ANNAM',
    },
    {
        CITY: 'UMINGAN',
        BARANGAY: 'BANTUG',
    },
    {
        CITY: 'UMINGAN',
        BARANGAY: 'BARACBAC',
    },
    {
        CITY: 'UMINGAN',
        BARANGAY: 'BARAT',
    },
    {
        CITY: 'UMINGAN',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'UMINGAN',
        BARANGAY: 'CABALITIAN',
    },
    {
        CITY: 'UMINGAN',
        BARANGAY: 'CABANGARAN',
    },
    {
        CITY: 'UMINGAN',
        BARANGAY: 'CABARUAN',
    },
    {
        CITY: 'UMINGAN',
        BARANGAY: 'CABATUAN',
    },
    {
        CITY: 'UMINGAN',
        BARANGAY: 'CADIZ',
    },
    {
        CITY: 'UMINGAN',
        BARANGAY: 'CALITLITAN',
    },
    {
        CITY: 'UMINGAN',
        BARANGAY: 'CAPAS',
    },
    {
        CITY: 'UMINGAN',
        BARANGAY: 'CARAYUNGAN SUR',
    },
    {
        CITY: 'UMINGAN',
        BARANGAY: 'CAROSALESAN',
    },
    {
        CITY: 'UMINGAN',
        BARANGAY: 'CASILAN',
    },
    {
        CITY: 'UMINGAN',
        BARANGAY: 'CAURDANETAAN',
    },
    {
        CITY: 'UMINGAN',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'UMINGAN',
        BARANGAY: 'DECRETO',
    },
    {
        CITY: 'UMINGAN',
        BARANGAY: 'DEL ROSARIO',
    },
    {
        CITY: 'UMINGAN',
        BARANGAY: 'DIAZ',
    },
    {
        CITY: 'UMINGAN',
        BARANGAY: 'DIKET',
    },
    {
        CITY: 'UMINGAN',
        BARANGAY: 'DON JUSTO ABALOS (CAROAN)',
    },
    {
        CITY: 'UMINGAN',
        BARANGAY: 'DON MONTANO',
    },
    {
        CITY: 'UMINGAN',
        BARANGAY: 'ESPERANZA',
    },
    {
        CITY: 'UMINGAN',
        BARANGAY: 'EVANGELISTA',
    },
    {
        CITY: 'UMINGAN',
        BARANGAY: 'FLORES',
    },
    {
        CITY: 'UMINGAN',
        BARANGAY: 'FULGOSINO',
    },
    {
        CITY: 'UMINGAN',
        BARANGAY: 'GONZALES',
    },
    {
        CITY: 'UMINGAN',
        BARANGAY: 'LA PAZ',
    },
    {
        CITY: 'UMINGAN',
        BARANGAY: 'LABUAN',
    },
    {
        CITY: 'UMINGAN',
        BARANGAY: 'LAUREN',
    },
    {
        CITY: 'UMINGAN',
        BARANGAY: 'LUBONG',
    },
    {
        CITY: 'UMINGAN',
        BARANGAY: 'LUNA ESTE',
    },
    {
        CITY: 'UMINGAN',
        BARANGAY: 'LUNA WESTE',
    },
    {
        CITY: 'UMINGAN',
        BARANGAY: 'MANTACDANG',
    },
    {
        CITY: 'UMINGAN',
        BARANGAY: 'MASEIL-SEIL',
    },
    {
        CITY: 'UMINGAN',
        BARANGAY: 'NAMPALCAN',
    },
    {
        CITY: 'UMINGAN',
        BARANGAY: 'NANCALABASAAN',
    },
    {
        CITY: 'UMINGAN',
        BARANGAY: 'PANGANGAAN',
    },
    {
        CITY: 'UMINGAN',
        BARANGAY: 'PAPALLASEN',
    },
    {
        CITY: 'UMINGAN',
        BARANGAY: 'PEMIENTA',
    },
    {
        CITY: 'UMINGAN',
        BARANGAY: 'POBLACION EAST',
    },
    {
        CITY: 'UMINGAN',
        BARANGAY: 'POBLACION WEST',
    },
    {
        CITY: 'UMINGAN',
        BARANGAY: 'PRADO',
    },
    {
        CITY: 'UMINGAN',
        BARANGAY: 'RESURRECCION',
    },
    {
        CITY: 'UMINGAN',
        BARANGAY: 'RICOS',
    },
    {
        CITY: 'UMINGAN',
        BARANGAY: 'SAN ANDRES',
    },
    {
        CITY: 'UMINGAN',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'UMINGAN',
        BARANGAY: 'SAN LEON',
    },
    {
        CITY: 'UMINGAN',
        BARANGAY: 'SAN PABLO',
    },
    {
        CITY: 'UMINGAN',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'UMINGAN',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'UMINGAN',
        BARANGAY: 'SANTA ROSA',
    },
    {
        CITY: 'UMINGAN',
        BARANGAY: 'SINABAAN',
    },
    {
        CITY: 'UMINGAN',
        BARANGAY: 'TANGGAL SAWANG',
    },
    {
        CITY: 'URBIZTONDO',
        BARANGAY: 'ANGATEL',
    },
    {
        CITY: 'URBIZTONDO',
        BARANGAY: 'BALANGAY',
    },
    {
        CITY: 'URBIZTONDO',
        BARANGAY: 'BATANGCAOA',
    },
    {
        CITY: 'URBIZTONDO',
        BARANGAY: 'BAUG',
    },
    {
        CITY: 'URBIZTONDO',
        BARANGAY: 'BAYAOAS',
    },
    {
        CITY: 'URBIZTONDO',
        BARANGAY: 'BITUAG',
    },
    {
        CITY: 'URBIZTONDO',
        BARANGAY: 'CAMAMBUGAN',
    },
    {
        CITY: 'URBIZTONDO',
        BARANGAY: 'DALANGIRING',
    },
    {
        CITY: 'URBIZTONDO',
        BARANGAY: 'DUPLAC',
    },
    {
        CITY: 'URBIZTONDO',
        BARANGAY: 'GALARIN',
    },
    {
        CITY: 'URBIZTONDO',
        BARANGAY: 'GUETEB',
    },
    {
        CITY: 'URBIZTONDO',
        BARANGAY: 'MALACA',
    },
    {
        CITY: 'URBIZTONDO',
        BARANGAY: 'MALAYO',
    },
    {
        CITY: 'URBIZTONDO',
        BARANGAY: 'MALIBONG',
    },
    {
        CITY: 'URBIZTONDO',
        BARANGAY: 'PASIBI EAST',
    },
    {
        CITY: 'URBIZTONDO',
        BARANGAY: 'PASIBI WEST',
    },
    {
        CITY: 'URBIZTONDO',
        BARANGAY: 'PISUAC',
    },
    {
        CITY: 'URBIZTONDO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'URBIZTONDO',
        BARANGAY: 'REAL',
    },
    {
        CITY: 'URBIZTONDO',
        BARANGAY: 'SALAVANTE',
    },
    {
        CITY: 'URBIZTONDO',
        BARANGAY: 'SAWAT',
    },
    {
        CITY: 'URDANETA',
        BARANGAY: 'ANONAS',
    },
    {
        CITY: 'URDANETA',
        BARANGAY: 'BACTAD EAST',
    },
    {
        CITY: 'URDANETA',
        BARANGAY: 'BAYAOAS',
    },
    {
        CITY: 'URDANETA',
        BARANGAY: 'BOLAOEN',
    },
    {
        CITY: 'URDANETA',
        BARANGAY: 'CABARUAN',
    },
    {
        CITY: 'URDANETA',
        BARANGAY: 'CABULOAN',
    },
    {
        CITY: 'URDANETA',
        BARANGAY: 'CAMANANG',
    },
    {
        CITY: 'URDANETA',
        BARANGAY: 'CAMANTILES',
    },
    {
        CITY: 'URDANETA',
        BARANGAY: 'CASANTAAN',
    },
    {
        CITY: 'URDANETA',
        BARANGAY: 'CATABLAN',
    },
    {
        CITY: 'URDANETA',
        BARANGAY: 'CAYAMBANAN',
    },
    {
        CITY: 'URDANETA',
        BARANGAY: 'CONSOLACION',
    },
    {
        CITY: 'URDANETA',
        BARANGAY: 'DILAN PAURIDO',
    },
    {
        CITY: 'URDANETA',
        BARANGAY: 'DR. PEDRO T. ORATA (BACTAD PROPER)',
    },
    {
        CITY: 'URDANETA',
        BARANGAY: 'LABIT PROPER',
    },
    {
        CITY: 'URDANETA',
        BARANGAY: 'LABIT WEST',
    },
    {
        CITY: 'URDANETA',
        BARANGAY: 'MABANOGBOG',
    },
    {
        CITY: 'URDANETA',
        BARANGAY: 'MACALONG',
    },
    {
        CITY: 'URDANETA',
        BARANGAY: 'NANCALOBASAAN',
    },
    {
        CITY: 'URDANETA',
        BARANGAY: 'NANCAMALIRAN EAST',
    },
    {
        CITY: 'URDANETA',
        BARANGAY: 'NANCAMALIRAN WEST',
    },
    {
        CITY: 'URDANETA',
        BARANGAY: 'NANCAYASAN',
    },
    {
        CITY: 'URDANETA',
        BARANGAY: 'NANCAYASAN',
    },
    {
        CITY: 'URDANETA',
        BARANGAY: 'OLTAMA',
    },
    {
        CITY: 'URDANETA',
        BARANGAY: 'PALINA EAST',
    },
    {
        CITY: 'URDANETA',
        BARANGAY: 'PALINA WEST',
    },
    {
        CITY: 'URDANETA',
        BARANGAY: 'PINMALUDPOD',
    },
    {
        CITY: 'URDANETA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'URDANETA',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'URDANETA',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'URDANETA',
        BARANGAY: 'SANTA LUCIA',
    },
    {
        CITY: 'URDANETA',
        BARANGAY: 'SANTO DOMINGO',
    },
    {
        CITY: 'URDANETA',
        BARANGAY: 'SUGCONG',
    },
    {
        CITY: 'URDANETA',
        BARANGAY: 'TIPUSO',
    },
    {
        CITY: 'URDANETA',
        BARANGAY: 'TULONG',
    },
    {
        CITY: 'VILLASIS',
        BARANGAY: 'AMAMPEREZ',
    },
    {
        CITY: 'VILLASIS',
        BARANGAY: 'BACAG',
    },
    {
        CITY: 'VILLASIS',
        BARANGAY: 'BARANGOBONG',
    },
    {
        CITY: 'VILLASIS',
        BARANGAY: 'BARRACA',
    },
    {
        CITY: 'VILLASIS',
        BARANGAY: 'CAPULAAN',
    },
    {
        CITY: 'VILLASIS',
        BARANGAY: 'CARAMUTAN',
    },
    {
        CITY: 'VILLASIS',
        BARANGAY: 'LA PAZ',
    },
    {
        CITY: 'VILLASIS',
        BARANGAY: 'LABIT',
    },
    {
        CITY: 'VILLASIS',
        BARANGAY: 'LIPAY',
    },
    {
        CITY: 'VILLASIS',
        BARANGAY: 'LOMBOY',
    },
    {
        CITY: 'VILLASIS',
        BARANGAY: 'PIAZ (PLAZA)',
    },
    {
        CITY: 'VILLASIS',
        BARANGAY: 'PUELAY',
    },
    {
        CITY: 'VILLASIS',
        BARANGAY: 'SAN BLAS',
    },
    {
        CITY: 'VILLASIS',
        BARANGAY: 'SAN NICOLAS',
    },
    {
        CITY: 'VILLASIS',
        BARANGAY: 'TOMBOD',
    },
    {
        CITY: 'VILLASIS',
        BARANGAY: 'UNZAD',
    },
    {
        CITY: 'VILLASIS',
        BARANGAY: 'ZONE I (POB.)',
    },
    {
        CITY: 'VILLASIS',
        BARANGAY: 'ZONE II (POB.)',
    },
    {
        CITY: 'VILLASIS',
        BARANGAY: 'ZONE III (POB.)',
    },
    {
        CITY: 'VILLASIS',
        BARANGAY: 'ZONE IV (POB.)',
    },
    {
        CITY: 'VILLASIS',
        BARANGAY: 'ZONE V (POB.)',
    },
    {
        CITY: 'AGOO',
        BARANGAY: 'AMBITACAY',
    },
    {
        CITY: 'AGOO',
        BARANGAY: 'BALAWARTE',
    },
    {
        CITY: 'AGOO',
        BARANGAY: 'CAPAS',
    },
    {
        CITY: 'AGOO',
        BARANGAY: 'CONSOLACION (POB.)',
    },
    {
        CITY: 'AGOO',
        BARANGAY: 'MACALVA CENTRAL',
    },
    {
        CITY: 'AGOO',
        BARANGAY: 'MACALVA NORTE',
    },
    {
        CITY: 'AGOO',
        BARANGAY: 'MACALVA SUR',
    },
    {
        CITY: 'AGOO',
        BARANGAY: 'NAZARENO',
    },
    {
        CITY: 'AGOO',
        BARANGAY: 'PUROK',
    },
    {
        CITY: 'AGOO',
        BARANGAY: 'SAN AGUSTIN EAST',
    },
    {
        CITY: 'AGOO',
        BARANGAY: 'SAN AGUSTIN NORTE',
    },
    {
        CITY: 'AGOO',
        BARANGAY: 'SAN AGUSTIN SUR',
    },
    {
        CITY: 'AGOO',
        BARANGAY: 'SAN ANTONINO',
    },
    {
        CITY: 'AGOO',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'AGOO',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'AGOO',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'AGOO',
        BARANGAY: 'SAN JOAQUIN NORTE',
    },
    {
        CITY: 'AGOO',
        BARANGAY: 'SAN JOAQUIN SUR',
    },
    {
        CITY: 'AGOO',
        BARANGAY: 'SAN JOSE NORTE',
    },
    {
        CITY: 'AGOO',
        BARANGAY: 'SAN JOSE SUR',
    },
    {
        CITY: 'AGOO',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'AGOO',
        BARANGAY: 'SAN JULIAN CENTRAL',
    },
    {
        CITY: 'AGOO',
        BARANGAY: 'SAN JULIAN EAST',
    },
    {
        CITY: 'AGOO',
        BARANGAY: 'SAN JULIAN NORTE',
    },
    {
        CITY: 'AGOO',
        BARANGAY: 'SAN JULIAN WEST',
    },
    {
        CITY: 'AGOO',
        BARANGAY: 'SAN MANUEL NORTE',
    },
    {
        CITY: 'AGOO',
        BARANGAY: 'SAN MANUEL SUR',
    },
    {
        CITY: 'AGOO',
        BARANGAY: 'SAN MARCOS',
    },
    {
        CITY: 'AGOO',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'AGOO',
        BARANGAY: 'SAN NICOLAS CENTRAL (POB.)',
    },
    {
        CITY: 'AGOO',
        BARANGAY: 'SAN NICOLAS EAST',
    },
    {
        CITY: 'AGOO',
        BARANGAY: 'SAN NICOLAS NORTE (POB.)',
    },
    {
        CITY: 'AGOO',
        BARANGAY: 'SAN NICOLAS SUR (POB.)',
    },
    {
        CITY: 'AGOO',
        BARANGAY: 'SAN NICOLAS WEST',
    },
    {
        CITY: 'AGOO',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'AGOO',
        BARANGAY: 'SAN ROQUE EAST',
    },
    {
        CITY: 'AGOO',
        BARANGAY: 'SAN ROQUE WEST',
    },
    {
        CITY: 'AGOO',
        BARANGAY: 'SAN VICENTE NORTE',
    },
    {
        CITY: 'AGOO',
        BARANGAY: 'SAN VICENTE SUR',
    },
    {
        CITY: 'AGOO',
        BARANGAY: 'SANTA ANA',
    },
    {
        CITY: 'AGOO',
        BARANGAY: 'SANTA BARBARA (POB.)',
    },
    {
        CITY: 'AGOO',
        BARANGAY: 'SANTA FE',
    },
    {
        CITY: 'AGOO',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'AGOO',
        BARANGAY: 'SANTA MONICA',
    },
    {
        CITY: 'AGOO',
        BARANGAY: 'SANTA RITA (NALINAC)',
    },
    {
        CITY: 'AGOO',
        BARANGAY: 'SANTA RITA EAST',
    },
    {
        CITY: 'AGOO',
        BARANGAY: 'SANTA RITA NORTE',
    },
    {
        CITY: 'AGOO',
        BARANGAY: 'SANTA RITA SUR',
    },
    {
        CITY: 'AGOO',
        BARANGAY: 'SANTA RITA WEST',
    },
    {
        CITY: 'ARINGAY',
        BARANGAY: 'ALASKA',
    },
    {
        CITY: 'ARINGAY',
        BARANGAY: 'BASCA',
    },
    {
        CITY: 'ARINGAY',
        BARANGAY: 'DULAO',
    },
    {
        CITY: 'ARINGAY',
        BARANGAY: 'GALLANO',
    },
    {
        CITY: 'ARINGAY',
        BARANGAY: 'MACABATO',
    },
    {
        CITY: 'ARINGAY',
        BARANGAY: 'MANGA',
    },
    {
        CITY: 'ARINGAY',
        BARANGAY: 'PANGAO-AOAN EAST',
    },
    {
        CITY: 'ARINGAY',
        BARANGAY: 'PANGAO-AOAN WEST',
    },
    {
        CITY: 'ARINGAY',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'ARINGAY',
        BARANGAY: 'SAMARA',
    },
    {
        CITY: 'ARINGAY',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'ARINGAY',
        BARANGAY: 'SAN BENITO NORTE',
    },
    {
        CITY: 'ARINGAY',
        BARANGAY: 'SAN BENITO SUR',
    },
    {
        CITY: 'ARINGAY',
        BARANGAY: 'SAN EUGENIO',
    },
    {
        CITY: 'ARINGAY',
        BARANGAY: 'SAN JUAN EAST',
    },
    {
        CITY: 'ARINGAY',
        BARANGAY: 'SAN JUAN WEST',
    },
    {
        CITY: 'ARINGAY',
        BARANGAY: 'SAN SIMON EAST',
    },
    {
        CITY: 'ARINGAY',
        BARANGAY: 'SAN SIMON WEST',
    },
    {
        CITY: 'ARINGAY',
        BARANGAY: 'SANTA CECILIA',
    },
    {
        CITY: 'ARINGAY',
        BARANGAY: 'SANTA LUCIA',
    },
    {
        CITY: 'ARINGAY',
        BARANGAY: 'SANTA RITA EAST',
    },
    {
        CITY: 'ARINGAY',
        BARANGAY: 'SANTA RITA WEST',
    },
    {
        CITY: 'ARINGAY',
        BARANGAY: 'SANTO ROSARIO EAST',
    },
    {
        CITY: 'ARINGAY',
        BARANGAY: 'SANTO ROSARIO WEST',
    },
    {
        CITY: 'BACNOTAN',
        BARANGAY: 'AGTIPAL',
    },
    {
        CITY: 'BACNOTAN',
        BARANGAY: 'AROSIP',
    },
    {
        CITY: 'BACNOTAN',
        BARANGAY: 'BACQUI',
    },
    {
        CITY: 'BACNOTAN',
        BARANGAY: 'BACSIL',
    },
    {
        CITY: 'BACNOTAN',
        BARANGAY: 'BAGUTOT',
    },
    {
        CITY: 'BACNOTAN',
        BARANGAY: 'BALLOGO',
    },
    {
        CITY: 'BACNOTAN',
        BARANGAY: 'BARORO',
    },
    {
        CITY: 'BACNOTAN',
        BARANGAY: 'BITALAG',
    },
    {
        CITY: 'BACNOTAN',
        BARANGAY: 'BULALA',
    },
    {
        CITY: 'BACNOTAN',
        BARANGAY: 'BURAYOC',
    },
    {
        CITY: 'BACNOTAN',
        BARANGAY: 'BUSSAOIT',
    },
    {
        CITY: 'BACNOTAN',
        BARANGAY: 'CABAROAN',
    },
    {
        CITY: 'BACNOTAN',
        BARANGAY: 'CABARSICAN',
    },
    {
        CITY: 'BACNOTAN',
        BARANGAY: 'CABUGAO',
    },
    {
        CITY: 'BACNOTAN',
        BARANGAY: 'CALAUTIT',
    },
    {
        CITY: 'BACNOTAN',
        BARANGAY: 'CARCARMAY',
    },
    {
        CITY: 'BACNOTAN',
        BARANGAY: 'CASIAMAN',
    },
    {
        CITY: 'BACNOTAN',
        BARANGAY: 'GALONGEN',
    },
    {
        CITY: 'BACNOTAN',
        BARANGAY: 'GUINABANG',
    },
    {
        CITY: 'BACNOTAN',
        BARANGAY: 'LEGLEG',
    },
    {
        CITY: 'BACNOTAN',
        BARANGAY: 'LISQUEB',
    },
    {
        CITY: 'BACNOTAN',
        BARANGAY: 'MABANENGBENG 1ST',
    },
    {
        CITY: 'BACNOTAN',
        BARANGAY: 'MABANENGBENG 2ND',
    },
    {
        CITY: 'BACNOTAN',
        BARANGAY: 'MARAGAYAP',
    },
    {
        CITY: 'BACNOTAN',
        BARANGAY: 'NAGATIRAN',
    },
    {
        CITY: 'BACNOTAN',
        BARANGAY: 'NAGSARABOAN',
    },
    {
        CITY: 'BACNOTAN',
        BARANGAY: 'NAGSIMBAANAN',
    },
    {
        CITY: 'BACNOTAN',
        BARANGAY: 'NANGALISAN',
    },
    {
        CITY: 'BACNOTAN',
        BARANGAY: 'NARRA',
    },
    {
        CITY: 'BACNOTAN',
        BARANGAY: 'ORTEGA',
    },
    {
        CITY: 'BACNOTAN',
        BARANGAY: 'OYA-OY',
    },
    {
        CITY: 'BACNOTAN',
        BARANGAY: 'PAAGAN',
    },
    {
        CITY: 'BACNOTAN',
        BARANGAY: 'PANDAN',
    },
    {
        CITY: 'BACNOTAN',
        BARANGAY: 'PANG-PANG',
    },
    {
        CITY: 'BACNOTAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BACNOTAN',
        BARANGAY: 'QUIRINO',
    },
    {
        CITY: 'BACNOTAN',
        BARANGAY: 'RAOIS',
    },
    {
        CITY: 'BACNOTAN',
        BARANGAY: 'SALINCOB',
    },
    {
        CITY: 'BACNOTAN',
        BARANGAY: 'SAN MARTIN',
    },
    {
        CITY: 'BACNOTAN',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'BACNOTAN',
        BARANGAY: 'SANTA RITA',
    },
    {
        CITY: 'BACNOTAN',
        BARANGAY: 'SAPILANG',
    },
    {
        CITY: 'BACNOTAN',
        BARANGAY: 'SAYOAN',
    },
    {
        CITY: 'BACNOTAN',
        BARANGAY: 'SIPULO',
    },
    {
        CITY: 'BACNOTAN',
        BARANGAY: 'TAMMOCALAO',
    },
    {
        CITY: 'BACNOTAN',
        BARANGAY: 'UBBOG',
    },
    {
        CITY: 'BACNOTAN',
        BARANGAY: 'ZARAGOSA',
    },
    {
        CITY: 'BAGULIN',
        BARANGAY: 'ALIBANGSAY',
    },
    {
        CITY: 'BAGULIN',
        BARANGAY: 'BAAY',
    },
    {
        CITY: 'BAGULIN',
        BARANGAY: 'CAMBALY',
    },
    {
        CITY: 'BAGULIN',
        BARANGAY: 'CARDIZ',
    },
    {
        CITY: 'BAGULIN',
        BARANGAY: 'DAGUP',
    },
    {
        CITY: 'BAGULIN',
        BARANGAY: 'LIBBO',
    },
    {
        CITY: 'BAGULIN',
        BARANGAY: 'SUYO (POB.)',
    },
    {
        CITY: 'BAGULIN',
        BARANGAY: 'TAGUDTUD',
    },
    {
        CITY: 'BAGULIN',
        BARANGAY: 'TIO-ANGAN',
    },
    {
        CITY: 'BAGULIN',
        BARANGAY: 'WALLAYAN',
    },
    {
        CITY: 'BALAOAN',
        BARANGAY: 'ALMIEDA',
    },
    {
        CITY: 'BALAOAN',
        BARANGAY: 'ANTONINO',
    },
    {
        CITY: 'BALAOAN',
        BARANGAY: 'APATUT',
    },
    {
        CITY: 'BALAOAN',
        BARANGAY: 'AR-ARAMPANG',
    },
    {
        CITY: 'BALAOAN',
        BARANGAY: 'BARACBAC ESTE',
    },
    {
        CITY: 'BALAOAN',
        BARANGAY: 'BARACBAC OESTE',
    },
    {
        CITY: 'BALAOAN',
        BARANGAY: 'BET-ANG',
    },
    {
        CITY: 'BALAOAN',
        BARANGAY: 'BULBULALA',
    },
    {
        CITY: 'BALAOAN',
        BARANGAY: 'BUNGOL',
    },
    {
        CITY: 'BALAOAN',
        BARANGAY: 'BUTUBUT ESTE',
    },
    {
        CITY: 'BALAOAN',
        BARANGAY: 'BUTUBUT NORTE',
    },
    {
        CITY: 'BALAOAN',
        BARANGAY: 'BUTUBUT OESTE',
    },
    {
        CITY: 'BALAOAN',
        BARANGAY: 'BUTUBUT SUR',
    },
    {
        CITY: 'BALAOAN',
        BARANGAY: 'CABUAAN OESTE (POB.)',
    },
    {
        CITY: 'BALAOAN',
        BARANGAY: 'CALLIAT',
    },
    {
        CITY: 'BALAOAN',
        BARANGAY: 'CALUNGBUYAN',
    },
    {
        CITY: 'BALAOAN',
        BARANGAY: 'CAMILING',
    },
    {
        CITY: 'BALAOAN',
        BARANGAY: 'DR. CAMILO OSIAS POB. (CABUAAN ESTE)',
    },
    {
        CITY: 'BALAOAN',
        BARANGAY: 'GUINABURAN',
    },
    {
        CITY: 'BALAOAN',
        BARANGAY: 'MASUPE',
    },
    {
        CITY: 'BALAOAN',
        BARANGAY: 'NAGSABARAN NORTE',
    },
    {
        CITY: 'BALAOAN',
        BARANGAY: 'NAGSABARAN SUR',
    },
    {
        CITY: 'BALAOAN',
        BARANGAY: 'NALASIN',
    },
    {
        CITY: 'BALAOAN',
        BARANGAY: 'NAPASET',
    },
    {
        CITY: 'BALAOAN',
        BARANGAY: 'PAGBENNECAN',
    },
    {
        CITY: 'BALAOAN',
        BARANGAY: 'PAGLEDDEGAN',
    },
    {
        CITY: 'BALAOAN',
        BARANGAY: 'PANTAR NORTE',
    },
    {
        CITY: 'BALAOAN',
        BARANGAY: 'PANTAR SUR',
    },
    {
        CITY: 'BALAOAN',
        BARANGAY: 'PA-O',
    },
    {
        CITY: 'BALAOAN',
        BARANGAY: 'PARAOIR',
    },
    {
        CITY: 'BALAOAN',
        BARANGAY: 'PATPATA',
    },
    {
        CITY: 'BALAOAN',
        BARANGAY: 'SABLUT',
    },
    {
        CITY: 'BALAOAN',
        BARANGAY: 'SAN PABLO',
    },
    {
        CITY: 'BALAOAN',
        BARANGAY: 'SINAPANGAN NORTE',
    },
    {
        CITY: 'BALAOAN',
        BARANGAY: 'SINAPANGAN SUR',
    },
    {
        CITY: 'BALAOAN',
        BARANGAY: 'TALLIPUGO',
    },
    {
        CITY: 'BANGAR',
        BARANGAY: 'AGDEPPA',
    },
    {
        CITY: 'BANGAR',
        BARANGAY: 'ALZATE',
    },
    {
        CITY: 'BANGAR',
        BARANGAY: 'BANGAOILAN EAST',
    },
    {
        CITY: 'BANGAR',
        BARANGAY: 'BANGAOILAN WEST',
    },
    {
        CITY: 'BANGAR',
        BARANGAY: 'BARRACA',
    },
    {
        CITY: 'BANGAR',
        BARANGAY: 'CADAPLI',
    },
    {
        CITY: 'BANGAR',
        BARANGAY: 'CAGGAO',
    },
    {
        CITY: 'BANGAR',
        BARANGAY: 'CENTRAL EAST NO. 1 (POB.)',
    },
    {
        CITY: 'BANGAR',
        BARANGAY: 'CENTRAL EAST NO. 2 (POB.)',
    },
    {
        CITY: 'BANGAR',
        BARANGAY: 'CENTRAL WEST NO. 1 (POB.)',
    },
    {
        CITY: 'BANGAR',
        BARANGAY: 'CENTRAL WEST NO. 2 (POB.)',
    },
    {
        CITY: 'BANGAR',
        BARANGAY: 'CENTRAL WEST NO. 3 (POB.)',
    },
    {
        CITY: 'BANGAR',
        BARANGAY: 'CONSUEGRA',
    },
    {
        CITY: 'BANGAR',
        BARANGAY: 'GENERAL PRIM EAST',
    },
    {
        CITY: 'BANGAR',
        BARANGAY: 'GENERAL PRIM WEST',
    },
    {
        CITY: 'BANGAR',
        BARANGAY: 'GENERAL TERRERO',
    },
    {
        CITY: 'BANGAR',
        BARANGAY: 'LUZONG NORTE',
    },
    {
        CITY: 'BANGAR',
        BARANGAY: 'LUZONG SUR',
    },
    {
        CITY: 'BANGAR',
        BARANGAY: 'MARIA CRISTINA EAST',
    },
    {
        CITY: 'BANGAR',
        BARANGAY: 'MARIA CRISTINA WEST',
    },
    {
        CITY: 'BANGAR',
        BARANGAY: 'MINDORO',
    },
    {
        CITY: 'BANGAR',
        BARANGAY: 'NAGSABARAN',
    },
    {
        CITY: 'BANGAR',
        BARANGAY: 'PARATONG NO. 3',
    },
    {
        CITY: 'BANGAR',
        BARANGAY: 'PARATONG NO. 4',
    },
    {
        CITY: 'BANGAR',
        BARANGAY: 'PARATONG NORTE',
    },
    {
        CITY: 'BANGAR',
        BARANGAY: 'QUINTARONG',
    },
    {
        CITY: 'BANGAR',
        BARANGAY: 'REYNA REGENTE',
    },
    {
        CITY: 'BANGAR',
        BARANGAY: 'RISSING',
    },
    {
        CITY: 'BANGAR',
        BARANGAY: 'SAN BLAS',
    },
    {
        CITY: 'BANGAR',
        BARANGAY: 'SAN CRISTOBAL',
    },
    {
        CITY: 'BANGAR',
        BARANGAY: 'SINAPANGAN NORTE',
    },
    {
        CITY: 'BANGAR',
        BARANGAY: 'SINAPANGAN SUR',
    },
    {
        CITY: 'BANGAR',
        BARANGAY: 'UBBOG',
    },
    {
        CITY: 'BAUANG',
        BARANGAY: 'ACAO',
    },
    {
        CITY: 'BAUANG',
        BARANGAY: 'BACCUIT NORTE',
    },
    {
        CITY: 'BAUANG',
        BARANGAY: 'BACCUIT SUR',
    },
    {
        CITY: 'BAUANG',
        BARANGAY: 'BAGBAG',
    },
    {
        CITY: 'BAUANG',
        BARANGAY: 'BALLAY',
    },
    {
        CITY: 'BAUANG',
        BARANGAY: 'BAWANTA',
    },
    {
        CITY: 'BAUANG',
        BARANGAY: 'BOY-UTAN',
    },
    {
        CITY: 'BAUANG',
        BARANGAY: 'BUCAYAB',
    },
    {
        CITY: 'BAUANG',
        BARANGAY: 'CABALAYANGAN',
    },
    {
        CITY: 'BAUANG',
        BARANGAY: 'CABISILAN',
    },
    {
        CITY: 'BAUANG',
        BARANGAY: 'CALUMBAYA',
    },
    {
        CITY: 'BAUANG',
        BARANGAY: 'CARMAY',
    },
    {
        CITY: 'BAUANG',
        BARANGAY: 'CASILAGAN',
    },
    {
        CITY: 'BAUANG',
        BARANGAY: 'CENTRAL EAST (POB.)',
    },
    {
        CITY: 'BAUANG',
        BARANGAY: 'CENTRAL WEST (POB.)',
    },
    {
        CITY: 'BAUANG',
        BARANGAY: 'DILI',
    },
    {
        CITY: 'BAUANG',
        BARANGAY: 'DISSO-OR',
    },
    {
        CITY: 'BAUANG',
        BARANGAY: 'GUERRERO',
    },
    {
        CITY: 'BAUANG',
        BARANGAY: 'LOWER SAN AGUSTIN',
    },
    {
        CITY: 'BAUANG',
        BARANGAY: 'NAGREBCAN',
    },
    {
        CITY: 'BAUANG',
        BARANGAY: 'PAGDALAGAN SUR',
    },
    {
        CITY: 'BAUANG',
        BARANGAY: 'PALINTUCANG',
    },
    {
        CITY: 'BAUANG',
        BARANGAY: 'PALUGSI-LIMMANSANGAN',
    },
    {
        CITY: 'BAUANG',
        BARANGAY: 'PARIAN ESTE',
    },
    {
        CITY: 'BAUANG',
        BARANGAY: 'PARIAN OESTE',
    },
    {
        CITY: 'BAUANG',
        BARANGAY: 'PARINGAO',
    },
    {
        CITY: 'BAUANG',
        BARANGAY: 'PAYOCPOC NORTE ESTE',
    },
    {
        CITY: 'BAUANG',
        BARANGAY: 'PAYOCPOC NORTE OESTE',
    },
    {
        CITY: 'BAUANG',
        BARANGAY: 'PAYOCPOC SUR',
    },
    {
        CITY: 'BAUANG',
        BARANGAY: 'PILAR',
    },
    {
        CITY: 'BAUANG',
        BARANGAY: 'POTTOT',
    },
    {
        CITY: 'BAUANG',
        BARANGAY: 'PUDOC',
    },
    {
        CITY: 'BAUANG',
        BARANGAY: 'PUGO',
    },
    {
        CITY: 'BAUANG',
        BARANGAY: 'QUINAVITE',
    },
    {
        CITY: 'BAUANG',
        BARANGAY: 'SANTA MONICA',
    },
    {
        CITY: 'BAUANG',
        BARANGAY: 'SANTIAGO',
    },
    {
        CITY: 'BAUANG',
        BARANGAY: 'TABERNA',
    },
    {
        CITY: 'BAUANG',
        BARANGAY: 'UPPER SAN AGUSTIN',
    },
    {
        CITY: 'BAUANG',
        BARANGAY: 'URAYONG',
    },
    {
        CITY: 'CABA',
        BARANGAY: 'BAUTISTA',
    },
    {
        CITY: 'CABA',
        BARANGAY: 'GANA',
    },
    {
        CITY: 'CABA',
        BARANGAY: 'JUAN CARTAS',
    },
    {
        CITY: 'CABA',
        BARANGAY: 'LAS-UD',
    },
    {
        CITY: 'CABA',
        BARANGAY: 'LIQUICIA',
    },
    {
        CITY: 'CABA',
        BARANGAY: 'POBLACION NORTE',
    },
    {
        CITY: 'CABA',
        BARANGAY: 'POBLACION SUR',
    },
    {
        CITY: 'CABA',
        BARANGAY: 'SAN CARLOS',
    },
    {
        CITY: 'CABA',
        BARANGAY: 'SAN CORNELIO',
    },
    {
        CITY: 'CABA',
        BARANGAY: 'SAN FERMIN',
    },
    {
        CITY: 'CABA',
        BARANGAY: 'SAN GREGORIO',
    },
    {
        CITY: 'CABA',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'CABA',
        BARANGAY: 'SANTIAGO NORTE',
    },
    {
        CITY: 'CABA',
        BARANGAY: 'SANTIAGO SUR',
    },
    {
        CITY: 'CABA',
        BARANGAY: 'SOBREDILLO',
    },
    {
        CITY: 'CABA',
        BARANGAY: 'URAYONG',
    },
    {
        CITY: 'CABA',
        BARANGAY: 'WENCESLAO',
    },
    {
        CITY: 'LA-UNION-BURGOS',
        BARANGAY: 'AGPAY',
    },
    {
        CITY: 'LA-UNION-BURGOS',
        BARANGAY: 'BILIS',
    },
    {
        CITY: 'LA-UNION-BURGOS',
        BARANGAY: 'CAOAYAN',
    },
    {
        CITY: 'LA-UNION-BURGOS',
        BARANGAY: 'DALACDAC',
    },
    {
        CITY: 'LA-UNION-BURGOS',
        BARANGAY: 'DELLES',
    },
    {
        CITY: 'LA-UNION-BURGOS',
        BARANGAY: 'IMELDA',
    },
    {
        CITY: 'LA-UNION-BURGOS',
        BARANGAY: 'LIBTONG',
    },
    {
        CITY: 'LA-UNION-BURGOS',
        BARANGAY: 'LINUAN',
    },
    {
        CITY: 'LA-UNION-BURGOS',
        BARANGAY: 'LOWER TUMAPOC',
    },
    {
        CITY: 'LA-UNION-BURGOS',
        BARANGAY: 'NEW POBLACION',
    },
    {
        CITY: 'LA-UNION-BURGOS',
        BARANGAY: 'OLD POBLACION',
    },
    {
        CITY: 'LA-UNION-BURGOS',
        BARANGAY: 'UPPER TUMAPOC',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'ALCALA (POB.)',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'AYAOAN',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'BARANGOBONG',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'BARRIENTOS',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'BUNGRO',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'BUSELBUSEL',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'CABALITOCAN',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'CANTORIA NO. 1',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'CANTORIA NO. 2',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'CANTORIA NO. 3',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'CANTORIA NO. 4',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'CARISQUIS',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'DARIGAYOS',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'MAGALLANES (POB.)',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'MAGSIPING',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'MAMAY',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'NAGREBCAN',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'NALVO NORTE',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'NALVO SUR',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'NAPASET',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'OAQUI NO. 1',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'OAQUI NO. 2',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'OAQUI NO. 3',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'OAQUI NO. 4',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'PILA',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'PITPITAC',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'RIMOS NO. 1',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'RIMOS NO. 2',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'RIMOS NO. 3',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'RIMOS NO. 4',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'RIMOS NO. 5',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'RISSING',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'SALCEDO (POB.)',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'SANTO DOMINGO NORTE',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'SANTO DOMINGO SUR',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'SUCOC NORTE',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'SUCOC SUR',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'SUYO',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'TALLAOEN',
    },
    {
        CITY: 'LUNA',
        BARANGAY: 'VICTORIA (POB.)',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'AGUIOAS',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'AL-ALINAO NORTE',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'AL-ALINAO SUR',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'AMBARACAO NORTE',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'AMBARACAO SUR',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'ANGIN',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'BALECBEC',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'BANCAGAN',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'BARAOAS NORTE',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'BARAOAS SUR',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'BARIQUIR',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'BATO',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'BIMMOTOBOT',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'CABARITAN NORTE',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'CABARITAN SUR',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'CASILAGAN',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'DAL-LIPAOEN',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'DARAMUANGAN',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'GUESSET',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'GUSING NORTE',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'GUSING SUR',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'IMELDA',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'LIOAC NORTE',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'LIOAC SUR',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'MAGUNGUNAY',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'MAMAT-ING NORTE',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'MAMAT-ING SUR',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'NAGSIDORISAN',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'NATIVIDAD (POB.)',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'ORTIZ (POB.)',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'RIBSUAN',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'SILI',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'SUGUIDAN NORTE',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'SUGUIDAN SUR',
    },
    {
        CITY: 'NAGUILIAN',
        BARANGAY: 'TUDDINGAN',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'ALIPANG',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'AMBANGONAN',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'AMLANG',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'BACANI',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'BANGAR',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'BANI',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'BENTENG-SAPILANG',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'CADUMANIAN',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'CAMP ONE',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'CARUNUAN EAST',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'CARUNUAN WEST',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'CASILAGAN',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'CATAGUINGTINGAN',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'DAMORTIS',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'GUMOT-NAGCOLARAN',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'INABAAN NORTE',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'INABAAN SUR',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'MARCOS',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'NAGTAGAAN',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'NANGCAMOTIAN',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'PARASAPAS',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'POBLACION EAST',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'POBLACION WEST',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'PUZON',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'RABON',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'SUBUSUB',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'TABTABUNGAO',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'TANGLAG',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'TAY-AC',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'UDIAO',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'VILA',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'ABUT',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'APALENG',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'BACSIL',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'BANGBANGOLAN',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'BANGCUSAY',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'BARANGAY I (POB.)',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'BARANGAY II (POB.)',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'BARANGAY III (POB.)',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'BARANGAY IV (POB.)',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'BARAOAS',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'BATO',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'BIDAY',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'BIRUNGET',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'BUNGRO',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'CABAROAN (NEGRO)',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'CABARSICAN',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'CADACLAN',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'CALABUGAO',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'CAMANSI',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'CANAOAY',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'CARLATAN',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'CATBANGEN',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'DALLANGAYAN ESTE',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'DALLANGAYAN OESTE',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'DALUMPINAS ESTE',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'DALUMPINAS OESTE',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'ILOCANOS NORTE',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'ILOCANOS SUR',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'LANGCUAS',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'LINGSAT',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'MADAYEGDEG',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'MAMELTAC',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'MASICONG',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'NAGYUBUYUBAN',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'NAMTUTAN',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'NARRA ESTE',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'NARRA OESTE',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'PACPACO',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'PAGDALAGAN',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'PAGDARAOAN',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'PAGUDPUD',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'PAO NORTE',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'PAO SUR',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'PARIAN',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'PIAS',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'PORO',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'PUSPUS',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'SACYUD',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'SAGAYAD',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'SANTIAGO NORTE',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'SANTIAGO SUR',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'SAOAY',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'SEVILLA',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'SIBOAN-OTONG',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'TANQUI',
    },
    {
        CITY: 'SAN-FERNANDO',
        BARANGAY: 'TANQUIGAN',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'ALLANGIGAN',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'ALUDAID',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'BACSAYAN',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'BALBALLOSA',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'BAMBANAY',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'BUGBUGCAO',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'CAARUSIPAN',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'CABAROAN',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'CABUGNAYAN',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'CACAPIAN',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'CACULANGAN',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'CALINCAMASAN',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'CASILAGAN',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'CATDONGAN',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'DANGDANGLA',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'DASAY',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'DINANUM',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'DUPLAS',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'GUINGUINABANG',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'ILI NORTE (POB.)',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'ILI SUR (POB.)',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'LEGLEG',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'LUBING',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'NADSAAG',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'NAGSABARAN',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'NAGUIRANGAN',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'NAGUITUBAN',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'NAGYUBUYUBAN',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'OAQUING',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'PACPACAC',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'PAGDILDILAN',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'PANICSICAN',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'QUIDEM',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'SAN FELIPE',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'SANTA ROSA',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'SANTO ROSARIO',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'SARACAT',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'SINAPANGAN',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'TABOC',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'TALOGTOG',
    },
    {
        CITY: 'SAN-JUAN',
        BARANGAY: 'URBIZTONDO',
    },
    {
        CITY: 'LA-UNION-SANTO-TOMAS',
        BARANGAY: 'AMBITACAY',
    },
    {
        CITY: 'LA-UNION-SANTO-TOMAS',
        BARANGAY: 'BAIL',
    },
    {
        CITY: 'LA-UNION-SANTO-TOMAS',
        BARANGAY: 'BALAOC',
    },
    {
        CITY: 'LA-UNION-SANTO-TOMAS',
        BARANGAY: 'BALSAAN',
    },
    {
        CITY: 'LA-UNION-SANTO-TOMAS',
        BARANGAY: 'BAYBAY',
    },
    {
        CITY: 'LA-UNION-SANTO-TOMAS',
        BARANGAY: 'CABARUAN',
    },
    {
        CITY: 'LA-UNION-SANTO-TOMAS',
        BARANGAY: 'CASANTAAN',
    },
    {
        CITY: 'LA-UNION-SANTO-TOMAS',
        BARANGAY: 'CASILAGAN',
    },
    {
        CITY: 'LA-UNION-SANTO-TOMAS',
        BARANGAY: 'CUPANG',
    },
    {
        CITY: 'LA-UNION-SANTO-TOMAS',
        BARANGAY: 'DAMORTIS',
    },
    {
        CITY: 'LA-UNION-SANTO-TOMAS',
        BARANGAY: 'FERNANDO',
    },
    {
        CITY: 'LA-UNION-SANTO-TOMAS',
        BARANGAY: 'LINONG',
    },
    {
        CITY: 'LA-UNION-SANTO-TOMAS',
        BARANGAY: 'LOMBOY',
    },
    {
        CITY: 'LA-UNION-SANTO-TOMAS',
        BARANGAY: 'MALABAGO',
    },
    {
        CITY: 'LA-UNION-SANTO-TOMAS',
        BARANGAY: 'NAMBOONGAN',
    },
    {
        CITY: 'LA-UNION-SANTO-TOMAS',
        BARANGAY: 'NAMONITAN',
    },
    {
        CITY: 'LA-UNION-SANTO-TOMAS',
        BARANGAY: 'NARVACAN',
    },
    {
        CITY: 'LA-UNION-SANTO-TOMAS',
        BARANGAY: 'PATAC',
    },
    {
        CITY: 'LA-UNION-SANTO-TOMAS',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'LA-UNION-SANTO-TOMAS',
        BARANGAY: 'PONGPONG',
    },
    {
        CITY: 'LA-UNION-SANTO-TOMAS',
        BARANGAY: 'RAOIS',
    },
    {
        CITY: 'LA-UNION-SANTO-TOMAS',
        BARANGAY: 'TOCOC',
    },
    {
        CITY: 'LA-UNION-SANTO-TOMAS',
        BARANGAY: 'TUBOD',
    },
    {
        CITY: 'LA-UNION-SANTO-TOMAS',
        BARANGAY: 'UBAGAN',
    },
    {
        CITY: 'PUGO',
        BARANGAY: 'AMBALITE',
    },
    {
        CITY: 'PUGO',
        BARANGAY: 'AMBANGONAN',
    },
    {
        CITY: 'PUGO',
        BARANGAY: 'CARES',
    },
    {
        CITY: 'PUGO',
        BARANGAY: 'CUENCA',
    },
    {
        CITY: 'PUGO',
        BARANGAY: 'DUPLAS',
    },
    {
        CITY: 'PUGO',
        BARANGAY: 'MAOASOAS NORTE',
    },
    {
        CITY: 'PUGO',
        BARANGAY: 'MAOASOAS SUR',
    },
    {
        CITY: 'PUGO',
        BARANGAY: 'PALINA',
    },
    {
        CITY: 'PUGO',
        BARANGAY: 'POBLACION EAST',
    },
    {
        CITY: 'PUGO',
        BARANGAY: 'POBLACION WEST',
    },
    {
        CITY: 'PUGO',
        BARANGAY: 'SAN LUIS',
    },
    {
        CITY: 'PUGO',
        BARANGAY: 'SAYTAN',
    },
    {
        CITY: 'PUGO',
        BARANGAY: 'TAVORA EAST',
    },
    {
        CITY: 'PUGO',
        BARANGAY: 'TAVORA PROPER',
    },
    {
        CITY: 'SAN-GABRIEL',
        BARANGAY: 'AMONTOC',
    },
    {
        CITY: 'SAN-GABRIEL',
        BARANGAY: 'APAYAO',
    },
    {
        CITY: 'SAN-GABRIEL',
        BARANGAY: 'BALBALAYANG',
    },
    {
        CITY: 'SAN-GABRIEL',
        BARANGAY: 'BAYABAS',
    },
    {
        CITY: 'SAN-GABRIEL',
        BARANGAY: 'BUCAO',
    },
    {
        CITY: 'SAN-GABRIEL',
        BARANGAY: 'BUMBUNEG',
    },
    {
        CITY: 'SAN-GABRIEL',
        BARANGAY: 'DAKING',
    },
    {
        CITY: 'SAN-GABRIEL',
        BARANGAY: 'LACONG',
    },
    {
        CITY: 'SAN-GABRIEL',
        BARANGAY: 'LIPAY ESTE',
    },
    {
        CITY: 'SAN-GABRIEL',
        BARANGAY: 'LIPAY NORTE',
    },
    {
        CITY: 'SAN-GABRIEL',
        BARANGAY: 'LIPAY PROPER',
    },
    {
        CITY: 'SAN-GABRIEL',
        BARANGAY: 'LIPAY SUR',
    },
    {
        CITY: 'SAN-GABRIEL',
        BARANGAY: 'LON-OY',
    },
    {
        CITY: 'SAN-GABRIEL',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SAN-GABRIEL',
        BARANGAY: 'POLIPOL',
    },
    {
        CITY: 'SANTOL',
        BARANGAY: 'CORROOY',
    },
    {
        CITY: 'SANTOL',
        BARANGAY: 'LETTAC NORTE',
    },
    {
        CITY: 'SANTOL',
        BARANGAY: 'LETTAC SUR',
    },
    {
        CITY: 'SANTOL',
        BARANGAY: 'MANGAAN',
    },
    {
        CITY: 'SANTOL',
        BARANGAY: 'PAAGAN',
    },
    {
        CITY: 'SANTOL',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SANTOL',
        BARANGAY: 'PUGUIL',
    },
    {
        CITY: 'SANTOL',
        BARANGAY: 'RAMOT',
    },
    {
        CITY: 'SANTOL',
        BARANGAY: 'SAPDAAN',
    },
    {
        CITY: 'SANTOL',
        BARANGAY: 'SASABA',
    },
    {
        CITY: 'SANTOL',
        BARANGAY: 'TUBADAY',
    },
    {
        CITY: 'SUDIPEN',
        BARANGAY: 'BIGBIGA',
    },
    {
        CITY: 'SUDIPEN',
        BARANGAY: 'BIGBIGA',
    },
    {
        CITY: 'SUDIPEN',
        BARANGAY: 'BULALAAN',
    },
    {
        CITY: 'SUDIPEN',
        BARANGAY: 'CASTRO',
    },
    {
        CITY: 'SUDIPEN',
        BARANGAY: 'DUPLAS',
    },
    {
        CITY: 'SUDIPEN',
        BARANGAY: 'ILOCANO',
    },
    {
        CITY: 'SUDIPEN',
        BARANGAY: 'IPET',
    },
    {
        CITY: 'SUDIPEN',
        BARANGAY: 'MALICLICO',
    },
    {
        CITY: 'SUDIPEN',
        BARANGAY: 'NAMALTUGAN',
    },
    {
        CITY: 'SUDIPEN',
        BARANGAY: 'OLD CENTRAL',
    },
    {
        CITY: 'SUDIPEN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SUDIPEN',
        BARANGAY: 'PORPORIKET',
    },
    {
        CITY: 'SUDIPEN',
        BARANGAY: 'SAN FRANCISCO NORTE',
    },
    {
        CITY: 'SUDIPEN',
        BARANGAY: 'SAN FRANCISCO SUR',
    },
    {
        CITY: 'SUDIPEN',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'SUDIPEN',
        BARANGAY: 'SENGNGAT',
    },
    {
        CITY: 'SUDIPEN',
        BARANGAY: 'TUROD',
    },
    {
        CITY: 'SUDIPEN',
        BARANGAY: 'UP-UPLAS',
    },
    {
        CITY: 'TUBAO',
        BARANGAY: 'AMALLAPAY',
    },
    {
        CITY: 'TUBAO',
        BARANGAY: 'ANDUYAN',
    },
    {
        CITY: 'TUBAO',
        BARANGAY: 'CAOIGUE',
    },
    {
        CITY: 'TUBAO',
        BARANGAY: 'FRANCIA SUR',
    },
    {
        CITY: 'TUBAO',
        BARANGAY: 'FRANCIA WEST',
    },
    {
        CITY: 'TUBAO',
        BARANGAY: 'GARCIA',
    },
    {
        CITY: 'TUBAO',
        BARANGAY: 'GONZALES',
    },
    {
        CITY: 'TUBAO',
        BARANGAY: 'HALOG EAST',
    },
    {
        CITY: 'TUBAO',
        BARANGAY: 'HALOG WEST',
    },
    {
        CITY: 'TUBAO',
        BARANGAY: 'LEONES EAST',
    },
    {
        CITY: 'TUBAO',
        BARANGAY: 'LEONES WEST',
    },
    {
        CITY: 'TUBAO',
        BARANGAY: 'LINAPEW',
    },
    {
        CITY: 'TUBAO',
        BARANGAY: 'LLOREN',
    },
    {
        CITY: 'TUBAO',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'TUBAO',
        BARANGAY: 'PIDEG',
    },
    {
        CITY: 'TUBAO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'TUBAO',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'TUBAO',
        BARANGAY: 'SANTA TERESA',
    },
    {
        CITY: 'ALILEM',
        BARANGAY: 'ALILEM DAYA (POB.)',
    },
    {
        CITY: 'ALILEM',
        BARANGAY: 'AMILONGAN',
    },
    {
        CITY: 'ALILEM',
        BARANGAY: 'ANAAO',
    },
    {
        CITY: 'ALILEM',
        BARANGAY: 'APANG',
    },
    {
        CITY: 'ALILEM',
        BARANGAY: 'APAYA',
    },
    {
        CITY: 'ALILEM',
        BARANGAY: 'BATBATO',
    },
    {
        CITY: 'ALILEM',
        BARANGAY: 'DADDAAY',
    },
    {
        CITY: 'ALILEM',
        BARANGAY: 'DALAWA',
    },
    {
        CITY: 'ALILEM',
        BARANGAY: 'KIAT',
    },
    {
        CITY: 'BANAYOYO',
        BARANGAY: 'BAGBAGOTOT',
    },
    {
        CITY: 'BANAYOYO',
        BARANGAY: 'BANBANAAL',
    },
    {
        CITY: 'BANAYOYO',
        BARANGAY: 'BISANGOL',
    },
    {
        CITY: 'BANAYOYO',
        BARANGAY: 'CADANGLAAN',
    },
    {
        CITY: 'BANAYOYO',
        BARANGAY: 'CASILAGAN NORTE',
    },
    {
        CITY: 'BANAYOYO',
        BARANGAY: 'CASILAGAN SUR',
    },
    {
        CITY: 'BANAYOYO',
        BARANGAY: 'ELEFANTE',
    },
    {
        CITY: 'BANAYOYO',
        BARANGAY: 'GUARDIA',
    },
    {
        CITY: 'BANAYOYO',
        BARANGAY: 'LINTIC',
    },
    {
        CITY: 'BANAYOYO',
        BARANGAY: 'LOPEZ',
    },
    {
        CITY: 'BANAYOYO',
        BARANGAY: 'MONTERO',
    },
    {
        CITY: 'BANAYOYO',
        BARANGAY: 'NAGUIMBA',
    },
    {
        CITY: 'BANAYOYO',
        BARANGAY: 'PILA',
    },
    {
        CITY: 'BANAYOYO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BANTAY',
        BARANGAY: 'AGGAY',
    },
    {
        CITY: 'BANTAY',
        BARANGAY: 'AN-ANNAM',
    },
    {
        CITY: 'BANTAY',
        BARANGAY: 'BALALENG',
    },
    {
        CITY: 'BANTAY',
        BARANGAY: 'BANAOANG',
    },
    {
        CITY: 'BANTAY',
        BARANGAY: 'BARANGAY 1 (POB.)',
    },
    {
        CITY: 'BANTAY',
        BARANGAY: 'BARANGAY 2 (POB.)',
    },
    {
        CITY: 'BANTAY',
        BARANGAY: 'BARANGAY 3 (POB.)',
    },
    {
        CITY: 'BANTAY',
        BARANGAY: 'BARANGAY 4 (POB.)',
    },
    {
        CITY: 'BANTAY',
        BARANGAY: 'BARANGAY 5 (POB.)',
    },
    {
        CITY: 'BANTAY',
        BARANGAY: 'BARANGAY 6 (POB.)',
    },
    {
        CITY: 'BANTAY',
        BARANGAY: 'BULAG',
    },
    {
        CITY: 'BANTAY',
        BARANGAY: 'BUQUIG',
    },
    {
        CITY: 'BANTAY',
        BARANGAY: 'CABALANGGAN',
    },
    {
        CITY: 'BANTAY',
        BARANGAY: 'CABAROAN',
    },
    {
        CITY: 'BANTAY',
        BARANGAY: 'CABUSLIGAN',
    },
    {
        CITY: 'BANTAY',
        BARANGAY: 'CAPANGDANAN',
    },
    {
        CITY: 'BANTAY',
        BARANGAY: 'GUIMOD',
    },
    {
        CITY: 'BANTAY',
        BARANGAY: 'LINGSAT',
    },
    {
        CITY: 'BANTAY',
        BARANGAY: 'MALINGEB',
    },
    {
        CITY: 'BANTAY',
        BARANGAY: 'MIRA',
    },
    {
        CITY: 'BANTAY',
        BARANGAY: 'NAGUIDDAYAN',
    },
    {
        CITY: 'BANTAY',
        BARANGAY: 'ORA',
    },
    {
        CITY: 'BANTAY',
        BARANGAY: 'PAING',
    },
    {
        CITY: 'BANTAY',
        BARANGAY: 'PUSPUS',
    },
    {
        CITY: 'BANTAY',
        BARANGAY: 'QUIMMARAYAN',
    },
    {
        CITY: 'BANTAY',
        BARANGAY: 'SAGNEB',
    },
    {
        CITY: 'BANTAY',
        BARANGAY: 'SAGPAT',
    },
    {
        CITY: 'BANTAY',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'BANTAY',
        BARANGAY: 'SAN JULIAN',
    },
    {
        CITY: 'BANTAY',
        BARANGAY: 'SAN MARIANO (SALLACONG)',
    },
    {
        CITY: 'BANTAY',
        BARANGAY: 'SINABAAN',
    },
    {
        CITY: 'BANTAY',
        BARANGAY: 'TAGUIPORO',
    },
    {
        CITY: 'BANTAY',
        BARANGAY: 'TALEB',
    },
    {
        CITY: 'BANTAY',
        BARANGAY: 'TAY-AC',
    },
    {
        CITY: 'CABUGAO',
        BARANGAY: 'ALINAAY',
    },
    {
        CITY: 'CABUGAO',
        BARANGAY: 'ARAGAN',
    },
    {
        CITY: 'CABUGAO',
        BARANGAY: 'ARNAP',
    },
    {
        CITY: 'CABUGAO',
        BARANGAY: 'BACLIG (POB.)',
    },
    {
        CITY: 'CABUGAO',
        BARANGAY: 'BATO',
    },
    {
        CITY: 'CABUGAO',
        BARANGAY: 'BONIFACIO (POB.)',
    },
    {
        CITY: 'CABUGAO',
        BARANGAY: 'BUNGRO',
    },
    {
        CITY: 'CABUGAO',
        BARANGAY: 'CACADIRAN',
    },
    {
        CITY: 'CABUGAO',
        BARANGAY: 'CAELLAYAN',
    },
    {
        CITY: 'CABUGAO',
        BARANGAY: 'CARUSIPAN',
    },
    {
        CITY: 'CABUGAO',
        BARANGAY: 'CATUCDAAN',
    },
    {
        CITY: 'CABUGAO',
        BARANGAY: 'CUANCABAL',
    },
    {
        CITY: 'CABUGAO',
        BARANGAY: 'CUANTACLA',
    },
    {
        CITY: 'CABUGAO',
        BARANGAY: 'DACLAPAN',
    },
    {
        CITY: 'CABUGAO',
        BARANGAY: 'DARDARAT',
    },
    {
        CITY: 'CABUGAO',
        BARANGAY: 'LIPIT',
    },
    {
        CITY: 'CABUGAO',
        BARANGAY: 'MARADODON',
    },
    {
        CITY: 'CABUGAO',
        BARANGAY: 'MARGAAY',
    },
    {
        CITY: 'CABUGAO',
        BARANGAY: 'NAGSANTAAN',
    },
    {
        CITY: 'CABUGAO',
        BARANGAY: 'NAGSINCAOAN',
    },
    {
        CITY: 'CABUGAO',
        BARANGAY: 'NAMRUANGAN',
    },
    {
        CITY: 'CABUGAO',
        BARANGAY: 'PILA',
    },
    {
        CITY: 'CABUGAO',
        BARANGAY: 'PUG-OS',
    },
    {
        CITY: 'CABUGAO',
        BARANGAY: 'QUEZON (POB.)',
    },
    {
        CITY: 'CABUGAO',
        BARANGAY: 'REPPAAC',
    },
    {
        CITY: 'CABUGAO',
        BARANGAY: 'RIZAL (POB.)',
    },
    {
        CITY: 'CABUGAO',
        BARANGAY: 'SABANG',
    },
    {
        CITY: 'CABUGAO',
        BARANGAY: 'SAGAYADEN',
    },
    {
        CITY: 'CABUGAO',
        BARANGAY: 'SALAPASAP',
    },
    {
        CITY: 'CABUGAO',
        BARANGAY: 'SALOMAGUE',
    },
    {
        CITY: 'CABUGAO',
        BARANGAY: 'SISIM',
    },
    {
        CITY: 'CABUGAO',
        BARANGAY: 'TUROD',
    },
    {
        CITY: 'CABUGAO',
        BARANGAY: 'TUROD-PATAC',
    },
    {
        CITY: 'CANDON',
        BARANGAY: 'ALLANGIGAN PRIMERO',
    },
    {
        CITY: 'CANDON',
        BARANGAY: 'ALLANGIGAN SEGUNDO',
    },
    {
        CITY: 'CANDON',
        BARANGAY: 'AMGUID',
    },
    {
        CITY: 'CANDON',
        BARANGAY: 'AYUDANTE',
    },
    {
        CITY: 'CANDON',
        BARANGAY: 'BAGANI CAMPOSANTO',
    },
    {
        CITY: 'CANDON',
        BARANGAY: 'BAGANI GABOR',
    },
    {
        CITY: 'CANDON',
        BARANGAY: 'BAGANI TOCGO',
    },
    {
        CITY: 'CANDON',
        BARANGAY: 'BAGANI UBBOG',
    },
    {
        CITY: 'CANDON',
        BARANGAY: 'BAGAR',
    },
    {
        CITY: 'CANDON',
        BARANGAY: 'BALINGAOAN',
    },
    {
        CITY: 'CANDON',
        BARANGAY: 'BUGNAY',
    },
    {
        CITY: 'CANDON',
        BARANGAY: 'CALAOAAN',
    },
    {
        CITY: 'CANDON',
        BARANGAY: 'CALONGBUYAN',
    },
    {
        CITY: 'CANDON',
        BARANGAY: 'CATERMAN',
    },
    {
        CITY: 'CANDON',
        BARANGAY: 'CUBCUBBOOT',
    },
    {
        CITY: 'CANDON',
        BARANGAY: 'DARAPIDAP',
    },
    {
        CITY: 'CANDON',
        BARANGAY: 'LANGLANGCA PRIMERO',
    },
    {
        CITY: 'CANDON',
        BARANGAY: 'LANGLANGCA SEGUNDO',
    },
    {
        CITY: 'CANDON',
        BARANGAY: 'OAIG-DAYA',
    },
    {
        CITY: 'CANDON',
        BARANGAY: 'PALACAPAC',
    },
    {
        CITY: 'CANDON',
        BARANGAY: 'PARAS',
    },
    {
        CITY: 'CANDON',
        BARANGAY: 'PARIOC PRIMERO',
    },
    {
        CITY: 'CANDON',
        BARANGAY: 'PARIOC SEGUNDO',
    },
    {
        CITY: 'CANDON',
        BARANGAY: 'PATPATA PRIMERO',
    },
    {
        CITY: 'CANDON',
        BARANGAY: 'PATPATA SEGUNDO',
    },
    {
        CITY: 'CANDON',
        BARANGAY: 'PAYPAYAD',
    },
    {
        CITY: 'CANDON',
        BARANGAY: 'SALVADOR PRIMERO',
    },
    {
        CITY: 'CANDON',
        BARANGAY: 'SALVADOR SEGUNDO',
    },
    {
        CITY: 'CANDON',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'CANDON',
        BARANGAY: 'SAN ANDRES',
    },
    {
        CITY: 'CANDON',
        BARANGAY: 'SAN ANTONIO (POB.)',
    },
    {
        CITY: 'CANDON',
        BARANGAY: 'SAN ISIDRO (POB.)',
    },
    {
        CITY: 'CANDON',
        BARANGAY: 'SAN JOSE (POB.)',
    },
    {
        CITY: 'CANDON',
        BARANGAY: 'SAN JUAN (POB.)',
    },
    {
        CITY: 'CANDON',
        BARANGAY: 'SAN NICOLAS',
    },
    {
        CITY: 'CANDON',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'CANDON',
        BARANGAY: 'SANTO TOMAS',
    },
    {
        CITY: 'CANDON',
        BARANGAY: 'TABLAC',
    },
    {
        CITY: 'CANDON',
        BARANGAY: 'TALOGTOG',
    },
    {
        CITY: 'CANDON',
        BARANGAY: 'TAMURONG PRIMERO',
    },
    {
        CITY: 'CANDON',
        BARANGAY: 'TAMURONG SEGUNDO',
    },
    {
        CITY: 'CANDON',
        BARANGAY: 'VILLARICA',
    },
    {
        CITY: 'CAOAYAN',
        BARANGAY: 'ANONANG MAYOR',
    },
    {
        CITY: 'CAOAYAN',
        BARANGAY: 'ANONANG MENOR',
    },
    {
        CITY: 'CAOAYAN',
        BARANGAY: 'BAGGOC',
    },
    {
        CITY: 'CAOAYAN',
        BARANGAY: 'CALLAGUIP',
    },
    {
        CITY: 'CAOAYAN',
        BARANGAY: 'CAPARACADAN',
    },
    {
        CITY: 'CAOAYAN',
        BARANGAY: 'DON ALEJANDRO QUIROLGICO (POB.)',
    },
    {
        CITY: 'CAOAYAN',
        BARANGAY: 'DON DIMAS QUERUBIN (POB.)',
    },
    {
        CITY: 'CAOAYAN',
        BARANGAY: 'DON LORENZO QUERUBIN (POB.)',
    },
    {
        CITY: 'CAOAYAN',
        BARANGAY: 'FUERTE',
    },
    {
        CITY: 'CAOAYAN',
        BARANGAY: 'MANANGAT',
    },
    {
        CITY: 'CAOAYAN',
        BARANGAY: 'NAGUILIAN',
    },
    {
        CITY: 'CAOAYAN',
        BARANGAY: 'NANSUAGAO',
    },
    {
        CITY: 'CAOAYAN',
        BARANGAY: 'PANDAN',
    },
    {
        CITY: 'CAOAYAN',
        BARANGAY: 'PANTAY TAMURONG',
    },
    {
        CITY: 'CAOAYAN',
        BARANGAY: 'PANTAY-QUITIQUIT',
    },
    {
        CITY: 'CAOAYAN',
        BARANGAY: 'PURO',
    },
    {
        CITY: 'CAOAYAN',
        BARANGAY: 'VILLAMAR',
    },
    {
        CITY: 'CERVANTES',
        BARANGAY: 'ALULING',
    },
    {
        CITY: 'CERVANTES',
        BARANGAY: 'COMILLAS NORTH',
    },
    {
        CITY: 'CERVANTES',
        BARANGAY: 'COMILLAS SOUTH',
    },
    {
        CITY: 'CERVANTES',
        BARANGAY: 'CONCEPCION (POB.)',
    },
    {
        CITY: 'CERVANTES',
        BARANGAY: 'DINWEDE EAST',
    },
    {
        CITY: 'CERVANTES',
        BARANGAY: 'DINWEDE WEST',
    },
    {
        CITY: 'CERVANTES',
        BARANGAY: 'LIBANG',
    },
    {
        CITY: 'CERVANTES',
        BARANGAY: 'MALAYA',
    },
    {
        CITY: 'CERVANTES',
        BARANGAY: 'PILIPIL',
    },
    {
        CITY: 'CERVANTES',
        BARANGAY: 'REMEDIOS',
    },
    {
        CITY: 'CERVANTES',
        BARANGAY: 'ROSARIO (POB.)',
    },
    {
        CITY: 'CERVANTES',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'CERVANTES',
        BARANGAY: 'SAN LUIS',
    },
    {
        CITY: 'GALIMUYOD',
        BARANGAY: 'ABAYA',
    },
    {
        CITY: 'GALIMUYOD',
        BARANGAY: 'BARACBAC',
    },
    {
        CITY: 'GALIMUYOD',
        BARANGAY: 'BIDBIDAY',
    },
    {
        CITY: 'GALIMUYOD',
        BARANGAY: 'BITONG',
    },
    {
        CITY: 'GALIMUYOD',
        BARANGAY: 'BOROBOR',
    },
    {
        CITY: 'GALIMUYOD',
        BARANGAY: 'CALIMUGTONG',
    },
    {
        CITY: 'GALIMUYOD',
        BARANGAY: 'CALONGBUYAN',
    },
    {
        CITY: 'GALIMUYOD',
        BARANGAY: 'CALUMBAYA',
    },
    {
        CITY: 'GALIMUYOD',
        BARANGAY: 'DALDAGAN',
    },
    {
        CITY: 'GALIMUYOD',
        BARANGAY: 'KILANG',
    },
    {
        CITY: 'GALIMUYOD',
        BARANGAY: 'LEGASPI',
    },
    {
        CITY: 'GALIMUYOD',
        BARANGAY: 'MABAYAG',
    },
    {
        CITY: 'GALIMUYOD',
        BARANGAY: 'MATANUBONG',
    },
    {
        CITY: 'GALIMUYOD',
        BARANGAY: 'MCKINLEY',
    },
    {
        CITY: 'GALIMUYOD',
        BARANGAY: 'NAGSINGCAOAN',
    },
    {
        CITY: 'GALIMUYOD',
        BARANGAY: 'OAIG-DAYA',
    },
    {
        CITY: 'GALIMUYOD',
        BARANGAY: 'PAGANGPANG',
    },
    {
        CITY: 'GALIMUYOD',
        BARANGAY: 'PATAC',
    },
    {
        CITY: 'GALIMUYOD',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'GALIMUYOD',
        BARANGAY: 'RUBIO',
    },
    {
        CITY: 'GALIMUYOD',
        BARANGAY: 'SABANGAN-BATO',
    },
    {
        CITY: 'GALIMUYOD',
        BARANGAY: 'SACAANG',
    },
    {
        CITY: 'GALIMUYOD',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'GALIMUYOD',
        BARANGAY: 'SAPANG',
    },
    {
        CITY: 'GREGORIO-DEL-PILAR',
        BARANGAY: 'ALFONSO (TANGAOAN)',
    },
    {
        CITY: 'GREGORIO-DEL-PILAR',
        BARANGAY: 'BUSSOT',
    },
    {
        CITY: 'GREGORIO-DEL-PILAR',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'GREGORIO-DEL-PILAR',
        BARANGAY: 'DAPDAPPIG',
    },
    {
        CITY: 'GREGORIO-DEL-PILAR',
        BARANGAY: 'MATUE-BUTARAG',
    },
    {
        CITY: 'GREGORIO-DEL-PILAR',
        BARANGAY: 'POBLACION NORTE',
    },
    {
        CITY: 'GREGORIO-DEL-PILAR',
        BARANGAY: 'POBLACION SUR',
    },
    {
        CITY: 'ILOCOS-SUR-BURGOS',
        BARANGAY: 'AMBUGAT',
    },
    {
        CITY: 'ILOCOS-SUR-BURGOS',
        BARANGAY: 'BALUGANG',
    },
    {
        CITY: 'ILOCOS-SUR-BURGOS',
        BARANGAY: 'BANGBANGAR',
    },
    {
        CITY: 'ILOCOS-SUR-BURGOS',
        BARANGAY: 'BESSANG',
    },
    {
        CITY: 'ILOCOS-SUR-BURGOS',
        BARANGAY: 'CABCABURAO',
    },
    {
        CITY: 'ILOCOS-SUR-BURGOS',
        BARANGAY: 'CADACAD',
    },
    {
        CITY: 'ILOCOS-SUR-BURGOS',
        BARANGAY: 'CALLITONG',
    },
    {
        CITY: 'ILOCOS-SUR-BURGOS',
        BARANGAY: 'DAYANKI',
    },
    {
        CITY: 'ILOCOS-SUR-BURGOS',
        BARANGAY: 'DIRDIRIG (DIRDIRIG-PADAY)',
    },
    {
        CITY: 'ILOCOS-SUR-BURGOS',
        BARANGAY: 'LESSEB',
    },
    {
        CITY: 'ILOCOS-SUR-BURGOS',
        BARANGAY: 'LUBING',
    },
    {
        CITY: 'ILOCOS-SUR-BURGOS',
        BARANGAY: 'LUCABAN',
    },
    {
        CITY: 'ILOCOS-SUR-BURGOS',
        BARANGAY: 'LUNA',
    },
    {
        CITY: 'ILOCOS-SUR-BURGOS',
        BARANGAY: 'MACAOAYAN',
    },
    {
        CITY: 'ILOCOS-SUR-BURGOS',
        BARANGAY: 'MAMBUG',
    },
    {
        CITY: 'ILOCOS-SUR-BURGOS',
        BARANGAY: 'MANABOC',
    },
    {
        CITY: 'ILOCOS-SUR-BURGOS',
        BARANGAY: 'MAPANIT',
    },
    {
        CITY: 'ILOCOS-SUR-BURGOS',
        BARANGAY: 'NAGPANAOAN',
    },
    {
        CITY: 'ILOCOS-SUR-BURGOS',
        BARANGAY: 'PADUROS',
    },
    {
        CITY: 'ILOCOS-SUR-BURGOS',
        BARANGAY: 'PATAC',
    },
    {
        CITY: 'ILOCOS-SUR-BURGOS',
        BARANGAY: 'POBLACION NORTE (BATO)',
    },
    {
        CITY: 'ILOCOS-SUR-BURGOS',
        BARANGAY: 'POBLACION SUR (MASINGIT)',
    },
    {
        CITY: 'ILOCOS-SUR-BURGOS',
        BARANGAY: 'SABANGAN PINGGAN',
    },
    {
        CITY: 'ILOCOS-SUR-BURGOS',
        BARANGAY: 'SUBADI NORTE',
    },
    {
        CITY: 'ILOCOS-SUR-BURGOS',
        BARANGAY: 'SUBADI SUR',
    },
    {
        CITY: 'ILOCOS-SUR-BURGOS',
        BARANGAY: 'TALIAO',
    },
    {
        CITY: 'QUIRINO',
        BARANGAY: 'BANOEN',
    },
    {
        CITY: 'QUIRINO',
        BARANGAY: 'CAYUS',
    },
    {
        CITY: 'QUIRINO',
        BARANGAY: 'LAMAG (TUBTUBA)',
    },
    {
        CITY: 'QUIRINO',
        BARANGAY: 'LEGLEG (POB.)',
    },
    {
        CITY: 'QUIRINO',
        BARANGAY: 'MALIDEG',
    },
    {
        CITY: 'QUIRINO',
        BARANGAY: 'NAMITPIT',
    },
    {
        CITY: 'QUIRINO',
        BARANGAY: 'PATIACAN',
    },
    {
        CITY: 'QUIRINO',
        BARANGAY: 'PATUNGCALEO (LAMAG)',
    },
    {
        CITY: 'QUIRINO',
        BARANGAY: 'SUAGAYAN',
    },
    {
        CITY: 'SALCEDO',
        BARANGAY: 'ATABAY',
    },
    {
        CITY: 'SALCEDO',
        BARANGAY: 'BALIDBID',
    },
    {
        CITY: 'SALCEDO',
        BARANGAY: 'BALUARTE',
    },
    {
        CITY: 'SALCEDO',
        BARANGAY: 'BAYBAYADING',
    },
    {
        CITY: 'SALCEDO',
        BARANGAY: 'BOGUIBOG',
    },
    {
        CITY: 'SALCEDO',
        BARANGAY: 'BULALA-LEGUEY',
    },
    {
        CITY: 'SALCEDO',
        BARANGAY: 'CALANGCUASAN',
    },
    {
        CITY: 'SALCEDO',
        BARANGAY: 'CULIONG',
    },
    {
        CITY: 'SALCEDO',
        BARANGAY: 'DINARATAN',
    },
    {
        CITY: 'SALCEDO',
        BARANGAY: 'KALIWAKIW',
    },
    {
        CITY: 'SALCEDO',
        BARANGAY: 'KINMARIN',
    },
    {
        CITY: 'SALCEDO',
        BARANGAY: 'LUCBUBAN',
    },
    {
        CITY: 'SALCEDO',
        BARANGAY: 'MADARANG',
    },
    {
        CITY: 'SALCEDO',
        BARANGAY: 'MALIGCONG',
    },
    {
        CITY: 'SALCEDO',
        BARANGAY: 'PIAS',
    },
    {
        CITY: 'SALCEDO',
        BARANGAY: 'POBLACION NORTE',
    },
    {
        CITY: 'SALCEDO',
        BARANGAY: 'POBLACION SUR',
    },
    {
        CITY: 'SALCEDO',
        BARANGAY: 'SAN GASPAR',
    },
    {
        CITY: 'SALCEDO',
        BARANGAY: 'SAN TIBURCIO',
    },
    {
        CITY: 'SALCEDO',
        BARANGAY: 'SORIOAN',
    },
    {
        CITY: 'SALCEDO',
        BARANGAY: 'UBBOG',
    },
    {
        CITY: 'SAN-ILDEFONSO',
        BARANGAY: 'ARNAP',
    },
    {
        CITY: 'SAN-ILDEFONSO',
        BARANGAY: 'BAHET',
    },
    {
        CITY: 'SAN-ILDEFONSO',
        BARANGAY: 'BELEN',
    },
    {
        CITY: 'SAN-ILDEFONSO',
        BARANGAY: 'BUNGRO',
    },
    {
        CITY: 'SAN-ILDEFONSO',
        BARANGAY: 'BUSIING NORTE',
    },
    {
        CITY: 'SAN-ILDEFONSO',
        BARANGAY: 'BUSIING SUR',
    },
    {
        CITY: 'SAN-ILDEFONSO',
        BARANGAY: 'DONGALO',
    },
    {
        CITY: 'SAN-ILDEFONSO',
        BARANGAY: 'GONGOGONG',
    },
    {
        CITY: 'SAN-ILDEFONSO',
        BARANGAY: 'IBOY',
    },
    {
        CITY: 'SAN-ILDEFONSO',
        BARANGAY: 'KINAMANTIRISAN',
    },
    {
        CITY: 'SAN-ILDEFONSO',
        BARANGAY: 'OTOL-PATAC',
    },
    {
        CITY: 'SAN-ILDEFONSO',
        BARANGAY: 'POBLACION EAST',
    },
    {
        CITY: 'SAN-ILDEFONSO',
        BARANGAY: 'POBLACION WEST',
    },
    {
        CITY: 'SAN-ILDEFONSO',
        BARANGAY: 'SAGNEB',
    },
    {
        CITY: 'SAN-ILDEFONSO',
        BARANGAY: 'SAGSAGAT',
    },
    {
        CITY: 'ILOCOS-SUR-SAN-JUAN',
        BARANGAY: 'ASILANG',
    },
    {
        CITY: 'ILOCOS-SUR-SAN-JUAN',
        BARANGAY: 'BACSIL',
    },
    {
        CITY: 'ILOCOS-SUR-SAN-JUAN',
        BARANGAY: 'BALIW',
    },
    {
        CITY: 'ILOCOS-SUR-SAN-JUAN',
        BARANGAY: 'BANNUAR (POB.)',
    },
    {
        CITY: 'ILOCOS-SUR-SAN-JUAN',
        BARANGAY: 'BARBAR',
    },
    {
        CITY: 'ILOCOS-SUR-SAN-JUAN',
        BARANGAY: 'CABANGLOTAN',
    },
    {
        CITY: 'ILOCOS-SUR-SAN-JUAN',
        BARANGAY: 'CACANDONGAN',
    },
    {
        CITY: 'ILOCOS-SUR-SAN-JUAN',
        BARANGAY: 'CAMANGGAAN',
    },
    {
        CITY: 'ILOCOS-SUR-SAN-JUAN',
        BARANGAY: 'CAMINDOROAN',
    },
    {
        CITY: 'ILOCOS-SUR-SAN-JUAN',
        BARANGAY: 'CARONOAN',
    },
    {
        CITY: 'ILOCOS-SUR-SAN-JUAN',
        BARANGAY: 'DARAO',
    },
    {
        CITY: 'ILOCOS-SUR-SAN-JUAN',
        BARANGAY: 'DARDARAT',
    },
    {
        CITY: 'ILOCOS-SUR-SAN-JUAN',
        BARANGAY: 'GUIMOD NORTE',
    },
    {
        CITY: 'ILOCOS-SUR-SAN-JUAN',
        BARANGAY: 'GUIMOD SUR',
    },
    {
        CITY: 'ILOCOS-SUR-SAN-JUAN',
        BARANGAY: 'IMMAYOS NORTE',
    },
    {
        CITY: 'ILOCOS-SUR-SAN-JUAN',
        BARANGAY: 'IMMAYOS SUR',
    },
    {
        CITY: 'ILOCOS-SUR-SAN-JUAN',
        BARANGAY: 'LABNIG',
    },
    {
        CITY: 'ILOCOS-SUR-SAN-JUAN',
        BARANGAY: 'LAPTING',
    },
    {
        CITY: 'ILOCOS-SUR-SAN-JUAN',
        BARANGAY: 'LIRA (POB.)',
    },
    {
        CITY: 'ILOCOS-SUR-SAN-JUAN',
        BARANGAY: 'MALAMIN',
    },
    {
        CITY: 'ILOCOS-SUR-SAN-JUAN',
        BARANGAY: 'MURAYA',
    },
    {
        CITY: 'ILOCOS-SUR-SAN-JUAN',
        BARANGAY: 'NAGSABARAN',
    },
    {
        CITY: 'ILOCOS-SUR-SAN-JUAN',
        BARANGAY: 'NAGSUPOTAN',
    },
    {
        CITY: 'ILOCOS-SUR-SAN-JUAN',
        BARANGAY: 'PANDAYAN (POB.)',
    },
    {
        CITY: 'ILOCOS-SUR-SAN-JUAN',
        BARANGAY: 'REFARO',
    },
    {
        CITY: 'ILOCOS-SUR-SAN-JUAN',
        BARANGAY: 'RESURRECCION (POB.)',
    },
    {
        CITY: 'ILOCOS-SUR-SAN-JUAN',
        BARANGAY: 'SABANGAN',
    },
    {
        CITY: 'ILOCOS-SUR-SAN-JUAN',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'ILOCOS-SUR-SAN-JUAN',
        BARANGAY: 'SAOANG',
    },
    {
        CITY: 'ILOCOS-SUR-SAN-JUAN',
        BARANGAY: 'SOLOTSOLOT',
    },
    {
        CITY: 'ILOCOS-SUR-SAN-JUAN',
        BARANGAY: 'SUNGGIAM',
    },
    {
        CITY: 'ILOCOS-SUR-SAN-JUAN',
        BARANGAY: 'SURNGIT',
    },
    {
        CITY: 'SANTA-CATALINA',
        BARANGAY: 'CABAROAN',
    },
    {
        CITY: 'SANTA-CATALINA',
        BARANGAY: 'CABITTAOGAN',
    },
    {
        CITY: 'SANTA-CATALINA',
        BARANGAY: 'CABULOAN',
    },
    {
        CITY: 'SANTA-CATALINA',
        BARANGAY: 'PANGADA',
    },
    {
        CITY: 'SANTA-CATALINA',
        BARANGAY: 'PARATONG',
    },
    {
        CITY: 'SANTA-CATALINA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SANTA-CATALINA',
        BARANGAY: 'SINABAAN',
    },
    {
        CITY: 'SANTA-CATALINA',
        BARANGAY: 'SUBEC',
    },
    {
        CITY: 'SANTA-CATALINA',
        BARANGAY: 'TAMORONG',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'AMARAO',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'BABAYOAN',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'BACSAYAN',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'BANAY',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'BAYUGAO ESTE',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'BAYUGAO OESTE',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'BESALAN',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'BUGBUGA',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'CALAOAAN',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'CAMANGGAAN',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'CANDALICAN',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'CAPARIAAN',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'CASILAGAN',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'COSCOSNONG',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'DALIGAN',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'DILI',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'GABOR NORTE',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'GABOR SUR',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'LALONG',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'LANTAG',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'LAS-UD',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'MAMBOG',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'MANTANAS',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'NAGTENGNGA',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'PADAOIL',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'PARATONG',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'PATTIQUI',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'PIDPID',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'PILAR',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'PINIPIN',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'POBLACION ESTE',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'POBLACION NORTE',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'POBLACION SUR',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'POBLACION WESTE',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'QUINFERMIN',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'QUINSORIANO',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'SAGAT',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'SAOAT',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'SEVILLA',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'SIDAOEN',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'SUYO',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'TAMPUGO',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'TUROD',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'VILLA GARCIA',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'VILLA HERMOSA',
    },
    {
        CITY: 'SANTA-CRUZ',
        BARANGAY: 'VILLA LAURENCIA',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'AG-AGRAO',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'AMPUAGAN',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'BABALLASIOAN',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'BALIW DAYA',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'BALIW LAUD',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'BIA-O',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'BUTIR',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'CABAROAN',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'DANUMAN EAST',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'DANUMAN WEST',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'DUNGLAYAN',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'GUSING',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'LANGAOAN',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'LASLASONG NORTE',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'LASLASONG SUR',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'LASLASONG WEST',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'LESSEB',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'LINGSAT',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'LUBONG',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'MAYNGANAY NORTE',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'MAYNGANAY SUR',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'NAGSAYAOAN',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'NAGTUPACAN',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'NALVO',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'PACANG',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'PENNED',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'POBLACION NORTE',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'POBLACION SUR',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'SILAG',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'SUMAGUI',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'SUSO',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'TANGAOAN',
    },
    {
        CITY: 'SANTA-MARIA',
        BARANGAY: 'TINAAN',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'AL-ALUDIG',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'AMBUCAO',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'BAYBAYABAS',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'BIGBIGA',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'BULBULALA',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'BUSEL-BUSEL',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'BUTOL',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'CABURAO',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'DAN-AR',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'GABAO',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'GUINABANG',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'IMUS',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'LANG-AYAN',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'MAMBUG',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'NALASIN',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'OLO-OLO NORTE',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'OLO-OLO SUR',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'POBLACION NORTE',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'POBLACION SUR',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'SABANGAN',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'SALINCUB',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'SAN JOSE (BARAOAS)',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'UBBOG',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'BINALAYANGAN',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'BINONGAN',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'BOROBOR',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'CABARITAN',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'CABIGBIGAAN',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'CALAUTIT',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'CALAY-AB',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'CAMESTIZOAN',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'CASILI',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'FLORA',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'LAGATIT',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'LAOINGEN',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'LUSSOC',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'NAGBETTEDAN',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'NAGLAOA-AN',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'NALASIN',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'NAMBARAN',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'NANERMAN',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'NAPO',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'PADU CHICO',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'PADU GRANDE',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'PAGURAPER',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'PANAY',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'PANGPANGDAN',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'PARADA',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'PARAS',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'PUERTA REAL',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'PUSSUAC',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'QUIMMARAYAN',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'SAN PABLO',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'SANTO TOMAS',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'SIVED',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'SUKSUKIT',
    },
    {
        CITY: 'SANTO-DOMINGO',
        BARANGAY: 'VACUNERO',
    },
    {
        CITY: 'SAN-VICENTE',
        BARANGAY: 'BANTAOAY',
    },
    {
        CITY: 'SAN-VICENTE',
        BARANGAY: 'BAYUBAY NORTE',
    },
    {
        CITY: 'SAN-VICENTE',
        BARANGAY: 'BAYUBAY SUR',
    },
    {
        CITY: 'SAN-VICENTE',
        BARANGAY: 'LUBONG',
    },
    {
        CITY: 'SAN-VICENTE',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SAN-VICENTE',
        BARANGAY: 'PUDOC',
    },
    {
        CITY: 'SAN-VICENTE',
        BARANGAY: 'SAN SEBASTIAN',
    },
    {
        CITY: 'LIDLIDDA',
        BARANGAY: 'BANUCAL',
    },
    {
        CITY: 'LIDLIDDA',
        BARANGAY: 'BEQUI-WALIN',
    },
    {
        CITY: 'LIDLIDDA',
        BARANGAY: 'BUGUI',
    },
    {
        CITY: 'LIDLIDDA',
        BARANGAY: 'CALUNGBUYAN',
    },
    {
        CITY: 'LIDLIDDA',
        BARANGAY: 'CARCARABASA',
    },
    {
        CITY: 'LIDLIDDA',
        BARANGAY: 'LABUT',
    },
    {
        CITY: 'LIDLIDDA',
        BARANGAY: 'POBLACION NORTE',
    },
    {
        CITY: 'LIDLIDDA',
        BARANGAY: 'POBLACION SUR',
    },
    {
        CITY: 'LIDLIDDA',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'LIDLIDDA',
        BARANGAY: 'SUYSUYAN',
    },
    {
        CITY: 'LIDLIDDA',
        BARANGAY: 'TAY-AC',
    },
    {
        CITY: 'MAGSINGAL',
        BARANGAY: 'ALANGAN',
    },
    {
        CITY: 'MAGSINGAL',
        BARANGAY: 'BACAR',
    },
    {
        CITY: 'MAGSINGAL',
        BARANGAY: 'BARBARIT',
    },
    {
        CITY: 'MAGSINGAL',
        BARANGAY: 'BUNGRO',
    },
    {
        CITY: 'MAGSINGAL',
        BARANGAY: 'CABAROAN',
    },
    {
        CITY: 'MAGSINGAL',
        BARANGAY: 'CADANGLAAN',
    },
    {
        CITY: 'MAGSINGAL',
        BARANGAY: 'CARAISAN',
    },
    {
        CITY: 'MAGSINGAL',
        BARANGAY: 'DACUTAN',
    },
    {
        CITY: 'MAGSINGAL',
        BARANGAY: 'LABUT',
    },
    {
        CITY: 'MAGSINGAL',
        BARANGAY: 'MAAS-ASIN',
    },
    {
        CITY: 'MAGSINGAL',
        BARANGAY: 'MACATCATUD',
    },
    {
        CITY: 'MAGSINGAL',
        BARANGAY: 'MANZANTE',
    },
    {
        CITY: 'MAGSINGAL',
        BARANGAY: 'MARATUDO',
    },
    {
        CITY: 'MAGSINGAL',
        BARANGAY: 'MIRAMAR',
    },
    {
        CITY: 'MAGSINGAL',
        BARANGAY: 'NAMALPALAN',
    },
    {
        CITY: 'MAGSINGAL',
        BARANGAY: 'NAPO',
    },
    {
        CITY: 'MAGSINGAL',
        BARANGAY: 'PAGSANAAN NORTE',
    },
    {
        CITY: 'MAGSINGAL',
        BARANGAY: 'PAGSANAAN SUR',
    },
    {
        CITY: 'MAGSINGAL',
        BARANGAY: 'PANAY NORTE',
    },
    {
        CITY: 'MAGSINGAL',
        BARANGAY: 'PANAY SUR',
    },
    {
        CITY: 'MAGSINGAL',
        BARANGAY: 'PATONG',
    },
    {
        CITY: 'MAGSINGAL',
        BARANGAY: 'PURO',
    },
    {
        CITY: 'MAGSINGAL',
        BARANGAY: 'SAN BASILIO (POB.)',
    },
    {
        CITY: 'MAGSINGAL',
        BARANGAY: 'SAN CLEMENTE (POB.)',
    },
    {
        CITY: 'MAGSINGAL',
        BARANGAY: 'SAN JULIAN (POB.)',
    },
    {
        CITY: 'MAGSINGAL',
        BARANGAY: 'SAN LUCAS (POB.)',
    },
    {
        CITY: 'MAGSINGAL',
        BARANGAY: 'SAN RAMON (POB.)',
    },
    {
        CITY: 'MAGSINGAL',
        BARANGAY: 'SAN VICENTE (POB.)',
    },
    {
        CITY: 'MAGSINGAL',
        BARANGAY: 'SANTA MONICA',
    },
    {
        CITY: 'MAGSINGAL',
        BARANGAY: 'SARSARACAT',
    },
    {
        CITY: 'NAGBUKEL',
        BARANGAY: 'BALAWEG',
    },
    {
        CITY: 'NAGBUKEL',
        BARANGAY: 'BANDRIL',
    },
    {
        CITY: 'NAGBUKEL',
        BARANGAY: 'BANTUGO',
    },
    {
        CITY: 'NAGBUKEL',
        BARANGAY: 'CADACAD',
    },
    {
        CITY: 'NAGBUKEL',
        BARANGAY: 'CASILAGAN',
    },
    {
        CITY: 'NAGBUKEL',
        BARANGAY: 'CASOCOS',
    },
    {
        CITY: 'NAGBUKEL',
        BARANGAY: 'LAPTING',
    },
    {
        CITY: 'NAGBUKEL',
        BARANGAY: 'MAPISI',
    },
    {
        CITY: 'NAGBUKEL',
        BARANGAY: 'MISSION',
    },
    {
        CITY: 'NAGBUKEL',
        BARANGAY: 'POBLACION EAST',
    },
    {
        CITY: 'NAGBUKEL',
        BARANGAY: 'POBLACION WEST',
    },
    {
        CITY: 'NAGBUKEL',
        BARANGAY: 'TALEB',
    },
    {
        CITY: 'NARVACAN',
        BARANGAY: 'ABUOR',
    },
    {
        CITY: 'NARVACAN',
        BARANGAY: 'AMBULOGAN',
    },
    {
        CITY: 'NARVACAN',
        BARANGAY: 'AQUIB',
    },
    {
        CITY: 'NARVACAN',
        BARANGAY: 'BANGLAYAN',
    },
    {
        CITY: 'NARVACAN',
        BARANGAY: 'BANTAY ABOT',
    },
    {
        CITY: 'NARVACAN',
        BARANGAY: 'BULANOS',
    },
    {
        CITY: 'NARVACAN',
        BARANGAY: 'CADACAD',
    },
    {
        CITY: 'NARVACAN',
        BARANGAY: 'CAGAYUNGAN',
    },
    {
        CITY: 'NARVACAN',
        BARANGAY: 'CAMARAO',
    },
    {
        CITY: 'NARVACAN',
        BARANGAY: 'CASILAGAN',
    },
    {
        CITY: 'NARVACAN',
        BARANGAY: 'CODOOG',
    },
    {
        CITY: 'NARVACAN',
        BARANGAY: 'DASAY',
    },
    {
        CITY: 'NARVACAN',
        BARANGAY: 'DINALAOAN',
    },
    {
        CITY: 'NARVACAN',
        BARANGAY: 'ESTANCIA',
    },
    {
        CITY: 'NARVACAN',
        BARANGAY: 'LANIPAO',
    },
    {
        CITY: 'NARVACAN',
        BARANGAY: 'LUNGOG',
    },
    {
        CITY: 'NARVACAN',
        BARANGAY: 'MARGAAY',
    },
    {
        CITY: 'NARVACAN',
        BARANGAY: 'MAROZO',
    },
    {
        CITY: 'NARVACAN',
        BARANGAY: 'NAGUNEG',
    },
    {
        CITY: 'NARVACAN',
        BARANGAY: 'ORENCE',
    },
    {
        CITY: 'NARVACAN',
        BARANGAY: 'PANTOC',
    },
    {
        CITY: 'NARVACAN',
        BARANGAY: 'PARATONG',
    },
    {
        CITY: 'NARVACAN',
        BARANGAY: 'PARPARIA',
    },
    {
        CITY: 'NARVACAN',
        BARANGAY: 'QUINARAYAN',
    },
    {
        CITY: 'NARVACAN',
        BARANGAY: 'RIVADAVIA',
    },
    {
        CITY: 'NARVACAN',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'NARVACAN',
        BARANGAY: 'SAN JOSE (POB.)',
    },
    {
        CITY: 'NARVACAN',
        BARANGAY: 'SAN PABLO',
    },
    {
        CITY: 'NARVACAN',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'NARVACAN',
        BARANGAY: 'SANTA LUCIA (POB.)',
    },
    {
        CITY: 'NARVACAN',
        BARANGAY: 'SARMINGAN',
    },
    {
        CITY: 'NARVACAN',
        BARANGAY: 'SUCOC',
    },
    {
        CITY: 'NARVACAN',
        BARANGAY: 'SULVEC',
    },
    {
        CITY: 'NARVACAN',
        BARANGAY: 'TUROD',
    },
    {
        CITY: 'SAN-EMILIO',
        BARANGAY: 'CABAROAN (POB.)',
    },
    {
        CITY: 'SAN-EMILIO',
        BARANGAY: 'KALUMSING',
    },
    {
        CITY: 'SAN-EMILIO',
        BARANGAY: 'LANCUAS',
    },
    {
        CITY: 'SAN-EMILIO',
        BARANGAY: 'MATIBUEY',
    },
    {
        CITY: 'SAN-EMILIO',
        BARANGAY: 'PALTOC',
    },
    {
        CITY: 'SAN-EMILIO',
        BARANGAY: 'SAN MILIANO',
    },
    {
        CITY: 'SAN-EMILIO',
        BARANGAY: 'SIBSIBBU',
    },
    {
        CITY: 'SAN-EMILIO',
        BARANGAY: 'TIAGAN',
    },
    {
        CITY: 'SAN-ESTEBAN',
        BARANGAY: 'ANSAD',
    },
    {
        CITY: 'SAN-ESTEBAN',
        BARANGAY: 'APATOT',
    },
    {
        CITY: 'SAN-ESTEBAN',
        BARANGAY: 'BATERIA',
    },
    {
        CITY: 'SAN-ESTEBAN',
        BARANGAY: 'CABAROAN',
    },
    {
        CITY: 'SAN-ESTEBAN',
        BARANGAY: 'CAPPA-CAPPA',
    },
    {
        CITY: 'SAN-ESTEBAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SAN-ESTEBAN',
        BARANGAY: 'SAN NICOLAS',
    },
    {
        CITY: 'SAN-ESTEBAN',
        BARANGAY: 'SAN PABLO',
    },
    {
        CITY: 'SAN-ESTEBAN',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'SAN-ESTEBAN',
        BARANGAY: 'VILLA QUIRINO',
    },
    {
        CITY: 'SANTA',
        BARANGAY: 'AMPANDULA',
    },
    {
        CITY: 'SANTA',
        BARANGAY: 'BANAOANG',
    },
    {
        CITY: 'SANTA',
        BARANGAY: 'BASUG',
    },
    {
        CITY: 'SANTA',
        BARANGAY: 'BUCALAG',
    },
    {
        CITY: 'SANTA',
        BARANGAY: 'CABANGARAN',
    },
    {
        CITY: 'SANTA',
        BARANGAY: 'CALUNGBOYAN',
    },
    {
        CITY: 'SANTA',
        BARANGAY: 'CASIBER',
    },
    {
        CITY: 'SANTA',
        BARANGAY: 'DAMMAY',
    },
    {
        CITY: 'SANTA',
        BARANGAY: 'LABUT NORTE',
    },
    {
        CITY: 'SANTA',
        BARANGAY: 'LABUT SUR',
    },
    {
        CITY: 'SANTA',
        BARANGAY: 'MABILBILA NORTE',
    },
    {
        CITY: 'SANTA',
        BARANGAY: 'MABILBILA SUR',
    },
    {
        CITY: 'SANTA',
        BARANGAY: 'MAGSAYSAY DISTRICT (POB.)',
    },
    {
        CITY: 'SANTA',
        BARANGAY: 'MANUEVA',
    },
    {
        CITY: 'SANTA',
        BARANGAY: 'MARCOS (POB.)',
    },
    {
        CITY: 'SANTA',
        BARANGAY: 'NAGPANAOAN',
    },
    {
        CITY: 'SANTA',
        BARANGAY: 'NAMALANGAN',
    },
    {
        CITY: 'SANTA',
        BARANGAY: 'ORIBI',
    },
    {
        CITY: 'SANTA',
        BARANGAY: 'PASUNGOL',
    },
    {
        CITY: 'SANTA',
        BARANGAY: 'QUEZON (POB.)',
    },
    {
        CITY: 'SANTA',
        BARANGAY: 'QUIRINO (POB.)',
    },
    {
        CITY: 'SANTA',
        BARANGAY: 'RANCHO',
    },
    {
        CITY: 'SANTA',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'SANTA',
        BARANGAY: 'SACUYYA NORTE',
    },
    {
        CITY: 'SANTA',
        BARANGAY: 'SACUYYA SUR',
    },
    {
        CITY: 'SANTA',
        BARANGAY: 'TABUCOLAN',
    },
    {
        CITY: 'SANTA-LUCIA',
        BARANGAY: 'ALINCAOEG',
    },
    {
        CITY: 'SANTA-LUCIA',
        BARANGAY: 'ANGKILENG',
    },
    {
        CITY: 'SANTA-LUCIA',
        BARANGAY: 'ARANGIN',
    },
    {
        CITY: 'SANTA-LUCIA',
        BARANGAY: 'AYUSAN (POB.)',
    },
    {
        CITY: 'SANTA-LUCIA',
        BARANGAY: 'BANBANABA',
    },
    {
        CITY: 'SANTA-LUCIA',
        BARANGAY: 'BANI',
    },
    {
        CITY: 'SANTA-LUCIA',
        BARANGAY: 'BAO-AS',
    },
    {
        CITY: 'SANTA-LUCIA',
        BARANGAY: 'BARANGOBONG (POB.)',
    },
    {
        CITY: 'SANTA-LUCIA',
        BARANGAY: 'BULICLIC',
    },
    {
        CITY: 'SANTA-LUCIA',
        BARANGAY: 'BURGOS (POB.)',
    },
    {
        CITY: 'SANTA-LUCIA',
        BARANGAY: 'CABARITAN',
    },
    {
        CITY: 'SANTA-LUCIA',
        BARANGAY: 'CATAYAGAN',
    },
    {
        CITY: 'SANTA-LUCIA',
        BARANGAY: 'CONCONIG EAST',
    },
    {
        CITY: 'SANTA-LUCIA',
        BARANGAY: 'CONCONIG WEST',
    },
    {
        CITY: 'SANTA-LUCIA',
        BARANGAY: 'DAMACUAG',
    },
    {
        CITY: 'SANTA-LUCIA',
        BARANGAY: 'LUBA',
    },
    {
        CITY: 'SANTA-LUCIA',
        BARANGAY: 'LUBONG',
    },
    {
        CITY: 'SANTA-LUCIA',
        BARANGAY: 'NAGREBCAN',
    },
    {
        CITY: 'SANTA-LUCIA',
        BARANGAY: 'NAGTABLAAN',
    },
    {
        CITY: 'SANTA-LUCIA',
        BARANGAY: 'NAMATICAN',
    },
    {
        CITY: 'SANTA-LUCIA',
        BARANGAY: 'NANGALISAN',
    },
    {
        CITY: 'SANTA-LUCIA',
        BARANGAY: 'PALALI NORTE',
    },
    {
        CITY: 'SANTA-LUCIA',
        BARANGAY: 'PALALI SUR',
    },
    {
        CITY: 'SANTA-LUCIA',
        BARANGAY: 'PAOC NORTE',
    },
    {
        CITY: 'SANTA-LUCIA',
        BARANGAY: 'PAOC SUR',
    },
    {
        CITY: 'SANTA-LUCIA',
        BARANGAY: 'PARATONG',
    },
    {
        CITY: 'SANTA-LUCIA',
        BARANGAY: 'PILA EAST',
    },
    {
        CITY: 'SANTA-LUCIA',
        BARANGAY: 'PILA WEST',
    },
    {
        CITY: 'SANTA-LUCIA',
        BARANGAY: 'QUINABALAYANGAN',
    },
    {
        CITY: 'SANTA-LUCIA',
        BARANGAY: 'RONDA',
    },
    {
        CITY: 'SANTA-LUCIA',
        BARANGAY: 'SABUANAN',
    },
    {
        CITY: 'SANTA-LUCIA',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'SANTA-LUCIA',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'SANTA-LUCIA',
        BARANGAY: 'SAPANG',
    },
    {
        CITY: 'SANTA-LUCIA',
        BARANGAY: 'SUAGAYAN',
    },
    {
        CITY: 'SANTA-LUCIA',
        BARANGAY: 'VICAL',
    },
    {
        CITY: 'SIGAY',
        BARANGAY: 'ABACCAN',
    },
    {
        CITY: 'SIGAY',
        BARANGAY: 'MABILEG',
    },
    {
        CITY: 'SIGAY',
        BARANGAY: 'MATALLUCOD',
    },
    {
        CITY: 'SIGAY',
        BARANGAY: 'POBLACION (MADAYAW)',
    },
    {
        CITY: 'SIGAY',
        BARANGAY: 'SAN ELIAS',
    },
    {
        CITY: 'SIGAY',
        BARANGAY: 'SAN RAMON',
    },
    {
        CITY: 'SIGAY',
        BARANGAY: 'SANTO ROSARIO',
    },
    {
        CITY: 'SINAIT',
        BARANGAY: 'AGUING',
    },
    {
        CITY: 'SINAIT',
        BARANGAY: 'BALIW',
    },
    {
        CITY: 'SINAIT',
        BARANGAY: 'BALLAIGUI (POB.)',
    },
    {
        CITY: 'SINAIT',
        BARANGAY: 'BARACBAC',
    },
    {
        CITY: 'SINAIT',
        BARANGAY: 'BARIKIR',
    },
    {
        CITY: 'SINAIT',
        BARANGAY: 'BATTOG',
    },
    {
        CITY: 'SINAIT',
        BARANGAY: 'BINACUD',
    },
    {
        CITY: 'SINAIT',
        BARANGAY: 'CABANGTALAN',
    },
    {
        CITY: 'SINAIT',
        BARANGAY: 'CABARAMBANAN',
    },
    {
        CITY: 'SINAIT',
        BARANGAY: 'CABULALAAN',
    },
    {
        CITY: 'SINAIT',
        BARANGAY: 'CADANGLAAN',
    },
    {
        CITY: 'SINAIT',
        BARANGAY: 'CALANUTIAN',
    },
    {
        CITY: 'SINAIT',
        BARANGAY: 'CALINGAYAN',
    },
    {
        CITY: 'SINAIT',
        BARANGAY: 'CURTIN',
    },
    {
        CITY: 'SINAIT',
        BARANGAY: 'DADALAQUITEN NORTE',
    },
    {
        CITY: 'SINAIT',
        BARANGAY: 'DADALAQUITEN SUR',
    },
    {
        CITY: 'SINAIT',
        BARANGAY: 'DEAN LEOPOLDO YABES (PUG-OS)',
    },
    {
        CITY: 'SINAIT',
        BARANGAY: 'DUYAYYAT',
    },
    {
        CITY: 'SINAIT',
        BARANGAY: 'JORDAN',
    },
    {
        CITY: 'SINAIT',
        BARANGAY: 'KATIPUNAN',
    },
    {
        CITY: 'SINAIT',
        BARANGAY: 'MACABIAG (POB.)',
    },
    {
        CITY: 'SINAIT',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'SINAIT',
        BARANGAY: 'MARNAY',
    },
    {
        CITY: 'SINAIT',
        BARANGAY: 'MASADAG',
    },
    {
        CITY: 'SINAIT',
        BARANGAY: 'NAGBALIOARTIAN',
    },
    {
        CITY: 'SINAIT',
        BARANGAY: 'NAGCULLOOBAN',
    },
    {
        CITY: 'SINAIT',
        BARANGAY: 'NAGONGBURAN',
    },
    {
        CITY: 'SINAIT',
        BARANGAY: 'NAMNAMA (POB.)',
    },
    {
        CITY: 'SINAIT',
        BARANGAY: 'PACIS',
    },
    {
        CITY: 'SINAIT',
        BARANGAY: 'PARATONG',
    },
    {
        CITY: 'SINAIT',
        BARANGAY: 'PURAG',
    },
    {
        CITY: 'SINAIT',
        BARANGAY: 'QUIBIT-QUIBIT',
    },
    {
        CITY: 'SINAIT',
        BARANGAY: 'QUIMMALLOGONG',
    },
    {
        CITY: 'SINAIT',
        BARANGAY: 'RANG-AY (POB.)',
    },
    {
        CITY: 'SINAIT',
        BARANGAY: 'RICUDO',
    },
    {
        CITY: 'SINAIT',
        BARANGAY: 'SABANGAN (MARCOS)',
    },
    {
        CITY: 'SINAIT',
        BARANGAY: 'SALLACAPO',
    },
    {
        CITY: 'SINAIT',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'SINAIT',
        BARANGAY: 'SAPRIANA',
    },
    {
        CITY: 'SINAIT',
        BARANGAY: 'TAPAO',
    },
    {
        CITY: 'SINAIT',
        BARANGAY: 'TEPPENG',
    },
    {
        CITY: 'SINAIT',
        BARANGAY: 'TUBIGAY',
    },
    {
        CITY: 'SINAIT',
        BARANGAY: 'UBBOG',
    },
    {
        CITY: 'SINAIT',
        BARANGAY: 'ZAPAT',
    },
    {
        CITY: 'SUGPON',
        BARANGAY: 'BALBALAYANG (POB.)',
    },
    {
        CITY: 'SUGPON',
        BARANGAY: 'BANGA',
    },
    {
        CITY: 'SUGPON',
        BARANGAY: 'CAOAYAN',
    },
    {
        CITY: 'SUGPON',
        BARANGAY: 'DANAC',
    },
    {
        CITY: 'SUGPON',
        BARANGAY: 'LICUNGAN (CULLANG)',
    },
    {
        CITY: 'SUGPON',
        BARANGAY: 'PANGOTAN',
    },
    {
        CITY: 'SUYO',
        BARANGAY: 'BARINGCUCURONG',
    },
    {
        CITY: 'SUYO',
        BARANGAY: 'CABUGAO',
    },
    {
        CITY: 'SUYO',
        BARANGAY: 'CABUGAO',
    },
    {
        CITY: 'SUYO',
        BARANGAY: 'MAN-ATONG',
    },
    {
        CITY: 'SUYO',
        BARANGAY: 'PATOC-AO',
    },
    {
        CITY: 'SUYO',
        BARANGAY: 'POBLACION (KIMPUSA)',
    },
    {
        CITY: 'SUYO',
        BARANGAY: 'SUYO PROPER',
    },
    {
        CITY: 'SUYO',
        BARANGAY: 'URZADAN',
    },
    {
        CITY: 'SUYO',
        BARANGAY: 'USO',
    },
    {
        CITY: 'TAGUDIN',
        BARANGAY: 'AG-AGUMAN',
    },
    {
        CITY: 'TAGUDIN',
        BARANGAY: 'AMBALAYAT',
    },
    {
        CITY: 'TAGUDIN',
        BARANGAY: 'BARACBAC',
    },
    {
        CITY: 'TAGUDIN',
        BARANGAY: 'BARIO-AN',
    },
    {
        CITY: 'TAGUDIN',
        BARANGAY: 'BARITAO',
    },
    {
        CITY: 'TAGUDIN',
        BARANGAY: 'BECQUES',
    },
    {
        CITY: 'TAGUDIN',
        BARANGAY: 'BIMMANGA',
    },
    {
        CITY: 'TAGUDIN',
        BARANGAY: 'BIO',
    },
    {
        CITY: 'TAGUDIN',
        BARANGAY: 'BITALAG',
    },
    {
        CITY: 'TAGUDIN',
        BARANGAY: 'BORONO',
    },
    {
        CITY: 'TAGUDIN',
        BARANGAY: 'BUCAO EAST',
    },
    {
        CITY: 'TAGUDIN',
        BARANGAY: 'BUCAO WEST',
    },
    {
        CITY: 'TAGUDIN',
        BARANGAY: 'CABAROAN',
    },
    {
        CITY: 'TAGUDIN',
        BARANGAY: 'CABUGBUGAN',
    },
    {
        CITY: 'TAGUDIN',
        BARANGAY: 'CABULANGLANGAN',
    },
    {
        CITY: 'TAGUDIN',
        BARANGAY: 'DACUTAN',
    },
    {
        CITY: 'TAGUDIN',
        BARANGAY: 'DARDARAT',
    },
    {
        CITY: 'TAGUDIN',
        BARANGAY: 'DEL PILAR (POB.)',
    },
    {
        CITY: 'TAGUDIN',
        BARANGAY: 'FAROLA',
    },
    {
        CITY: 'TAGUDIN',
        BARANGAY: 'GABUR',
    },
    {
        CITY: 'TAGUDIN',
        BARANGAY: 'GARITAN',
    },
    {
        CITY: 'TAGUDIN',
        BARANGAY: 'JARDIN',
    },
    {
        CITY: 'TAGUDIN',
        BARANGAY: 'LACONG',
    },
    {
        CITY: 'TAGUDIN',
        BARANGAY: 'LANTAG',
    },
    {
        CITY: 'TAGUDIN',
        BARANGAY: 'LAS-UD',
    },
    {
        CITY: 'TAGUDIN',
        BARANGAY: 'LIBTONG',
    },
    {
        CITY: 'TAGUDIN',
        BARANGAY: 'LUBNAC',
    },
    {
        CITY: 'TAGUDIN',
        BARANGAY: 'MAGSAYSAY (POB.)',
    },
    {
        CITY: 'TAGUDIN',
        BARANGAY: 'MALACANANG',
    },
    {
        CITY: 'TAGUDIN',
        BARANGAY: 'PACAC',
    },
    {
        CITY: 'TAGUDIN',
        BARANGAY: 'PALLOGAN',
    },
    {
        CITY: 'TAGUDIN',
        BARANGAY: 'PUDOC EAST',
    },
    {
        CITY: 'TAGUDIN',
        BARANGAY: 'PUDOC WEST',
    },
    {
        CITY: 'TAGUDIN',
        BARANGAY: 'PULA',
    },
    {
        CITY: 'TAGUDIN',
        BARANGAY: 'QUIRINO (POB.)',
    },
    {
        CITY: 'TAGUDIN',
        BARANGAY: 'RANGET',
    },
    {
        CITY: 'TAGUDIN',
        BARANGAY: 'RIZAL (POB.)',
    },
    {
        CITY: 'TAGUDIN',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'TAGUDIN',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'TAGUDIN',
        BARANGAY: 'SAWAT',
    },
    {
        CITY: 'TAGUDIN',
        BARANGAY: 'TALLAOEN',
    },
    {
        CITY: 'TAGUDIN',
        BARANGAY: 'TAMPUGO',
    },
    {
        CITY: 'TAGUDIN',
        BARANGAY: 'TARANGOTONG',
    },
    {
        CITY: 'VIGAN',
        BARANGAY: 'AYUSAN NORTE',
    },
    {
        CITY: 'VIGAN',
        BARANGAY: 'AYUSAN SUR',
    },
    {
        CITY: 'VIGAN',
        BARANGAY: 'BARANGAY I (POB.)',
    },
    {
        CITY: 'VIGAN',
        BARANGAY: 'BARANGAY II (POB.)',
    },
    {
        CITY: 'VIGAN',
        BARANGAY: 'BARANGAY III (POB.)',
    },
    {
        CITY: 'VIGAN',
        BARANGAY: 'BARANGAY IV (POB.)',
    },
    {
        CITY: 'VIGAN',
        BARANGAY: 'BARANGAY IX',
    },
    {
        CITY: 'VIGAN',
        BARANGAY: 'BARANGAY V (POB.)',
    },
    {
        CITY: 'VIGAN',
        BARANGAY: 'BARANGAY VI (POB.)',
    },
    {
        CITY: 'VIGAN',
        BARANGAY: 'BARANGAY VII',
    },
    {
        CITY: 'VIGAN',
        BARANGAY: 'BARANGAY VIII',
    },
    {
        CITY: 'VIGAN',
        BARANGAY: 'BARRACA',
    },
    {
        CITY: 'VIGAN',
        BARANGAY: 'BEDDENG DAYA',
    },
    {
        CITY: 'VIGAN',
        BARANGAY: 'BEDDENG LAUD',
    },
    {
        CITY: 'VIGAN',
        BARANGAY: 'BONGTOLAN',
    },
    {
        CITY: 'VIGAN',
        BARANGAY: 'BULALA',
    },
    {
        CITY: 'VIGAN',
        BARANGAY: 'CABALANGEGAN',
    },
    {
        CITY: 'VIGAN',
        BARANGAY: 'CABAROAN DAYA',
    },
    {
        CITY: 'VIGAN',
        BARANGAY: 'CABAROAN LAUD',
    },
    {
        CITY: 'VIGAN',
        BARANGAY: 'CAMANGAAN',
    },
    {
        CITY: 'VIGAN',
        BARANGAY: 'CAPANGPANGAN',
    },
    {
        CITY: 'VIGAN',
        BARANGAY: 'MINDORO',
    },
    {
        CITY: 'VIGAN',
        BARANGAY: 'NAGSANGALAN',
    },
    {
        CITY: 'VIGAN',
        BARANGAY: 'PANTAY DAYA',
    },
    {
        CITY: 'VIGAN',
        BARANGAY: 'PANTAY FATIMA',
    },
    {
        CITY: 'VIGAN',
        BARANGAY: 'PANTAY LAUD',
    },
    {
        CITY: 'VIGAN',
        BARANGAY: 'PAOA',
    },
    {
        CITY: 'VIGAN',
        BARANGAY: 'PARATONG',
    },
    {
        CITY: 'VIGAN',
        BARANGAY: 'PONG-OL',
    },
    {
        CITY: 'VIGAN',
        BARANGAY: 'PUROK-A-BASSIT',
    },
    {
        CITY: 'VIGAN',
        BARANGAY: 'PUROK-A-DACKEL',
    },
    {
        CITY: 'VIGAN',
        BARANGAY: 'RAOIS',
    },
    {
        CITY: 'VIGAN',
        BARANGAY: 'RUGSUANAN',
    },
    {
        CITY: 'VIGAN',
        BARANGAY: 'SALINDEG',
    },
    {
        CITY: 'VIGAN',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'VIGAN',
        BARANGAY: 'SAN JULIAN NORTE',
    },
    {
        CITY: 'VIGAN',
        BARANGAY: 'SAN JULIAN SUR',
    },
    {
        CITY: 'VIGAN',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'VIGAN',
        BARANGAY: 'TAMAG',
    }
];
